export const translations = {
  en: {
    // MVP Banner
    'mvpBanner.message':
      'clevia is an evolving MVP — new features are added regularly. Thank you for being part of the journey.',

    // Navigation
    'nav.login': 'Login',
    'nav.register': 'Sign up',
    'nav.logout': 'Logout',

    // Home Page
    'home.tagline': 'Your all-in-one wealth manager',
    'home.hero.title1': 'Your financial life,',
    'home.hero.title2': 'finally clear.',
    'home.hero.description':
      'All the essential features to manage your money simply, without unnecessary complexity.',
    'home.cta.start': 'Start for free',
    'home.cta.demo': 'Meet the founders',
    'home.trust.encrypted': 'No commitment',
    'home.trust.free': 'Set up in 2 minutes',
    'home.trust.rating': '5.0 from 2000+ users',
    'home.trust.eu': 'Data hosted in the EU',
    'home.banks.eyebrow': 'Track accounts from the banks you already use',
    'home.mock.tab.overview': 'Overview',
    'home.mock.tab.assets': 'Assets',
    'home.mock.tab.budget': 'Budget',
    'home.mock.totalWealth': 'Total wealth',
    'home.mock.thisMonth': 'this month',
    'home.mock.monthlyBudget': 'Monthly budget',
    'home.mock.asset.bank': 'Bank accounts',
    'home.mock.asset.savings': 'Savings account',
    'home.mock.asset.crypto': 'Crypto',
    'home.mock.asset.stocks': 'Stocks & PEA',
    'home.mock.asset.realEstate': 'Real estate',
    'home.mock.budget.food': 'Food & Groceries',
    'home.mock.budget.transport': 'Transport',
    'home.mock.budget.shopping': 'Shopping',
    'home.mock.budget.leisure': 'Leisure',
    'home.mock.notification.today': 'Today',
    'home.mock.notification.goal': 'Vacances Maroc',
    'home.mock.notification.reached': 'reached',
    'home.mock.caption':
      'A preview of the clevia dashboard. Sample data, shown for illustration purposes.',
    'home.mock.overBudget': 'Over budget by',

    'home.whatIs.title': 'What is clevia?',
    'home.whatIs.intro':
      'clevia is a simple app to see and understand your money, without stress or complication.',
    'home.whatIs.block1.title': 'Your wealth, centralized',
    'home.whatIs.block1.desc':
      'Your accounts, savings, investments and even valuable items appear in a single clear view. You see how much you have in total and how your money evolves.',
    'home.whatIs.block2.title': 'Your daily budget',
    'home.whatIs.block2.desc':
      "You track your income, expenses and what's left in real-time. You know exactly where your money goes and you can adjust simply.",
    'home.story.1.b1': 'Every account gathered in a single view',
    'home.story.1.b2': 'Your total net worth, always up to date',
    'home.story.1.b3': 'Crypto, stocks and real estate included',
    'home.story.2.b1': 'Your spending sorted by category',
    'home.story.2.b2': 'A clear alert as soon as a budget is exceeded',
    'home.story.2.b3': 'What you have left to spend, in real time',
    'home.story.3.b1': 'One goal per project, at your own pace',
    'home.story.3.b2': 'Progress you can read at a glance',
    'home.story.3.b3': 'Deposits you adjust whenever you want',
    'home.whatIs.block4.title': 'Your categories, your way',
    'home.whatIs.block4.desc':
      'Nobody spends like anyone else. Create, rename and reorganise your categories so your budget speaks your language.',
    'home.story.4.b1': 'Create your own categories in one click',
    'home.story.4.b2': 'Rename or merge the default ones',
    'home.story.4.b3': 'A monthly budget per category, if you want one',
    'home.story.4.visualLabel': 'Your categories',
    'home.story.4.custom': 'Family in Morocco',
    'home.story.4.badge': 'Custom',
    'home.story.4.add': 'Add a category',
    'home.whatIs.bank': 'Bank accounts',
    'home.whatIs.savings': 'Savings accounts',
    'home.whatIs.realEstate': 'Real estate',
    'home.whatIs.crypto': 'Crypto',
    'home.whatIs.stocks': 'Stocks & PEA',
    'home.whatIs.watches': 'Watches & Jewelry',
    'home.whatIs.metals': 'Precious metals',

    'home.whyDifferent.title': 'Why clevia is different?',
    'home.whyDifferent.subtitle':
      'Built by Mehdi & Marouane who wanted a simple, clear financial app.',
    'home.whyDifferent.1.title': 'Founded by two people',
    'home.whyDifferent.1.desc': 'Not a big corporation. Accessible, human, close to our users.',
    'home.whyDifferent.2.title': 'Independent',
    'home.whyDifferent.2.desc': 'Bootstrapped. No investors telling us what features to build.',
    'home.whyDifferent.3.title': 'Simplicity first',
    'home.whyDifferent.3.desc': 'No financial jargon. No useless features.',
    'home.whyDifferent.4.title': 'Built with users',
    'home.whyDifferent.4.desc': 'User feedback directly shapes improvements.',
    'home.whyDifferent.cta': 'Meet the founders',

    'home.assets.title': 'Track every type of asset',
    'home.assets.subtitle':
      'From your bank account to your watch collection — clevia centralizes all your wealth in one place.',
    'home.assets.bank': 'Bank accounts',
    'home.assets.crypto': 'Crypto',
    'home.assets.pea': 'Stocks & PEA',
    'home.assets.realEstate': 'Real estate',
    'home.assets.watches': 'Watches & Jewelry',
    'home.assets.metals': 'Precious metals',
    'home.stats.assetTypes': 'Asset types tracked',
    'home.stats.features': 'Built-in features',
    'home.stats.freeForever': 'Free forever',
    'home.section.patrimoine': 'Wealth',
    'home.section.different': 'Unique',
    'home.section.features': 'Features',
    'home.section.guide': 'Guide',
    'home.section.faq': 'FAQ',
    'home.features.title': 'Built for real people',
    'home.features.subtitle':
      'Not another spreadsheet. clevia gives you the tools to actually understand and grow your money.',
    'home.feature.tracking.title': 'Wealth overview',
    'home.feature.tracking.desc':
      'See all your assets in one dashboard. Bank balances, crypto prices, stock values, real estate estimates - always up to date.',
    'home.feature.security.title': 'Bank-grade security',
    'home.feature.security.desc':
      'Your data is encrypted end-to-end with Supabase infrastructure. We never store your banking credentials.',
    'home.feature.ai.title': 'AI assistant',
    'home.feature.ai.desc':
      'Ask questions about your finances in natural language. Get insights, summaries, and smart suggestions powered by AI.',
    'home.feature.goals.title': 'Savings goals',
    'home.feature.goals.desc':
      'Set goals for vacation, emergency fund, or your next investment. Track progress visually and stay motivated.',
    'home.feature.multi.title': 'Multi-currency',
    'home.feature.multi.desc':
      'Track assets in EUR, USD, MAD, and CAD. clevia adapts to your financial reality wherever you are.',
    'home.feature.responsive.title': 'Use anywhere',
    'home.feature.responsive.desc':
      'Works beautifully on desktop, tablet, and mobile. Your finances travel with you, always accessible.',
    'home.howItWorks.title': 'Ready in minutes',
    'home.howItWorks.subtitle': 'No complicated setup. Sign up and start right away.',
    'home.steps.1.title': 'Create your free account',
    'home.steps.1.desc': 'Sign up with your email. No credit card. No commitment.',
    'home.steps.2.title': 'Add what you own',
    'home.steps.2.desc': 'Your bank accounts, your savings, your projects. All in one place.',
    'home.steps.3.title': 'Track your money simply',
    'home.steps.3.desc': 'See how much you have, what you spend and move toward your goals.',
    'home.faq.title': 'Frequently asked questions',
    'home.faq.subtitle': 'Everything you need to know about clevia',
    'home.faq.1.q': 'Is clevia really free?',
    'home.faq.1.a':
      "Yes, you can use clevia's essential features for free. And if you'd like to go further, a Premium plan gives you access to additional features.",
    'home.faq.2.q': 'Do I need to connect my bank account?',
    'home.faq.2.a':
      'No. clevia works with manual entry, which gives you full control over your data. You add your accounts and transactions yourself. For crypto and stocks, we fetch live market prices automatically.',
    'home.faq.3.q': 'Is my data secure?',
    'home.faq.3.a':
      'Yes. Your data is protected and hosted within the European Union, as stated in our legal notices. Each user can only access their own data, and we never store your banking credentials.',
    'home.faq.4.q': 'What asset types can I track?',
    'home.faq.4.a':
      'Bank accounts, savings, crypto (with live CoinGecko prices), PEA/stocks (CAC 40, ETFs with live Yahoo Finance data), real estate, watches & jewelry, precious metals, and more coming soon.',
    'home.faq.5.q': 'Can I use clevia in multiple languages?',
    'home.faq.5.a':
      'Yes! clevia is fully available in French and English. You can change the language at any time from the settings or directly from the home page. If you would like other languages, contact the founders. We will add them gradually as clevia grows.',
    'home.faq.6.q': 'Can I exchange with the founders of clevia?',
    'home.faq.6.a':
      'Yes. If you have a question, suggestion or just want to chat, you can write to us directly at founders@cleviaapp.com. We read every message and we love talking with people who use clevia.',
    'home.cta.final.title': 'Your new financial life starts now.',
    'home.cta.final.subtitle':
      'Manage your budget today. Build your wealth tomorrow. Free, simple, no commitment.',
    'home.cta.final.button': 'Create my free account',
    'home.cta.final.noCreditCard': '',
    'home.footer.rights': '© 2026 clevia. All rights reserved.',

    // Founders Page
    'founders.title': 'Our Founders',
    'founders.subtitle': 'Content coming soon...',

    // Landing Header Navigation
    'header.features': 'Features',
    'header.resources': 'Resources',
    'header.solutions': 'Solutions',
    'header.company': 'About Us',
    'header.pricing': 'Pricing',

    // Features Menu
    'header.features.daily': 'Daily Management',
    'header.features.budget.title': 'Smart Budgeting',
    'header.features.budget.desc': 'Track income, expenses and remaining balance in real-time',
    'header.features.transactions.title': 'Simplified Transactions',
    'header.features.transactions.desc': 'Add, filter and analyze your operations easily',
    'header.features.rules.title': 'Automatic Rules',
    'header.features.rules.desc': 'Smart categorization and automation',
    'header.features.calendar.title': 'Recurring Calendar',
    'header.features.calendar.desc': 'Visualize subscriptions and future payments',
    'header.features.multiCurrency.title': 'Multi-Currency Accounts',
    'header.features.multiCurrency.desc': 'Manage MAD, EUR, USD, CAD without confusion',

    'header.features.vision': 'Global Vision',
    'header.features.wealth.title': 'Total Wealth Consolidated',
    'header.features.wealth.desc': 'Unified view of all your accounts',
    'header.features.conversion.title': 'Live Multi-Currency Conversion',
    'header.features.conversion.desc': 'Wealth automatically recalculated',
    'header.features.cashflow.title': 'Cash Flow Analysis',
    'header.features.cashflow.desc': 'Income vs expenses visualized over 6 months',
    'header.features.topspending.title': 'Top Spending & Income',
    'header.features.topspending.desc': 'Identify your key categories instantly',
    'header.features.analysis.title': 'Intelligent Monthly Analysis',
    'header.features.analysis.desc': 'Evolution in € and % vs previous period',

    'header.features.strategy': 'Objectives & Strategy',
    'header.features.goals.title': 'Smart Savings Goals',
    'header.features.goals.desc': 'Track + predict goal achievement',
    'header.features.allocation.title': 'Virtual Allocation',
    'header.features.allocation.desc': 'Allocate your money without locking it',
    'header.features.debts.title': 'Debt Management',
    'header.features.debts.desc': 'Plan and optimize your repayments',
    'header.features.method.title': '50/30/20 Method',
    'header.features.method.desc': 'Structure your finances simply',
    'header.features.ai.title': 'AI Assistant',
    'header.features.ai.desc': 'Automatic insights based on your data',

    'header.resources.learn': 'Learn',
    'header.resources.guide.title': 'Getting Started Guide',
    'header.resources.guide.desc': 'Quick onboarding',
    'header.resources.method.title': '50/30/20 Method',
    'header.resources.method.desc': 'Learn the proven method',
    'header.resources.blog.title': 'clevia Blog',
    'header.resources.blog.desc': 'Tips and financial advice',

    // Blog Page
    'blog.empty': 'No articles available at the moment.',

    'header.resources.support': 'Help & Security',
    'header.resources.help.title': 'Help Center',
    'header.resources.help.desc': 'FAQs and support',
    'help.title': 'Need help with clevia?',
    'help.tutorial':
      "A getting-started tutorial is available as soon as you create your account to guide you through clevia's main features.",
    'help.dashboard': 'This tutorial remains available afterwards from your Dashboard.',
    'help.contact': 'Need additional help? Mehdi & Marouane remain available directly by email.',
    'help.contactButton': 'Contact us',
    'header.resources.security.title': 'Security & Privacy',
    'header.resources.security.desc': 'Learn about data protection',
    'header.resources.notifications.title': 'Notifications & Alerts',
    'header.resources.notifications.desc': 'Stay updated on your finances',
    'header.resources.faq.title': 'FAQ',
    'header.resources.faq.desc': 'Common questions answered',
    'header.resources.contact.title': 'Contact Support',
    'support.contactSupport': 'Contact support',
    'support.contactOrSuggest': 'Help & Support',
    'support.suggestIdea': 'Suggest an idea',
    'feedback.title': 'Help & Support',
    'feedback.description': 'Tell us what you need and help us make clevia better.',
    'feedback.tabs.support': 'Support',
    'feedback.tabs.idea': 'Feature idea',
    'feedback.helper.support': "Describe your issue and we'll get back to you.",
    'feedback.helper.idea': 'Share an idea that could make your daily life with clevia better.',
    'feedback.subject': 'Subject',
    'feedback.subjectPlaceholder.support': 'e.g. Issue with an account',
    'feedback.subjectPlaceholder.idea': 'e.g. Add a monthly comparison',
    'feedback.message': 'Message',
    'feedback.messagePlaceholder.support': 'Describe your issue in detail...',
    'feedback.messagePlaceholder.idea': 'Tell us how this feature would help you...',
    'feedback.addAttachment': 'Add an attachment',
    'feedback.removeAttachment': 'Remove attachment',
    'feedback.attachmentTooLarge': 'File is too large (max 5 MB).',
    'feedback.cancel': 'Cancel',
    'feedback.sending': 'Sending...',
    'feedback.submit.support': 'Send message',
    'feedback.submit.idea': 'Send idea',
    'feedback.successTitle': 'Thanks for your message!',
    'feedback.successDescription': 'Your feedback has been sent to the clevia team.',
    'feedback.close': 'Close',
    'header.resources.contact.desc': 'Get help from our team',

    'header.solutions.particulars': 'For Individuals',
    'header.solutions.students.title': 'For Students',
    'header.solutions.students.desc': 'Manage your student budget',
    'header.solutions.young.title': 'Young Professionals',
    'header.solutions.young.desc': 'Start building wealth early',
    'header.solutions.couples.title': 'Couples',
    'header.solutions.couples.desc': 'Manage shared finances',
    'header.solutions.mre.title': 'Residents Abroad',
    'header.solutions.mre.desc': 'Centralize your finances across two countries',

    'header.solutions.professionals': 'For Professionals',
    'header.solutions.freelancers.title': 'Freelancers',
    'header.solutions.freelancers.desc': 'Track variable income',
    'header.solutions.consultants.title': 'Consultants',
    'header.solutions.consultants.desc': 'Manage client projects',
    'header.solutions.creators.title': 'Content Creators',
    'header.solutions.creators.desc': 'Monetize your content',
    'header.solutions.coaches.title': 'Financial Coaches',
    'header.solutions.coaches.desc': 'Help your clients grow',

    'header.company.transparency': 'Transparency',
    'header.company.founders.title': 'Founders',
    'header.company.founders.desc': 'Mehdi & Marouane',
    'header.company.mission.title': 'Our Mission',
    'header.company.mission.desc': 'Making finance simple for everyone',
    'header.company.vision.title': 'Our Vision',
    'header.company.vision.desc': 'Democratize wealth management',
    'header.company.careers.title': 'Careers',
    'header.company.careers.desc': 'Join our team',
    'header.company.press.title': 'Partnerships & Press',
    'header.company.press.desc': 'Media and news',
    'header.company.blog.title': 'Blog',
    'header.company.blog.desc': 'Articles and stories',
    'header.company.legal.title': 'Legal',
    'header.company.legal.desc': 'Terms and conditions',
    'header.company.privacy.title': 'Privacy Policy',
    'header.company.privacy.desc': 'Your data protection',
    'header.company.contact.title': 'Contact Us',
    'header.company.contact.desc': 'Get in touch',

    // Auth Pages
    'auth.login.title': 'Login to your account',
    'auth.login.subtitle': 'Welcome back! Please enter your credentials',
    'auth.login.email': 'Email',
    'auth.login.password': 'Password',
    'auth.login.forgotPassword': 'Forgot password?',
    'auth.login.rememberMe': 'Stay logged in for 30 days',
    'auth.login.submit': 'Login',
    'auth.login.loading': 'Logging in...',
    'auth.login.noAccount': "Don't have an account?",
    'auth.login.signup': 'Sign up',
    'auth.login.security': '🔒 Secure connection',
    'auth.register.title': 'Create an account',
    'auth.register.subtitle': 'Get started for free in 2 minutes',
    'auth.register.name': 'Full name',
    'auth.register.email': 'Email',
    'auth.register.password': 'Password',
    'auth.register.confirmPassword': 'Confirm password',
    'auth.register.submit': 'Create my account',
    'auth.register.loading': 'Creating account...',
    'auth.register.hasAccount': 'Already have an account?',
    'auth.register.login': 'Login',
    'auth.register.benefit1': 'Real-time financial tracking',
    'auth.register.benefit2': 'Dashboards and BI analytics',
    'auth.register.benefit3': 'Enterprise-grade security',
    'auth.register.benefit4': 'Free forever',
    'auth.register.hero.title': 'Take control of your finances',
    'auth.register.hero.subtitle':
      'Join over 150,000 users who have transformed their financial life',
    'auth.backHome': 'Back to home',

    // Forgot Password
    'forgotPassword.title': 'Forgot password',
    'forgotPassword.subtitle': 'Enter your email to receive a reset link',
    'forgotPassword.email': 'Email address',
    'forgotPassword.emailPlaceholder': 'name@example.com',
    'forgotPassword.submit': 'Send reset link',
    'forgotPassword.loading': 'Sending...',
    'forgotPassword.backToLogin': 'Back to login',
    'forgotPassword.success.title': 'Email sent!',
    'forgotPassword.success.message': 'We sent an email to',
    'forgotPassword.success.instruction': 'Click the link in the email to reset your password.',
    'forgotPassword.help': 'Remember your password?',
    'forgotPassword.login': 'Sign in',
    'forgotPassword.toast.success': 'Email sent',
    'forgotPassword.toast.successDesc': 'Check your mailbox to reset your password',
    'forgotPassword.toast.error': 'Error',
    'forgotPassword.toast.errorDesc': 'An error occurred',

    // Reset Password
    'resetPassword.title': 'New password',
    'resetPassword.subtitle': 'Choose a new secure password',
    'resetPassword.newPassword': 'New password',
    'resetPassword.confirmPassword': 'Confirm password',
    'resetPassword.submit': 'Reset password',
    'resetPassword.loading': 'Updating...',
    'resetPassword.success.title': 'Password updated!',
    'resetPassword.success.message': 'Your password has been successfully reset.',
    'resetPassword.success.redirect': 'Redirecting to login page...',
    'resetPassword.error.invalidLink': 'Invalid or expired link',
    'resetPassword.error.requestNew': 'Please request a new reset link',
    'resetPassword.verifying': 'Verifying link...',
    'resetPassword.toast.success': 'Password updated',
    'resetPassword.toast.successDesc': 'Your password has been successfully reset',
    'resetPassword.validation.passwordMin': 'Password must be at least 6 characters',
    'resetPassword.validation.passwordMatch': 'Passwords do not match',

    // Dashboard
    'dashboard.welcome': 'Welcome back',
    'dashboard.customize': 'Customize',
    'dashboard.greeting': 'Hello',
    'dashboard.subtitle': "Here's an overview of your finances today",
    'dashboard.nav.dashboard': 'Dashboard',
    'dashboard.nav.transactions': 'Transactions',
    'dashboard.nav.budgets': 'Budgets',
    'dashboard.nav.categories': 'Categories',
    'dashboard.nav.planning': 'Planning',
    'dashboard.nav.settings': 'Settings',
    'dashboard.nav.logout': 'Logout',
    'sidebar.hideAmounts': 'Hide amounts',
    'sidebar.showAmounts': 'Show amounts',
    'sidebar.collapse': 'Collapse sidebar',
    'sidebar.expand': 'Expand sidebar',
    'dashboard.stats.totalBudget': 'Total Budget',
    'dashboard.stats.expenses': 'Expenses',
    'dashboard.stats.income': 'Income',
    'dashboard.stats.savings': 'Savings',
    'dashboard.stats.thisMonth': 'This month',
    'dashboard.budget.title': 'Budget',
    'dashboard.budget.expenses': 'Expenses',
    'dashboard.budget.income': 'Income',
    'dashboard.budget.fixed': 'Fixed',
    'dashboard.budget.flexible': 'Flexible',
    'dashboard.budget.nonMonthly': 'Non-Monthly',
    'dashboard.budget.spent': 'spent',
    'dashboard.budget.remaining': 'remaining',
    'dashboard.netWorth.title': 'net worth',
    'dashboard.netWorth.days7': '7 days',
    'dashboard.netWorth.days30': '30 days',
    'dashboard.netWorth.days90': '90 days',
    'dashboard.netWorth.overPeriod': 'Over',
    'dashboard.spending.title': 'Spending',
    'dashboard.spending.other': 'Other',
    'dashboard.spending.top5': 'Top 5 expenses',
    'dashboard.spending.thisMonth': 'this month',
    'dashboard.spending.lastMonth': 'Last month',
    'dashboard.goals.title': 'Goals',
    'dashboard.goals.subtitle': 'Your top 3 priorities',
    'dashboard.goals.empty': 'No goals set yet',
    'dashboard.goals.add': 'Add goal',
    'dashboard.transactions.title': 'Transactions',
    'dashboard.transactions.recent': 'Most recent',
    'dashboard.transactions.all': 'All transactions',
    'dashboard.transactions.empty': 'No transactions yet',
    'dashboard.transactions.add': 'Add transaction',
    'dashboard.transactions.today': 'Today',
    'dashboard.transactions.yesterday': 'Yesterday',
    'dashboard.recurring.title': 'Recurring',
    'dashboard.recurring.due': 'remaining due',
    'dashboard.recurring.thisMonth': 'This month',
    'dashboard.recurring.empty': 'No upcoming transactions for this time period',
    'dashboard.recurring.emptyDesc': 'Add new recurring transactions to see them here',
    'dashboard.recurring.add': 'Add recurring',
    'dashboard.recurring.addButton': 'Add',
    'dashboard.recurring.next7Days': 'Next 7 days',
    'dashboard.recurring.later': 'Later',
    'dashboard.recurring.total30Days': 'Total over 30 days',
    'dashboard.recurring.expenses': 'Expenses:',
    'dashboard.recurring.income': 'Income:',
    'dashboard.recurring.viewCalendar': 'View full calendar',
    'dashboard.recurring.today': 'Today',
    'dashboard.recurring.tomorrow': 'Tomorrow',

    // Recurring Modal
    'recurring.create': 'New Recurring Transaction',
    'recurring.edit': 'Edit Recurring Transaction',
    'recurring.expense': 'Expense',
    'recurring.income': 'Income',
    'recurring.description': 'Description',
    'recurring.descriptionPlaceholder': 'Netflix, Rent, Salary...',
    'recurring.amount': 'Amount',
    'recurring.frequency': 'Frequency',
    'recurring.frequency.daily': 'Daily',
    'recurring.frequency.weekly': 'Weekly',
    'recurring.frequency.monthly': 'Monthly',
    'recurring.frequency.yearly': 'Yearly',
    'recurring.startDate': 'Start date',
    'recurring.endDate': 'End date',
    'recurring.optional': 'optional',
    'recurring.category': 'Category',
    'recurring.selectCategory': 'Select category',
    'recurring.account': 'Account',
    'recurring.selectAccount': 'Select account',
    'recurring.cancel': 'Cancel',
    'recurring.save': 'Save',
    'recurring.saving': 'Saving...',
    'recurring.delete': 'Delete',
    'recurring.deleteConfirm': 'Are you sure you want to delete this recurring transaction?',
    'recurring.pause': 'Pause',
    'recurring.resume': 'Resume',
    'recurring.nextOccurrence': 'Next occurrence',

    'dashboard.accounts': 'accounts',
    'dashboard.noData': 'No data available yet',
    'dashboard.noExpenses': 'No expenses this month',
    'dashboard.cashFlow.title': 'Cash Flow',
    'dashboard.cashFlow.subtitle': 'Income vs expenses over the last 6 months',
    'dashboard.quickActions.title': 'Quick actions',
    'dashboard.quickActions.subtitle': 'Get things done faster',
    'dashboard.quickActions.addTransaction': 'Add Transaction',
    'dashboard.quickActions.viewAccounts': 'View Accounts',
    'dashboard.quickActions.viewGoals': 'View Goals',
    'dashboard.quickActions.setBudget': 'Set Budget',
    'dashboard.quickActions.newTransaction': 'New transaction',
    'dashboard.quickActions.createBudget': 'Create budget',
    'dashboard.quickActions.manageCategories': 'Manage categories',
    'dashboard.quickActions.viewAnalytics': 'View analytics',
    'dashboard.transactions.viewAll': 'View all →',
    'dashboard.getStarted.title': 'Get started now',
    'dashboard.getStarted.step1': 'Account created successfully',
    'dashboard.getStarted.step1Desc': "You're ready to start",
    'dashboard.getStarted.step2': 'Create your first budget',
    'dashboard.getStarted.step2Desc': 'Define your financial goals',
    'dashboard.getStarted.step3': 'Add transactions',
    'dashboard.getStarted.step3Desc': 'Track your income and expenses',
    'dashboard.getStarted.step4': 'Configure categories',
    'dashboard.getStarted.step4Desc': 'Organize your expenses',

    // Goals Page
    'goals.title': 'Goals',
    'goals.subtitle': 'Track your financial goals',
    'goals.addGoal': 'Add Goal',
    'goals.emptyTitle': 'Track goals that matter to you',
    'goals.emptyDesc':
      'Use linked accounts to track your savings, debt payoff, and investment goals. Create savings, debt and investment goals.',
    'goals.getStarted': 'Get Started',
    'goals.addNew': 'Add new goal',
    'goals.chooseType': 'Choose goal type',
    'goals.customizeGoal': 'Customize your goal',
    'goals.name': 'Goal name',
    'goals.namePlaceholder': 'My savings goal',
    'goals.targetAmount': 'Target amount',
    'goals.targetDate': 'Target date (optional)',
    'goals.linkAccount': 'Link to account (optional)',
    'goals.noAccount': 'No linked account',
    'goals.untitled': 'Untitled Goal',
    'goals.create': 'Create Goal',
    'goals.created': 'Goal created',
    'goals.createdDesc': 'Your goal has been created successfully',
    'goals.deleted': 'Goal deleted',
    'goals.deletedDesc': 'Your goal has been deleted',
    'goals.archived': 'Goal archived',
    'goals.archivedDesc': 'Your goal has been archived',
    'goals.archivedTitle': 'Archived Goals',
    'goals.unarchived': 'Goal restored',
    'goals.unarchivedDesc': 'Your goal has been restored',
    'goals.unarchive': 'Restore',
    'goals.completed': 'Completed',
    'goals.progress': 'Progress',
    'goals.remaining': 'Remaining',
    'goals.archive': 'Archive',
    'goals.delete': 'Delete',
    'goals.target': 'Target',
    'goals.saved': 'Saved',
    'goals.deadline': 'Deadline',
    'goals.noDeadline': 'No deadline',
    'goals.addDeposit': 'Allocate',
    'goals.addWithdrawal': 'Deallocate',
    'goals.depositAdded': 'Allocation recorded',
    'goals.depositAddedDesc': 'Your allocation has been recorded',
    'goals.withdrawalAdded': 'Deallocation recorded',
    'goals.withdrawalAddedDesc': 'Your deallocation has been recorded',
    'goals.amount': 'Amount',
    'goals.sourceAccount': 'From account',
    'goals.destinationAccount': 'From account',
    'goals.date': 'Date',
    'goals.noteOptional': 'Note (optional)',
    'goals.confirm': 'Confirm',
    'goals.depositHistory': 'History',
    'goals.noDeposits': 'No allocations yet',
    'goals.noDepositsDesc': 'Allocate funds to start tracking progress',
    'goals.predictionText': 'At your current pace, you will reach this goal around {date}.',
    'goals.predictionInsufficient': 'Allocate more funds to see a prediction.',
    'goals.cumulativeProgress': 'Progress over time',
    'goals.savingsGoals': 'Savings Goals',
    'goals.debtPayment': 'Debt Payment',
    'goals.deleteConfirm': 'This will permanently delete this goal and all its allocations.',
    'goals.selectAccount': 'Select an account',
    'dashboard.nav.goals': 'Goals',
    'dashboard.nav.calendar': 'Calendar',
    'dashboard.nav.coach': 'Coach clevia',

    // Coach Page
    'coach.title': 'Coach clevia',
    'coach.subtitle': 'Your personal AI financial guide',
    'coach.comingSoon.title': 'Your Personal AI Coach',
    'coach.comingSoon.description':
      'Your personal AI coach is coming soon. It will help you make better financial decisions based on your history in clevia.',
    'coach.disclaimer.title': 'Important:',
    'coach.disclaimer.description':
      'Coach clevia provides general guidance, not financial advice. Always consult with a qualified financial advisor for important decisions.',
    'coach.features.analysis': 'Spending Analysis',
    'coach.features.analysisDesc':
      'Understand your spending patterns and find opportunities to save.',
    'coach.features.insights': 'Personalized Insights',
    'coach.features.insightsDesc': 'Get tailored recommendations based on your financial data.',
    'coach.features.decisions': 'Better Decisions',
    'coach.features.decisionsDesc': 'Make smarter financial choices with AI-powered guidance.',

    // Calendar Page
    'calendar.title': 'Subscriptions Calendar',
    'calendar.subtitle': 'View and manage your recurring transactions',
    'calendar.viewCalendar': 'Calendar',
    'calendar.viewList': 'List',
    'calendar.add': 'Add',
    'calendar.income': 'Income',
    'calendar.expenses': 'Expenses',
    'calendar.recurring': 'Recurring',
    'calendar.net': 'Net',
    'calendar.fixedExpenses': 'Fixed expenses',
    'calendar.recurringIncome': 'Recurring income',
    'calendar.forecastBalance': 'Forecast balance',
    'calendar.next7Days': 'Next 7 days',
    'calendar.upcomingDue': 'Upcoming due',
    'calendar.manageRecurrences': 'Manage recurrences',
    'calendar.manage.description': 'Description',
    'calendar.manage.amount': 'Amount',
    'calendar.manage.frequency': 'Frequency',
    'calendar.manage.recurrenceDate': 'Recurrence date',
    'calendar.manage.endDate': 'End',
    'calendar.manage.category': 'Category',
    'calendar.manage.account': 'Account',
    'calendar.manage.status': 'Status',
    'calendar.manage.actions': 'Actions',
    'calendar.manage.active': 'Active',
    'calendar.manage.inactive': 'Inactive',
    'calendar.manage.noEnd': '—',
    'calendar.manage.noRecurrences': 'No recurrences yet',
    'calendar.manage.daily': 'Daily',
    'calendar.manage.weekly': 'Weekly',
    'calendar.manage.monthly': 'Monthly',
    'calendar.manage.yearly': 'Yearly',
    'calendar.modify.title': 'How to apply this change?',
    'calendar.modify.includeCurrent': 'Also modify the current month',
    'calendar.modify.includeCurrentDesc':
      'The change applies immediately\nThe current month occurrence is updated\nAll future occurrences use the new amount',
    'calendar.modify.fromNext': 'Apply from the next cycle',
    'calendar.modify.fromNextDesc':
      'The current month stays unchanged\nThe change starts at the next payment',
    'calendar.modify.apply': 'Apply',
    'calendar.modify.cancel': 'Cancel',
    'calendar.today': 'Today',
    'calendar.activeSubscriptions': 'active subscriptions',
    'calendar.empty': 'No recurring payments this month',
    'calendar.addFirst': 'Add your first subscription',
    'calendar.nothingOnDay': 'No payments on this day',
    'calendar.incomeLabel': 'Income',
    'calendar.expenseLabel': 'Expense',
    'calendar.mon': 'Mon',
    'calendar.tue': 'Tue',
    'calendar.wed': 'Wed',
    'calendar.thu': 'Thu',
    'calendar.fri': 'Fri',
    'calendar.sat': 'Sat',
    'calendar.sun': 'Sun',

    // Budgets
    'budgets.title': 'Category Budgets',
    'budgets.subtitle': 'Set spending limits for each category',
    'budgets.addNew': 'Add Budget',
    'budgets.empty': 'No budgets yet',
    'budgets.emptyDesc': 'Create budgets to track spending by category',
    'budgets.addFirst': 'Add your first budget',
    'budgets.spent': 'Spent',
    'budgets.limit': 'Limit',
    'budgets.remaining': 'remaining',
    'budgets.status.exceeded': 'Exceeded',
    'budgets.status.nearLimit': 'Near limit',
    'budgets.status.healthy': 'Healthy',
    'budgets.period.weekly': 'Weekly',
    'budgets.period.monthly': 'Monthly',
    'budgets.period.yearly': 'Yearly',
    'budgets.modal.edit': 'Edit Budget',
    'budgets.modal.create': 'Create Budget',
    'budgets.modal.category': 'Category',
    'budgets.modal.selectCategory': 'Select a category',
    'budgets.modal.amount': 'Budget Amount',
    'budgets.modal.period': 'Period',
    'budgets.delete.confirm': 'Are you sure you want to delete this budget?',
    'budgets.stats.totalBudget': 'Total Budget',
    'budgets.stats.totalSpent': 'Total Spent',
    'budgets.stats.remaining': 'Remaining',
    'budgets.stats.usage': 'Usage',
    'budgets.healthyBudgets': 'healthy',
    'budgets.nearLimitBudgets': 'near limit',
    'budgets.exceededBudgets': 'exceeded',

    'common.cancel': 'Cancel',
    'common.loading': 'Loading...',
    'common.save': 'Save',
    'common.saving': 'Saving...',
    'common.error': 'Error',
    'common.create': 'Create',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.retry': 'Retry',

    // Categories
    'categories.income': 'Income',
    'categories.expenses': 'Expenses',
    'categories.infoBanner':
      'Changes you make to your groups and categories here will be applied all throughout clevia. You should customize your category structure to fit your needs.',
    'categories.createGroup': 'Create group',
    'categories.editGroup': 'Edit group',
    'categories.deleteGroup': 'Delete group',
    'categories.createGroupDesc': 'Create a new group to organize your categories.',
    'categories.editGroupDesc': 'Update the group name.',
    'categories.groupName': 'Group name',
    'categories.groupNamePlaceholder': 'e.g. Housing, Transport...',
    'categories.groupCreated': 'Group created',
    'categories.groupCreatedDesc': 'Your group has been created successfully.',
    'categories.groupUpdated': 'Group updated',
    'categories.groupUpdatedDesc': 'Your group has been updated successfully.',
    'categories.groupDeleted': 'Group deleted',
    'categories.groupDeletedDesc': 'Your group has been deleted successfully.',
    'categories.groupError': 'Failed to save group. Please try again.',
    'categories.groupDeleteError': 'Failed to delete group. Please try again.',
    'categories.deleteGroupConfirm': 'Delete group?',
    'categories.deleteGroupWarning':
      'Are you sure you want to delete "{name}"? Categories in this group will become ungrouped.',
    'categories.noGroups': 'No groups yet. Create one to organize your categories.',
    'categories.createCategory': 'Create category',
    'categories.editCategory': 'Edit category',
    'categories.createCategoryDesc': 'Create a new category to track your transactions.',
    'categories.editCategoryDesc': 'Update the category details.',
    'categories.categoryName': 'Category name',
    'categories.categoryNamePlaceholder': 'e.g. Groceries, Gas...',
    'categories.icon': 'Icon',
    'categories.chooseEmoji': 'Choose an emoji...',
    'categories.color': 'Color',
    'categories.categoryCreated': 'Category created',
    'categories.categoryCreatedDesc': 'Your category has been created successfully.',
    'categories.categoryUpdated': 'Category updated',
    'categories.categoryUpdatedDesc': 'Your category has been updated successfully.',
    'categories.categoryDeleted': 'Category deleted',
    'categories.categoryDeletedDesc': 'Your category has been deleted successfully.',
    'categories.categoryError': 'Failed to save category. Please try again.',
    'categories.categoryDeleteError': 'Failed to delete category. Please try again.',
    'categories.deleteCategoryConfirm': 'Delete category?',
    'categories.deleteCategoryWarning':
      'Are you sure you want to delete "{name}"? Transactions using this category will have no category assigned.',
    'categories.noCategories': 'No categories in this group yet.',
    'categories.createFirstGroup': 'Create your first group',
    'categories.edit': 'Edit',
    'categories.delete': 'Delete',
    'categories.dragHint': 'Drag and drop categories to reorder them within a group.',
    'categories.reorderError': 'Failed to reorder categories. Please try again.',
    'categories.resetOrder': 'Reset order',
    'categories.resetOrderConfirm': 'Reset categories order?',
    'categories.resetOrderWarning':
      'This will reset all categories to alphabetical order within each group. Your custom order will be lost.',
    'categories.orderReset': 'Order reset',
    'categories.orderResetDesc': 'Categories have been reordered alphabetically.',
    'categories.resetError': 'Failed to reset categories order. Please try again.',
    'categories.hide': 'Hide',
    'categories.show': 'Show',
    'categories.hideGroup': 'Hide group',
    'categories.showGroup': 'Show group',
    'categories.active': 'active',
    'categories.duplicateError': 'A category with this name already exists in this group.',
    'categories.duplicateGroupError': 'A group with this name already exists.',
    'categories.categoryHidden': 'Category hidden',
    'categories.categoryHiddenDesc': 'This category will not appear in selection lists.',
    'categories.categoryShown': 'Category visible',
    'categories.categoryShownDesc': 'This category will now appear in selection lists.',
    'categories.groupHidden': 'Group hidden',
    'categories.groupHiddenDesc': 'This group will not appear in selection lists.',
    'categories.groupShown': 'Group visible',
    'categories.groupShownDesc': 'This group will now appear in selection lists.',
    'categories.toggleHiddenError': 'Failed to update visibility. Please try again.',
    'categories.loadError': 'Failed to load categories',
    'categories.emptyTitle': 'No categories yet',
    'categories.emptyDesc':
      'Start by setting up your default categories to organize your transactions.',
    'categories.setupDefaults': 'Set up default categories',
    'categories.validation.nameRequired': 'Name is required.',
    'categories.validation.nameTooShort': 'Name must be at least 2 characters.',
    'categories.validation.nameTooLong': 'Name must be less than 50 characters.',

    // Settings
    'settings.title': 'Settings',
    'settings.subtitle': 'Customize your clevia experience',
    'settings.backToDashboard': 'Back to dashboard',
    'settings.tab.profile': 'Profile',
    'settings.tab.categories': 'Categories',
    'settings.tab.notifications': 'Notifications',
    'settings.tab.security': 'Security',
    'settings.tab.appearance': 'Appearance',
    'settings.tab.billing': 'Billing',
    'settings.profile.photo': 'Profile photo',
    'settings.profile.upload': 'Upload a photo',
    'settings.profile.delete': 'Delete',
    'settings.profile.photoDesc': 'JPG, PNG or GIF. Max 2MB.',
    'settings.profile.invalidFileType': 'Invalid file type',
    'settings.profile.invalidFileTypeDesc': 'Please upload a JPG, PNG or GIF image.',
    'settings.profile.fileTooLarge': 'File too large',
    'settings.profile.fileTooLargeDesc': 'Please upload an image smaller than 2MB.',
    'settings.profile.photoUploaded': 'Photo uploaded',
    'settings.profile.photoUploadedDesc': 'Your profile photo has been updated.',
    'settings.profile.uploadError': 'Upload failed',
    'settings.profile.uploadErrorDesc': 'Could not upload your photo. Please try again.',
    'settings.profile.photoDeleted': 'Photo deleted',
    'settings.profile.photoDeletedDesc': 'Your profile photo has been removed.',
    'settings.profile.deleteError': 'Delete failed',
    'settings.profile.deleteErrorDesc': 'Could not delete your photo. Please try again.',
    'settings.profile.personalInfo': 'Personal information',
    'settings.profile.fullName': 'Full name',
    'settings.profile.email': 'Email',
    'settings.profile.phone': 'Phone',
    'settings.profile.phonePlaceholder': '+212 6XX XXX XXX',
    'settings.profile.address': 'Address',
    'settings.profile.addressPlaceholder': 'Casablanca, Morocco',
    'settings.profile.save': 'Save changes',
    'settings.profile.saved': 'Profile updated',
    'settings.profile.savedDesc': 'Your profile has been saved successfully',
    'settings.profile.error': 'Update failed',
    'settings.profile.errorDesc': 'Could not update your profile. Please try again.',
    'settings.notifications.title': 'Notification preferences',
    'settings.notifications.email': 'Email notifications',
    'settings.notifications.emailDesc': 'Receive updates by email',
    'settings.notifications.push': 'Push notifications',
    'settings.notifications.pushDesc': 'Receive notifications on your devices',
    'settings.notifications.transactions': 'Transaction alerts',
    'settings.notifications.transactionsDesc': 'Get notified for each transaction',
    'settings.notifications.budgets': 'Budget alerts',
    'settings.notifications.budgetsDesc': 'Receive alerts when you exceed your budget',
    'settings.notifications.weekly': 'Weekly report',
    'settings.notifications.weeklyDesc': 'Weekly summary of your finances',
    'settings.notifications.saved': 'Preferences saved',
    'settings.notifications.savedDesc': 'Your notification preferences have been updated.',
    'settings.notifications.error': 'Save failed',
    'settings.notifications.errorDesc': 'Could not save your preferences. Please try again.',
    'settings.security.changePassword': 'Change password',
    'settings.security.currentPassword': 'Current password',
    'settings.security.newPassword': 'New password',
    'settings.security.confirmPassword': 'Confirm password',
    'settings.security.updatePassword': 'Update password',
    'settings.security.twoFactor': 'Two-factor authentication',
    'settings.security.twoFactorDesc': 'Add an extra layer of security to your account',
    'settings.security.enable2FA': 'Enable 2FA',
    'settings.security.manage2FA': 'Manage 2FA',
    'settings.security.2faActive': 'Active',
    'settings.2fa.title': 'Two-Factor Authentication',
    'settings.2fa.subtitle': 'Secure your account',
    'settings.2fa.manageDesc': 'Manage your 2FA settings',
    'settings.2fa.howItWorks': 'How it works',
    'settings.2fa.howItWorksDesc':
      'Use an authenticator app like Google Authenticator or Authy to generate verification codes when you sign in.',
    'settings.2fa.step1': 'Download an authenticator app',
    'settings.2fa.step2': 'Scan the QR code with the app',
    'settings.2fa.step3': 'Enter the verification code',
    'settings.2fa.startSetup': 'Start Setup',
    'settings.2fa.scanQR': 'Scan this QR code with your authenticator app',
    'settings.2fa.manualEntry': "Can't scan? Enter this code manually:",
    'settings.2fa.continue': 'Continue',
    'settings.2fa.enterCode': 'Enter verification code',
    'settings.2fa.enterCodeDesc': 'Enter the 6-digit code from your authenticator app',
    'settings.2fa.codeLength': 'Please enter a 6-digit code',
    'settings.2fa.invalidCode': 'Invalid verification code. Please try again.',
    'settings.2fa.back': 'Back',
    'settings.2fa.verify': 'Verify',
    'settings.2fa.successTitle': '2FA Enabled!',
    'settings.2fa.successDesc': 'Your account is now protected with two-factor authentication.',
    'settings.2fa.enabled': '2FA Enabled',
    'settings.2fa.enabledDesc': 'Two-factor authentication has been enabled for your account.',
    'settings.2fa.disabled': '2FA Disabled',
    'settings.2fa.disabledDesc': 'Two-factor authentication has been disabled.',
    'settings.2fa.activeTitle': '2FA is Active',
    'settings.2fa.activeDesc': 'Your account is protected with two-factor authentication.',
    'settings.2fa.addedOn': 'Added on',
    'settings.2fa.remove': 'Remove',
    'settings.2fa.close': 'Close',
    'settings.2fa.error': 'Error',
    'settings.2fa.enrollError': 'Failed to start 2FA setup. Please try again.',
    'settings.2fa.disableError': 'Failed to disable 2FA. Please try again.',
    'settings.2fa.verifyTitle': 'Two-Factor Authentication Required',
    'settings.2fa.verifyDesc': 'Enter the code from your authenticator app',
    'settings.security.activeSessions': 'Active sessions',
    'settings.security.currentSession': 'Current',
    'settings.security.activeNow': 'Active now',
    'settings.security.onDevice': 'on',
    'settings.security.revoke': 'Revoke',
    'settings.security.signOutOthers': 'Sign out others',
    'settings.security.sessionRevoked': 'Session revoked',
    'settings.security.sessionRevokedDesc': 'The session has been successfully revoked.',
    'settings.security.otherSessionsRevoked': 'Other sessions revoked',
    'settings.security.otherSessionsRevokedDesc': 'All other sessions have been signed out.',
    'settings.security.allFieldsRequired': 'All fields are required',
    'settings.security.passwordMinLength': 'Password must be at least 8 characters',
    'settings.security.passwordsNoMatch': 'Passwords do not match',
    'settings.security.currentPasswordWrong': 'Current password is incorrect',
    'settings.security.passwordUpdated': 'Password updated',
    'settings.security.passwordUpdatedDesc': 'Your password has been successfully updated.',
    'settings.security.passwordUpdateError': 'Failed to update password. Please try again.',
    'settings.appearance.theme': 'Theme',
    'settings.appearance.darkMode': 'Dark mode',
    'settings.appearance.darkModeDesc': 'Perfect for night',
    'settings.appearance.lightMode': 'Light mode',
    'settings.appearance.lightModeDesc': 'Ideal for day',
    'settings.appearance.language': 'Language',
    'settings.appearance.languageDesc': 'Select your preferred language',
    'settings.appearance.currency': 'Currency',
    'settings.appearance.currencyDesc': 'Choose your preferred currency for displaying amounts',
    'settings.appearance.currencyExample': 'Example',
    'settings.billing.currentPlan': 'Free Plan',
    'settings.billing.planDesc': 'Enjoy all features for free',
    'settings.billing.perMonth': '/ month',
    'settings.billing.upgradePremium': 'Upgrade to Premium',
    'settings.billing.features': 'Included features',
    'settings.billing.feature1': 'Unlimited budgets',
    'settings.billing.feature2': 'Unlimited transactions',
    'settings.billing.feature3': 'Custom categories',
    'settings.billing.feature4': 'Analytics and charts',
    'settings.billing.feature5': 'Data export',
    'settings.billing.feature6': 'Priority support',
    'settings.billing.exportData': 'Export your data',
    'settings.billing.exportDesc': 'Download a copy of all your data in CSV or JSON format',
    'settings.billing.exportCSV': 'Export CSV',
    'settings.billing.exportJSON': 'Export JSON',
    'settings.tab.account': 'Account',
    'settings.account.statusTitle': 'Account Status',
    'settings.account.statusActiveDesc': 'Your account is active and all features are available.',
    'settings.account.statusPausedDesc':
      'Your account is paused. Your data is preserved but you cannot use features.',
    'settings.account.active': 'Active',
    'settings.account.paused': 'Account paused',
    'settings.account.resumed': 'Account resumed',
    'settings.account.pausedDesc': 'Your account has been paused. You can resume it at any time.',
    'settings.account.resumedDesc': 'Your account is now active again.',
    'settings.account.pauseBtn': 'Pause my account',
    'settings.account.resumeBtn': 'Resume my account',
    'settings.account.dataRetention': 'Data Retention',
    'settings.account.dataFinancial': 'Financial data',
    'settings.account.dataFinancialValue': 'Kept as long as your account is active',
    'settings.account.dataConnection': 'Connection data',
    'settings.account.dataConnectionValue': 'Kept 12 months for security',
    'settings.account.dataCookies': 'Cookies',
    'settings.account.dataCookiesValue': 'Maximum 13 months (CNIL)',
    'settings.account.dataAfterDelete': 'After deletion',
    'settings.account.dataAfterDeleteValue': 'Data kept 30 days then permanently deleted',
    'settings.account.dangerZone': 'Danger Zone',
    'settings.account.deleteWarning':
      'Once you delete your account, there is a 30-day grace period during which you can contact us to cancel the deletion.',
    'settings.account.deleteInfo1': 'Your data will be kept for 30 days after the request',
    'settings.account.deleteInfo2': 'After 30 days, all data will be permanently deleted',
    'settings.account.deleteInfo3': 'This action cannot be undone after the grace period',
    'settings.account.deleteBtn': 'Delete my account',
    'settings.account.deleteConfirmLabel':
      'Type SUPPRIMER to confirm the deletion of your account:',
    'settings.account.confirmDelete': 'Permanently delete',
    'settings.account.cancel': 'Cancel',
    'settings.account.deleteRequested': 'Deletion requested',
    'settings.account.deleteRequestedDesc':
      'Your account will be deleted in 30 days. Contact us to cancel.',
    'settings.account.error': 'Error',
    'settings.account.errorDesc': 'An error occurred. Please try again.',

    // Transactions Page
    'transactions.title': 'Transactions',
    'transactions.subtitle': 'Track all your income and expenses',
    'transactions.addNew': 'Add transaction',
    'transactions.import': 'Import',
    'transactions.export': 'Export',
    'transactions.search': 'Search transactions...',
    'transactions.filter.all': 'All',
    'transactions.filter.income': 'Income',
    'transactions.filter.expense': 'Expenses',
    'transactions.stats.income': 'Total Income',
    'transactions.stats.expense': 'Total Expenses',
    'transactions.stats.balance': 'Balance',
    'transactions.empty': 'No transactions found',
    'transactions.emptyDesc': 'Start by adding your first transaction',
    'transactions.today': 'Today',
    'transactions.yesterday': 'Yesterday',
    'transactions.type.income': 'Income',
    'transactions.type.expense': 'Expense',
    'transactions.delete.confirm': 'Are you sure you want to delete this transaction?',
    'transactions.delete.success': 'Transaction deleted successfully',
    'transactions.create.success': 'Transaction created successfully',
    'transactions.update.success': 'Transaction updated successfully',

    // Transaction Modal
    'transactionModal.create': 'New Transaction',
    'transactionModal.edit': 'Edit Transaction',
    'transactionModal.amount': 'Amount',
    'transactionModal.description': 'Description',
    'transactionModal.descriptionPlaceholder': 'Enter description...',
    'transactionModal.noDescription': 'No description',
    'transactionModal.date': 'Date',
    'transactionModal.type': 'Type',
    'transactionModal.category': 'Category',
    'transactionModal.categoryPlaceholder': 'Select category...',
    'transactionModal.submit': 'Save',
    'transactionModal.cancel': 'Cancel',
    'transactionModal.creating': 'Creating...',
    'transactionModal.updating': 'Updating...',

    // Categories
    'categories.salary': 'Salary',
    'categories.freelance': 'Freelance',
    'categories.investment': 'Investment',
    'categories.food': 'Food',
    'categories.transport': 'Transport',
    'categories.housing': 'Housing',
    'categories.entertainment': 'Entertainment',
    'categories.health': 'Health',
    'categories.shopping': 'Shopping',
    'categories.other': 'Other',

    // Onboarding
    'onboarding.step': 'Step',
    'onboarding.of': 'of',
    'onboarding.next': 'Next',
    'onboarding.previous': 'Previous',
    'onboarding.skip': 'Skip this step',
    'onboarding.finish': 'Create my account',
    'onboarding.hasAccount': 'Already have an account?',
    'onboarding.login': 'Login',

    'onboarding.identity.title': 'To start, what is your first name?',
    'onboarding.identity.subtitle': 'A few details so clevia can truly feel like yours',
    'onboarding.identity.firstName': 'First name',
    'onboarding.identity.firstNamePlaceholder': 'Kamil',
    'onboarding.age.label': 'Age',
    'onboarding.age.placeholder': '25',
    'onboarding.dateOfBirth.label': 'Date of birth',
    'onboarding.gender.label': 'Sex',

    'onboarding.country.title': 'Where do you live right now?',
    'onboarding.country.subtitle': "We'll adjust currency and info to your location",
    'onboarding.country.search': 'Search for a country',
    'onboarding.country.other': 'Other country',
    'onboarding.country.loading': 'Loading countries...',
    'onboarding.country.noResults': 'No country found',
    'onboarding.country.error': 'Unable to load the country list. Please try again.',

    'onboarding.lifeSituation.title': 'Your life situation',
    'onboarding.lifeSituation.subtitle':
      'Pick the profile that best describes your current situation',

    'onboarding.management.title': 'You manage your money',
    'onboarding.management.subtitle': 'Just for you, for two, or for the whole household?',

    'onboarding.challenges.title': 'Why are you coming to clevia?',
    'onboarding.challenges.subtitle': "Tell us what's most complicated for you with money",

    'onboarding.expectations.title': 'What clevia can bring you',
    'onboarding.expectations.subtitle': 'Tell us what you expect from us',

    'onboarding.discovery.title': 'How did you find us?',
    'onboarding.discovery.subtitle': "Social media, friends, Google… we're curious to know",

    'onboarding.referral.title': 'Do you have a clevia referral code?',
    'onboarding.referral.subtitle': 'You can enter it now, or continue without adding one',
    'onboarding.referral.label': 'Referral code (optional)',
    'onboarding.referral.placeholder': 'Enter your code',
    'onboarding.referral.hint':
      'If you refer 5 people, you earn 1 free month on the paid plan (coming soon).',

    'onboarding.account.title': 'Create my account',
    'onboarding.account.subtitle': 'Last step before getting started',
    'onboarding.account.email': 'Your email',
    'onboarding.account.emailPlaceholder': 'name@example.com',
    'onboarding.account.password': 'Password',
    'onboarding.account.passwordPlaceholder': 'Minimum 8 characters (a-z, A-Z, 0-9)',
    'onboarding.account.terms': 'By signing up, you accept the',
    'onboarding.account.termsLink': 'Terms of Service',
    'onboarding.account.and': 'and the',
    'onboarding.account.privacyLink': 'Privacy Policy',
    'onboarding.account.ofclevia': 'of clevia',

    'onboarding.welcome.title': 'Welcome to clevia!',
    'onboarding.welcome.message': 'Your account has been successfully created',

    // Getting started guide
    'gettingStarted.label': 'Discover clevia',
    'gettingStarted.start': "Let's go",
    'gettingStarted.next': 'Next',
    'gettingStarted.previous': 'Previous',
    'gettingStarted.finish': 'Finish',
    'gettingStarted.final.cta': 'Start with clevia',
    'gettingStarted.finalStep': '7 / 7',
    'gettingStarted.slide1.title': 'Welcome to clevia 👋',
    'gettingStarted.slide1.description':
      'clevia helps you understand your money simply: what you own, what comes in, what goes out and the projects you want to achieve.',
    'gettingStarted.slide1.detail':
      'In a few steps, we will show you the essentials to get started.',
    'gettingStarted.slide2.title': '1. Start with your accounts',
    'gettingStarted.slide2.description':
      'Add the places where you keep your money: current account, savings, cash and other parts of your wealth.',
    'gettingStarted.slide2.cardTitle': 'Boursorama',
    'gettingStarted.slide2.cardType': 'Current account',
    'gettingStarted.slide2.balanceLabel': 'Current balance',
    'gettingStarted.slide2.amount': '€2,450',
    'gettingStarted.slide2.cardNote': 'This amount becomes your starting point in clevia.',
    'gettingStarted.slide2.cardHelp':
      'When you add an account, enter the amount currently on it. Then add new transactions from now on. No need to rebuild your entire history.',
    'gettingStarted.slide3.title': '2. Bring your accounts to life',
    'gettingStarted.slide3.description':
      'From now on, simply add the movements that happen on your accounts.',
    'gettingStarted.slide3.expenseTitle': 'Expense',
    'gettingStarted.slide3.expenseText':
      'Money leaves your account. Examples: restaurant, groceries, rent.',
    'gettingStarted.slide3.incomeTitle': 'Income',
    'gettingStarted.slide3.incomeText':
      'Money comes into your account. Examples: salary, refund, freelance income.',
    'gettingStarted.slide3.transferTitle': 'Transfer',
    'gettingStarted.slide3.transferText':
      'You move your own money from one account to another. Example: current account → savings.',
    'gettingStarted.slide3.note': 'A transfer is neither an expense nor an income.',
    'gettingStarted.slide4.title': '3. Give your month a framework',
    'gettingStarted.slide4.description':
      'Budgets help you decide how much to spend on each category and see what remains throughout the month.',
    'gettingStarted.slide4.exampleTitle': 'Restaurants',
    'gettingStarted.slide4.exampleText': '120 € used out of 200 €',
    'gettingStarted.slide4.note':
      'You do not need to set everything up at once. Start with the categories that matter most to you.',
    'gettingStarted.slide5.title': '4. Anticipate what comes back',
    'gettingStarted.slide5.description':
      'The Calendar helps you visualise income and expenses that come back regularly.',
    'gettingStarted.slide5.netflix': 'Netflix',
    'gettingStarted.slide5.rent': 'Rent',
    'gettingStarted.slide5.gym': 'Gym',
    'gettingStarted.slide5.salary': 'Salary',
    'gettingStarted.slide5.insurance': 'Insurance',
    'gettingStarted.slide5.cardTitle': 'Everything is managed from “Manage recurrences”',
    'gettingStarted.slide5.cardText':
      'Add, edit, pause or delete your recurring items. Add your subscriptions and regular expenses once, and clevia organises them in your calendar.',
    'gettingStarted.slide6.title': '5. Give your money a purpose',
    'gettingStarted.slide6.description':
      'Set goals that give direction to your money and follow your progress over time.',
    'gettingStarted.slide6.savingsTitle': 'Savings goal',
    'gettingStarted.slide6.savingsText': 'Gradually put money aside.',
    'gettingStarted.slide6.savingsExamples': 'Travel · Car · Down payment · Emergency fund',
    'gettingStarted.slide6.debtTitle': 'Debt repayment',
    'gettingStarted.slide6.debtText': 'Track what you still have left to repay.',
    'gettingStarted.slide6.debtExamples': 'Personal loan · Family debt · Credit',
    'gettingStarted.slide6.note':
      'You can simply see where you start, where you want to go and your progress.',
    'gettingStarted.slide7.title': '6. Make clevia yours',
    'gettingStarted.slide7.description':
      'The categories used in your transactions are fully customisable.',
    'gettingStarted.slide7.path': 'Settings → Financial settings → Categories',
    'gettingStarted.slide7.detail':
      'clevia gives you a starting point, but you decide how to organise your money.',
    'gettingStarted.slide7.create': 'Create your own categories',
    'gettingStarted.slide7.edit': 'Change their name or icon',
    'gettingStarted.slide7.organize': 'Organise them',
    'gettingStarted.slide7.hide': 'Hide those you do not need',
    'gettingStarted.final.title': 'And that is it, you are ready 🎉',
    'gettingStarted.final.description':
      'That is all you need to get started. Add your accounts, note what comes in and goes out, set a few budgets and move gradually towards your goals.',
    'gettingStarted.final.detail':
      'No need to be perfect from day one. Start simply, and clevia will evolve with you. We wish you a life full of projects, progress and beautiful achievements.',
    'gettingStarted.final.signature': 'Co-founders of clevia',
    'gettingStarted.final.names': 'Mehdi & Marouane',

    // Accounts
    'accounts.title': 'Accounts',
    'accounts.subtitle': 'Manage all your assets and liabilities',
    'accounts.addAccount': 'Add account',
    'accounts.netWorth': 'NET WORTH',
    'accounts.monthChange': '1 month change',
    'accounts.performance': 'Net worth performance',
    'accounts.vsPreviousPeriod': 'vs previous period',
    'accounts.period.1m': '1 month',
    'accounts.period.3m': '3 months',
    'accounts.period.6m': '6 months',
    'accounts.period.1y': '1 year',
    'accounts.period.all': 'All time',
    'accounts.summary': 'Summary',
    'accounts.summary.totals': 'Totals',
    'accounts.summary.percent': 'Percent',
    'accounts.summary.assets': 'Assets',
    'accounts.summary.liabilities': 'Liabilities',
    'accounts.summary.downloadExcel': 'Download Excel',
    'accounts.empty': 'No accounts yet',
    'accounts.emptyDesc': 'Add your first account to start tracking your net worth',
    'accounts.noAccount': 'No account',
    'accounts.justNow': 'Just now',
    'accounts.hidden': 'hidden account',
    'accounts.hidden_plural': 'hidden accounts',
    'accounts.lastUpdated': 'Last updated',
    'accounts.edit': 'Edit',
    'accounts.delete': 'Delete',
    'accounts.deleteConfirm': 'Are you sure you want to delete this account?',
    'accounts.hide': 'Hide',
    'accounts.show': 'Show',
    'accounts.updateBalance': 'Update balance',
    'accounts.modal.add': 'Add Account',
    'accounts.modal.addManual': 'Add Manual Account',
    'accounts.modal.edit': 'Edit Account',
    'accounts.modal.name': 'Name',
    'accounts.modal.namePlaceholder': 'My savings account',
    'accounts.modal.type': 'Type',
    'accounts.modal.subtype': 'Category',
    'accounts.modal.balance': 'Balance',
    'accounts.modal.balancePlaceholder': '0.00',
    'accounts.modal.institution': 'Institution (optional)',
    'accounts.modal.institutionPlaceholder': 'Bank name',
    'accounts.modal.save': 'Save',
    'accounts.modal.cancel': 'Cancel',
    'accounts.modal.saving': 'Saving...',

    // Add Bank Account
    'addBank.title': 'Add a bank account',
    'addBank.subtitle': 'Link your bank accounts to track your finances in one place.',
    'addBank.openBanking': 'Open Banking',
    'addBank.openBankingDesc': "Connect automatically via your bank's secure API.",
    'addBank.comingSoon': 'Coming soon',
    'addBank.manualAdd': 'Manual addition',
    'addBank.manualAddDesc': 'Select your bank and enter account details manually.',
    'addBank.selectBank': 'Select your bank',
    'addBank.selectBankDesc': 'Choose from our list of supported banks.',
    'addBank.searchPlaceholder': 'Search for a bank...',
    'addBank.yourCountry': 'Your country',
    'addBank.noResults': 'No banks found. Try a different search.',
    'addBank.accountType': 'Account type',
    'addBank.accountDetails': 'Account details',
    'addBank.addAccount': 'Add this account',
    'addBank.editAccount': 'Edit account',
    'addBank.saveChanges': 'Save changes',
    'addBank.categoryTitle': 'Add an account',
    'addBank.categorySubtitle': 'What type of account would you like to add?',
    'addBank.cat.bank_accounts': 'Bank accounts & savings',
    'addBank.cat.cash': 'Cash',
    'addBank.cat.real_estate': 'Real estate',
    'addBank.cat.other_assets': 'Other assets',
    'addBank.cat.watches_jewelry': 'Watches & Jewelry',
    'addBank.cat.precious_metals': 'Precious metals',
    'addBank.cat.crypto': 'Crypto',
    'addBank.cat.pea': 'PEA',
    'addBank.cat.life_insurance': 'Life insurance',
    'addBank.cat.stocks_funds': 'Stocks & Funds',
    'addBank.catDesc.bank_accounts': 'Current accounts, savings, term deposits',
    'addBank.catDesc.cash': 'Track your cash on hand',
    'addBank.catDesc.real_estate': 'Properties and real estate investments',
    'addBank.catDesc.other_assets': 'Vehicles, collections, other valuables',
    'addBank.catDesc.watches_jewelry': 'Luxury watches and jewelry',
    'addBank.catDesc.precious_metals': 'Gold, silver and other metals',
    'addBank.catDesc.crypto': 'Bitcoin, Ethereum and other cryptocurrencies',
    'addBank.catDesc.pea': 'Equity savings plan',
    'addBank.catDesc.life_insurance': 'Life insurance contracts',
    'addBank.catDesc.stocks_funds': 'Individual stocks and investment funds',
    'addBank.bankType.checking': 'Checking account',
    'addBank.bankType.savings': 'Savings account',
    'addBank.bankType.credit_card': 'Credit card',
    'addBank.bankType.joint_account': 'Joint account',
    'addBank.bankType.money_market': 'Money market',
    'addBank.interestRate': 'Annual interest rate',
    'addBank.interestRateHint': 'Optional — useful for tracking savings growth',
    'addBank.apr': 'Annual Percentage Rate (APR)',
    'addBank.aprHint': 'Optional — the annual interest rate on your credit card',
    'addBank.creditLimit': 'Credit limit',

    'addCash.title': 'Add cash',
    'addCash.subtitle': 'Declare your cash holdings to track them in your net worth.',
    'addCash.name': 'Cash name',
    'addCash.namePlaceholder': 'e.g. Wallet, Safe, Home cash...',
    'addCash.nameHint': 'Examples: Wallet cash, Safe, Home cash, Travel cash',
    'addCash.amount': 'Current amount (approx.)',
    'addCash.amountHint': 'An estimate is fine — you can adjust it later.',
    'addCash.currencyHint': 'Based on your currency settings',
    'addCash.addCash': 'Add this cash',

    // Real estate
    'addRealEstate.title': 'Add a property',
    'addRealEstate.subtitle': 'Track your real estate in your net worth.',
    'addRealEstate.defaultName': 'My property',
    'addRealEstate.optional': '(optional)',
    'addRealEstate.next': 'Next',
    'addRealEstate.addProperty': 'Add this property',
    'addRealEstate.estimatedValue': 'Estimated value',
    'addRealEstate.tab.description': 'Description',
    'addRealEstate.tab.characteristics': 'Features',
    'addRealEstate.tab.ownership': 'Ownership',
    'addRealEstate.name': 'Property name',
    'addRealEstate.namePlaceholder': 'e.g. My apartment, Country house...',
    'addRealEstate.description': 'Description',
    'addRealEstate.descriptionPlaceholder': 'Add a short description...',
    'addRealEstate.propertyType': 'Property type',
    'addRealEstate.category': 'Category',
    'addRealEstate.city': 'City',
    'addRealEstate.cityPlaceholder': 'e.g. Paris',
    'addRealEstate.country': 'Country',
    'addRealEstate.countryPlaceholder': 'e.g. France',
    'addRealEstate.type.apartment': 'Apartment',
    'addRealEstate.type.house': 'House',
    'addRealEstate.type.building': 'Building',
    'addRealEstate.type.parking': 'Parking',
    'addRealEstate.type.land': 'Land',
    'addRealEstate.type.commercial': 'Commercial property',
    'addRealEstate.type.other': 'Other',
    'addRealEstate.cat.primary_residence': 'Primary residence',
    'addRealEstate.cat.secondary_residence': 'Secondary residence',
    'addRealEstate.cat.rental': 'Rental property',
    'addRealEstate.cat.other': 'Other',
    'addRealEstate.purchasePrice': 'Purchase price (excl. fees)',
    'addRealEstate.surface': 'Surface area',
    'addRealEstate.landSurface': 'Land area',
    'addRealEstate.constructionYear': 'Construction year',
    'addRealEstate.dpe': 'Energy rating (DPE)',
    'addRealEstate.agencyFees': 'Agency fees',
    'addRealEstate.notaryFees': 'Notary fees',
    'addRealEstate.renovationFees': 'Renovation costs',
    'addRealEstate.furnishingFees': 'Furnishing costs',
    'addRealEstate.purchaseDate': 'Purchase date',
    'addRealEstate.ownershipPercent': 'Ownership share',
    'addRealEstate.ownershipHint': 'Percentage of the property you own (100% if sole owner).',

    // Other assets form
    'addOtherAsset.title': 'Add an asset',
    'addOtherAsset.subtitle': 'Track your other assets and alternative investments',
    'addOtherAsset.tabInfo': 'Information',
    'addOtherAsset.tabOwnership': 'Ownership',
    'addOtherAsset.name': 'Name',
    'addOtherAsset.namePlaceholder': 'e.g. Rolex Submariner, Wine collection...',
    'addOtherAsset.category': 'Category',
    'addOtherAsset.quantity': 'Quantity',
    'addOtherAsset.purchaseUnitPrice': 'Purchase unit price',
    'addOtherAsset.currentUnitPrice': 'Current unit price',
    'addOtherAsset.currentPricePlaceholder': 'Leave empty to use purchase price',
    'addOtherAsset.ownershipPercent': 'Ownership share',
    'addOtherAsset.estimatedValue': 'Estimated total value',
    'addOtherAsset.estimatedHint': 'Qty × Current price × Ownership %',
    'addOtherAsset.addAsset': 'Add this asset',
    'addOtherAsset.categories.other': 'Other',
    'addOtherAsset.categories.jewelry': 'Jewelry',
    'addOtherAsset.categories.pokemon_cards': 'Pokémon Cards',
    'addOtherAsset.categories.real_estate_crowdfunding': 'Real estate crowdfunding',
    'addOtherAsset.categories.private_debt': 'Private debt',
    'addOtherAsset.categories.fcpi': 'FCPI',
    'addOtherAsset.categories.g3f': 'G3F',
    'addOtherAsset.categories.forestry_investment': 'Forestry investment group',
    'addOtherAsset.categories.hedge_fund': 'Hedge fund',
    'addOtherAsset.categories.watch': 'Watch',
    'addOtherAsset.categories.sneakers': 'Sneakers',
    'addOtherAsset.categories.art': 'Art',
    'addOtherAsset.categories.precious_stones': 'Precious stones',
    'addOtherAsset.categories.p2p_lending': 'Peer-to-peer lending',
    'addOtherAsset.categories.private_equity': 'Private equity',
    'addOtherAsset.categories.land': 'Land',
    'addOtherAsset.categories.wine': 'Wine',
    'addOtherAsset.categories.car': 'Car',
    'addOtherAsset.categories.farm': 'Farm',
    'addOtherAsset.categories.agriculture': 'Agriculture',
    'addOtherAsset.categories.livestock': 'Livestock',
    'addOtherAsset.categories.taxi_license': 'Taxi license',

    // Watches & Jewelry form
    'addWatchJewelry.title': 'Add a watch or jewelry',
    'addWatchJewelry.subtitle': 'Track your luxury watches and jewelry',
    'addWatchJewelry.tabInfo': 'Information',
    'addWatchJewelry.tabOwnership': 'Ownership',
    'addWatchJewelry.typeWatch': 'Watch',
    'addWatchJewelry.typeJewelry': 'Jewelry',
    'addWatchJewelry.model': 'Model',
    'addWatchJewelry.modelPlaceholder': 'Rolex Submariner Date',
    'addWatchJewelry.name': 'Name',
    'addWatchJewelry.namePlaceholder': 'e.g. Gold bracelet, Diamond ring...',
    'addWatchJewelry.purchasePrice': 'Purchase price',
    'addWatchJewelry.seller': 'Seller',
    'addWatchJewelry.sellerPlaceholder': 'Original dealer or resale',
    'addWatchJewelry.condition': 'Condition',
    'addWatchJewelry.conditionOptional': 'Optional',
    'addWatchJewelry.condition.never_worn': 'Never worn',
    'addWatchJewelry.condition.worn': 'Already worn',
    'addWatchJewelry.originalBox': 'Original box',
    'addWatchJewelry.papers': 'Papers',
    'addWatchJewelry.ownershipPercent': 'Ownership share',
    'addWatchJewelry.estimatedValue': 'Estimated value',
    'addWatchJewelry.addItem': 'Add this item',

    'accounts.subtype.watch': 'Watch',
    'accounts.subtype.jewelry': 'Jewelry',
    'accountDetails.watchJewelry.details': 'Item details',
    'accountDetails.watchJewelry.condition': 'Condition',
    'accountDetails.watchJewelry.seller': 'Seller',
    'accountDetails.watchJewelry.originalBox': 'Original box',
    'accountDetails.watchJewelry.papers': 'Papers',
    'accountDetails.watchJewelry.yes': 'Yes',
    'accountDetails.watchJewelry.no': 'No',

    // Precious Metals
    'addPreciousMetal.title': 'Precious Metals',
    'addPreciousMetal.subtitle': 'Add your precious metal holdings',
    'addPreciousMetal.selectTitle': 'Add my precious metals',
    'addPreciousMetal.selectSubtitle': 'Select from popular metals or add a custom one',
    'addPreciousMetal.searchPlaceholder': 'Search precious metals...',
    'addPreciousMetal.popular': 'Most popular',
    'addPreciousMetal.results': 'Results',
    'addPreciousMetal.noResults': 'No metal found. Try another search or add a custom one.',
    'addPreciousMetal.addCustom': 'Add a custom metal',
    'addPreciousMetal.tabInfo': 'Information',
    'addPreciousMetal.tabOwnership': 'Ownership',
    'addPreciousMetal.name': 'Name',
    'addPreciousMetal.namePlaceholder': 'e.g. 1oz Gold Bar',
    'addPreciousMetal.quantity': 'Quantity',
    'addPreciousMetal.purchaseUnitPrice': 'Purchase unit price',
    'addPreciousMetal.totalValue': 'Total value',
    'addPreciousMetal.ownershipPercent': 'Ownership share',
    'addPreciousMetal.estimatedValue': 'Estimated value',
    'addPreciousMetal.estimatedHint': 'Based on quantity × price × ownership',
    'addPreciousMetal.addMetal': 'Add this metal',
    'accounts.subtype.precious_metal': 'Precious Metal',
    'accountDetails.preciousMetal.details': 'Metal details',

    // Crypto
    'addCrypto.title': 'Cryptocurrency',
    'addCrypto.subtitle': 'Add your crypto holdings',
    'addCrypto.selectTitle': 'Add my crypto',
    'addCrypto.selectSubtitle': 'Select from popular coins or search for any crypto',
    'addCrypto.searchPlaceholder': 'Search cryptocurrencies...',
    'addCrypto.popular': 'Most popular',
    'addCrypto.results': 'Results',
    'addCrypto.noResults': 'No crypto found. Try another search or add a custom one.',
    'addCrypto.addCustom': 'Add a custom cryptocurrency',
    'addCrypto.name': 'Name',
    'addCrypto.namePlaceholder': 'e.g. Bitcoin',
    'addCrypto.symbol': 'Symbol',
    'addCrypto.quantity': 'Quantity',
    'addCrypto.purchasePrice': 'Purchase unit price',
    'addCrypto.livePrice': 'Live price',
    'addCrypto.totalPurchase': 'Total purchase cost',
    'addCrypto.currentValue': 'Current value',
    'addCrypto.pnl': 'Profit / Loss',
    'addCrypto.addCrypto': 'Add this crypto',
    'accounts.subtype.crypto': 'Crypto',
    'accounts.group.crypto': 'Cryptocurrencies',
    'accountDetails.crypto.details': 'Holdings details',
    'accountDetails.crypto.livePrice': 'Live price',
    'accountDetails.crypto.change24h': '24h change',
    'accountDetails.crypto.pnl': 'Profit / Loss',
    'accountDetails.crypto.marketCap': 'Market cap',
    'accountDetails.crypto.priceChart': 'Price chart',
    'accountDetails.crypto.totalInvested': 'Total invested',
    'accountDetails.crypto.noChartData': 'No chart data available',

    // PEA (Plan d'Épargne en Actions)
    'addPea.title': 'PEA',
    'addPea.subtitle': 'Add a stock or ETF to your PEA',
    'addPea.selectTitle': 'Select a stock',
    'addPea.selectSubtitle': 'Choose from popular PEA-eligible stocks and ETFs',
    'addPea.searchPlaceholder': 'Search stocks, ETFs...',
    'addPea.popular': 'Popular stocks',
    'addPea.results': 'Search results',
    'addPea.noResults': 'No matching stocks found',
    'addPea.addCustom': 'Add a custom stock',
    'addPea.name': 'Stock name',
    'addPea.namePlaceholder': 'e.g. TotalEnergies',
    'addPea.quantity': 'Quantity',
    'addPea.purchasePrice': 'Purchase unit price',
    'addPea.totalValue': 'Total value',
    'addPea.addStock': 'Add this stock',
    'addPea.symbol': 'Symbol',
    'addPea.stockType': 'Type',
    'accounts.subtype.pea_stock': 'PEA',
    'accounts.group.pea': 'PEA',
    'accountDetails.pea.details': 'Holdings details',
    'accountDetails.pea.livePrice': 'Live price',
    'accountDetails.pea.pnl': 'Profit / Loss',
    'accountDetails.pea.currentValue': 'Current value',
    'accountDetails.pea.priceChart': 'Price chart',
    'accountDetails.pea.totalInvested': 'Total invested',
    'accountDetails.pea.noChartData': 'No chart data available',

    'accounts.type.asset': 'Asset',
    'accounts.type.liability': 'Liability',
    'accounts.subtype.checking': 'Checking',
    'accounts.subtype.savings': 'Savings',
    'accounts.subtype.cash': 'Cash',
    'accounts.subtype.investment': 'Investments',
    'accounts.subtype.real_estate': 'Real Estate',
    'accounts.subtype.vehicle': 'Vehicles',
    'accounts.subtype.other_asset': 'Other Assets',
    'accounts.subtype.credit_card': 'Credit Card',
    'accounts.subtype.mortgage': 'Mortgage',
    'accounts.subtype.loan': 'Loans',
    'accounts.subtype.other_liability': 'Other Liabilities',
    'accounts.subtype.joint_account': 'Joint Account',
    'accounts.subtype.money_market': 'Money Market',
    'accounts.group.bankAccounts': 'Bank Accounts',
    'accounts.group.livrets': 'Savings Accounts',
    'accounts.group.cash': 'Cash',
    'accounts.group.investments': 'Investments',
    'accounts.group.realEstate': 'Real Estate',
    'accounts.group.vehicles': 'Vehicles',
    'accounts.group.otherAssets': 'Other Assets',
    'accounts.group.watchesJewelry': 'Watches & Jewelry',
    'accounts.group.preciousMetals': 'Precious Metals',
    'accounts.group.creditCards': 'Credit Cards',
    'accounts.group.mortgages': 'Mortgages',
    'accounts.group.loans': 'Loans',
    'accounts.group.otherLiabilities': 'Other Liabilities',
    'dashboard.nav.accounts': 'Accounts',

    // Import
    'accounts.import': 'Import',
    'accounts.import.title': 'Import Accounts',
    'accounts.import.subtitle': 'Upload a CSV or Excel file to import your accounts',
    'accounts.import.upload': 'Upload File',
    'accounts.import.uploadDesc': 'Drag & drop a file here, or click to browse',
    'accounts.import.supported': 'Supports CSV, XLS, XLSX',
    'accounts.import.maxSize': 'Max 5MB',
    'accounts.import.mapColumns': 'Map Columns',
    'accounts.import.mapColumnsDesc': 'Match your file columns to account fields',
    'accounts.import.preview': 'Preview',
    'accounts.import.previewDesc': 'Review your data before importing',
    'accounts.import.importing': 'Importing...',
    'accounts.import.complete': 'Import Complete',
    'accounts.import.success': 'Successfully imported {count} accounts',
    'accounts.import.errors': '{count} errors occurred',
    'accounts.import.field.name': 'Account Name',
    'accounts.import.field.type': 'Type (asset/liability)',
    'accounts.import.field.subtype': 'Category',
    'accounts.import.field.balance': 'Balance',
    'accounts.import.field.institution': 'Institution',
    'accounts.import.field.skip': '-- Skip --',
    'accounts.import.rows': '{count} rows detected',
    'accounts.import.valid': '{count} valid',
    'accounts.import.invalid': '{count} invalid',
    'accounts.import.startImport': 'Import {count} Accounts',
    'accounts.import.back': 'Back',
    'accounts.import.next': 'Next',
    'accounts.import.close': 'Close',
    'accounts.import.done': 'Done',
    'accounts.import.tryAgain': 'Import More',
    'accounts.import.fileError': 'Could not read file. Please check the format.',
    'accounts.import.noData': 'No data found in the file',
    'accounts.import.nameRequired': 'Name is required',
    'accounts.import.downloadTemplate': 'Download Template',

    // Account Details
    'accountDetails.backToAccounts': 'Back to accounts',
    'accountDetails.realEstate.details': 'Property details',
    'accountDetails.realEstate.fees': 'Acquisition fees',
    'accountDetails.otherAsset.details': 'Asset details',
    'accountDetails.cash.currentAmount': 'Current amount',
    'accountDetails.cash.updateAmount': 'Update amount',
    'accountDetails.cash.tipTitle': 'Manual tracking',
    'accountDetails.cash.tipDesc':
      'Update this amount whenever your cash changes. It will be included in your net worth calculation.',
    'accountDetails.notFound': 'Account not found',
    'accountDetails.balanceHistory': 'Balance history',
    'accountDetails.transactions': 'Transactions',
    'accountDetails.noTransactions': 'No transactions yet',
    'accountDetails.noTransactionsDesc': 'Add your first transaction for this account',
    'accountDetails.stats.income': 'Income',
    'accountDetails.stats.expense': 'Expenses',
    'accountDetails.stats.transfersIn': 'Transfers In',
    'accountDetails.stats.transfersOut': 'Transfers Out',
    'accountDetails.stats.allTime': 'All time',

    // RIB Document
    'accountDetails.rib.title': 'Bank details (RIB)',
    'accountDetails.rib.upload': 'Upload RIB',
    'accountDetails.rib.replace': 'Replace',
    'accountDetails.rib.download': 'Download',
    'accountDetails.rib.view': 'View',
    'accountDetails.rib.delete': 'Delete',
    'accountDetails.rib.noFile': 'No RIB uploaded yet',
    'accountDetails.rib.noFileDesc': 'Upload your bank details document (PDF, max 5 MB)',
    'accountDetails.rib.uploaded': 'RIB uploaded',
    'accountDetails.rib.uploadedDesc': 'Your bank details document has been saved',
    'accountDetails.rib.deleted': 'RIB deleted',
    'accountDetails.rib.deletedDesc': 'Your bank details document has been removed',
    'accountDetails.rib.invalidType': 'Invalid file type',
    'accountDetails.rib.invalidTypeDesc': 'Please upload a PDF file',
    'accountDetails.rib.fileTooLarge': 'File too large',
    'accountDetails.rib.fileTooLargeDesc': 'Maximum file size is 5 MB',
    'accountDetails.rib.uploadError': 'Upload failed',
    'accountDetails.rib.uploadErrorDesc': 'Could not upload your document. Please try again.',
    'accountDetails.rib.deleteConfirm': 'Are you sure you want to delete this RIB?',
    'accountDetails.rib.fileName': 'RIB document',

    // Goal Allocations
    'accountDetails.goals.title': 'Goals linked to this account',
    'accountDetails.goals.realBalance': 'Real balance',
    'accountDetails.goals.allocated': 'Allocated to goals',
    'accountDetails.goals.available': 'Available',
    'accountDetails.goals.explanation':
      'Your real balance remains unchanged. A portion is simply earmarked for your goals.',
    'accountDetails.goals.allocatedFrom': 'allocated from this account',
    'accountDetails.goals.noGoals': 'No goals linked to this account yet.',

    // Transfer
    'transactions.transfer': 'Transfer',
    'transactions.filter.transfer': 'Transfer',
    'transactions.filter.allAccounts': 'All accounts',
    'transactions.filter.allCategories': 'All categories',
    'transactions.filter.nCategories': '{n} categories',
    'transactions.filter.from': 'From',
    'transactions.filter.to': 'To',
    'transactions.filter.clearDates': 'Clear dates',
    'transactions.customizeCategories': 'Customize categories',
    'transactions.stats.transfers': 'Transfers',
    'accounts.transfer': 'Transfer',
    'accounts.transferFrom': 'Transfer from this account',
    'dashboard.quickActions.transfer': 'Quick Transfer',
    'dashboard.filter.thisMonth': 'This Month',
    'dashboard.filter.lastMonth': 'Last Month',
    'dashboard.filter.last3Months': 'Last 3 Months',
    'dashboard.filter.thisYear': 'This Year',
    'dashboard.filter.allAccounts': 'All Accounts',
    'dashboard.filter.all': 'All',
    'dashboard.filter.income': 'Income',
    'dashboard.filter.expense': 'Expenses',
    'dashboard.filter.transfer': 'Transfers',
    'dashboard.goals.progress': 'saved',
    'dashboard.goals.remaining': 'remaining',
    'dashboard.goals.daysLeft': 'days left',
    // New dashboard translation keys
    'dashboard.accounts.empty': 'No accounts',
    'dashboard.accounts.add': 'Add account',
    'dashboard.distribution.title': 'Wealth Distribution',
    'dashboard.distribution.noAssets': 'No assets to display',
    'dashboard.budget.monthlyTitle': 'Monthly Budget',
    'dashboard.budget.exceeded': 'Exceeded',
    'dashboard.budget.ofIncome': 'of income',
    'dashboard.budget.availableBalance': 'Available balance',
    'dashboard.budget.expensesOverIncome': 'Expenses > Income',
    'dashboard.cashFlow.avgIncome': 'Avg income',
    'dashboard.cashFlow.avgExpenses': 'Avg expenses',
    'dashboard.cashFlow.avgBalance': 'Avg balance',
    'dashboard.cashFlow.balance': 'Balance',
    'dashboard.topCategories.topIncome': 'Top 3 Income',
    'dashboard.topCategories.noIncome': 'No income',
    'dashboard.topCategories.total': 'Total',
    'dashboard.upcomingBills.title': 'Upcoming Bills',
    'dashboard.upcomingBills.add': 'Add',
    'dashboard.upcomingBills.totalNext30Days': 'Total for next 30 days',
    'dashboard.upcomingBills.next7Days': 'Next 7 days',
    'dashboard.upcomingBills.later': 'Later',
    'dashboard.upcomingBills.viewCalendar': 'View full calendar',
    'dashboard.upcomingBills.today': 'Today',
    'dashboard.upcomingBills.tomorrow': 'Tomorrow',
    'dashboard.goals.viewAll': 'View all goals',
    'dashboard.goals.deadlinePassed': 'Deadline passed',
    'dashboard.transactions.viewAllBtn': 'View all transactions',
    'dashboard.distribution.others': 'others',
    'dashboard.period.7days': '7 days',
    'dashboard.period.30days': '30 days',
    'dashboard.period.90days': '90 days',
    'dashboard.period.overLast': 'Over the last',

    // Transaction Modal (account selection)
    'transactionModal.account': 'Account',
    'transactionModal.fromAccount': 'From account',
    'transactionModal.toAccount': 'To account',
    'transactionModal.selectAccount': 'Select account',
    'transactionModal.transferSummary': 'Transfer summary',
    'transactionModal.insufficientBalance': 'Insufficient balance',
    'transactionModal.selectDifferentAccounts': 'Select different accounts',
    'transactionModal.noAccounts': 'No accounts',
    'transactionModal.noAccountsDesc': 'Add an account first',

    // Transfer Modal
    'transfer.title': 'Quick Transfer',
    'transfer.amount': 'Amount',
    'transfer.from': 'From',
    'transfer.to': 'To',
    'transfer.swap': 'Swap',
    'transfer.quickAmounts': 'Quick amounts',
    'transfer.transferAll': 'Transfer all',
    'transfer.description': 'Description',
    'transfer.descriptionPlaceholder': 'Transfer note (optional)',
    'transfer.summary': 'Transfer summary',
    'transfer.fromAccount': 'From',
    'transfer.toAccount': 'To',
    'transfer.newBalance': 'New balance',
    'transfer.submit': 'Transfer',
    'transfer.submitting': 'Transferring...',
    'transfer.success': 'Transfer successful',
    'transfer.error': 'Transfer failed',
    'transfer.insufficientFunds': 'Insufficient funds',
    'transfer.sameAccount': 'Cannot transfer to the same account',
    'transfer.selectAccounts': 'Select both accounts',
    'transfer.selectBothAccounts': 'Please select both accounts',
    'transfer.sameAccountError': 'Cannot transfer to the same account',
    'transfer.insufficientBalance': 'Insufficient balance',
    'transfer.defaultDescription': 'Transfer',
    'transfer.selectAccount': 'Select account',
    'transfer.available': 'Available',
    'transfer.all': 'Transfer all',
    'common.optional': 'optional',
    'common.comingSoon': 'Coming soon',

    // Transaction Modal additional
    'transactionModal.selectDestination': 'Please select destination account',
    'transactionModal.sameAccountError': 'Cannot transfer between the same account',
    'transactionModal.transferDescription': 'Transfer',
    'transactions.type.transfer': 'Transfer',
    'transactionModal.selectAccountPlaceholder': 'Select account...',
    'transactionModal.availableBalance': 'Available',
    'transactionModal.selectDestinationPlaceholder': 'Select destination...',
    'transactionModal.newBalance': 'New balance',
    'transactionModal.transferDescriptionPlaceholder': 'Transfer note...',
    'transactionModal.update': 'Update',
    'transactions.noDescription': 'No description',

    // AI Assistant
    'ai.title': 'AI Assistant',
    'ai.subtitle': 'Ask me anything about your finances',
    'ai.welcome.title': 'How can I help you today?',
    'ai.welcome.description':
      'Ask me questions about your expenses, savings, or get personalized financial advice.',
    'ai.input.placeholder': 'Ask a question...',
    'ai.disclaimer': 'AI can make mistakes. Verify important information.',
    'ai.prompts.spending': 'Analyze my spending',
    'ai.prompts.savings': 'How can I save more?',
    'ai.prompts.subscriptions': 'Review my subscriptions',
    'ai.prompts.advice': 'Financial advice',
    'ai.prompts.spending_analysis.full': 'Can you analyze my spending habits this month?',
    'ai.prompts.savings_tips.full': 'How can I save more money based on my transactions?',
    'ai.prompts.subscriptions_review.full': 'Can you review my recurring subscriptions?',
    'ai.prompts.financial_advice.full': 'What financial advice would you give me based on my data?',
    'ai.placeholder.spending':
      'Based on your transactions, I can see that your main expense categories this month are... (AI integration coming soon)',
    'ai.placeholder.savings':
      'Looking at your financial patterns, here are some ways you could save more... (AI integration coming soon)',
    'ai.placeholder.budget':
      'To help you create a budget, I would analyze your income and expenses... (AI integration coming soon)',
    'ai.placeholder.subscriptions':
      "I'll review your recurring transactions to identify subscriptions... (AI integration coming soon)",
    'ai.placeholder.default':
      "I'm your personal finance assistant. I can help you analyze your spending, suggest ways to save, track your goals, and more. (Full AI integration coming soon)",
    'ai.error.generic': 'Sorry, an error occurred. Please try again.',
    'ai.error.notConfigured': 'AI assistant is not configured. Please add your API key.',

    // Footer
    'footer.tagline': 'Understand your financial situation, without stress.',
    'footer.features.title': 'Features',
    'footer.features.budget': 'Smart Budgeting',
    'footer.features.tracking': 'Transaction Tracking',
    'footer.features.wealth': 'Wealth Tracking',
    'footer.features.goals': 'Goals & Planning',
    'footer.resources.title': 'Resources',
    'footer.resources.guide': 'Getting Started',
    'footer.resources.faq': 'FAQ',
    'footer.resources.blog': 'Blog',
    'footer.resources.help': 'Help Center',
    'footer.solutions.title': 'Solutions',
    'footer.solutions.personal': 'For Personal Use',
    'footer.solutions.professionals': 'For Professionals',
    'footer.solutions.families': 'For Families',
    'footer.company.title': 'Company',
    'footer.company.about': 'About Us',
    'footer.company.careers': 'Careers',
    'footer.company.press': 'Partnerships & Press',
    'footer.company.partnerships': 'Partnerships',
    'footer.legal.title': 'Legal',
    'footer.legal.terms': 'Terms of Use',
    'footer.legal.privacy': 'Privacy Policy',
    'footer.legal.cookies': 'Cookies',
    'footer.legal.legal': 'Legal Notice',
    'footer.copyright': '© 2026 clevia. All rights reserved.',
    'press.title': 'Partnerships & Press',
    'footer.terms': 'Terms of Use',
    'footer.privacy': 'Privacy Policy',
    'footer.cookies': 'Cookies',
    'footer.legal': 'Legal Notice',

    // Pricing Page
    'nav.pricing': 'Pricing',
    'pricing.hero.title': 'Simple and Transparent Pricing',
    'pricing.hero.subtitle': 'Choose the plan that fits you best',
    'pricing.free.name': 'Free',
    'pricing.free.description': 'Perfect for starting your financial journey',
    'pricing.premium.name': 'Premium',
    'pricing.premium.description': 'Unlock your full financial potential',
    'pricing.mostPopular': 'Most Popular',
    'pricing.features.accounts': 'Account Management',
    'pricing.features.transactions': 'Transaction Tracking',
    'pricing.features.budgets': 'Budgets',
    'pricing.features.multiCurrency': 'Multi-Currency',
    'pricing.features.reports': 'Advanced Reports',
    'pricing.features.aiChat': 'AI Assistant',
    'pricing.features.goals': 'Financial Goals',
    'pricing.features.recurring': 'Recurring Transactions',
    'pricing.highlights.fast': 'Fast and Reliable',
    'pricing.highlights.fastDesc': 'Instant synchronization of your financial data',
    'pricing.highlights.secure': 'Secure',
    'pricing.highlights.secureDesc': 'Your data is encrypted and protected',
    'pricing.highlights.analytics': 'Deep Analytics',
    'pricing.highlights.analyticsDesc': 'Understand your spending habits',
    'pricing.highlights.ai': 'Powered by AI',
    'pricing.highlights.aiDesc': 'Personalized advice based on AI',
    'pricing.whyChoose': 'Why Choose clevia?',
    'pricing.whyChooseDesc': 'We offer the best tools for your financial management',
    'pricing.faq': 'Frequently Asked Questions',
    'pricing.faqQ1': 'Can I change plans later?',
    'pricing.faqA1': 'Yes, you can upgrade or downgrade your plan anytime.',
    'pricing.faqQ2': 'Is there a free trial?',
    'pricing.faqA2': 'Yes, the Free plan offers access to all basic features with no time limit.',
    'pricing.faqQ3': 'How is my security ensured?',
    'pricing.faqA3': 'We use end-to-end encryption and the highest industry security standards.',
    'pricing.ctaTitle': 'Ready to take control?',
    'pricing.ctaDesc': 'Start for free today, no credit card required.',
    'pricing.learnMore': 'Learn More',
    'nav.dashboard': 'Dashboard',
    'nav.upgrade': 'Upgrade to Premium',

    // Powens (bank aggregation)
    'powens.connectBank': 'Connect my bank automatically',
    'powens.connectBankDesc': 'Connect your bank account directly, with no manual entry.',
    'powens.connecting': 'Redirecting to your bank\u2026',
    'powens.syncing': 'Connecting and preparing your account\u2026',
    'powens.syncingHint': 'This can take up to a minute on a first connection.',
    'powens.successTitle': 'Bank connected',
    'powens.accountReady': 'account ready',
    'powens.errorTitle': 'Connection failed',
    'powens.scaRequired':
      'Your bank is asking for an extra authentication. Please start the connection again.',
    'powens.cancelled': 'Connection cancelled.',
    'powens.retry': 'Try again',
    'powens.backToAccounts': 'Back to my accounts',

    'powens.pendingTitle': 'Your bank is still responding',
    'powens.pendingDesc':
      'Powens is still fetching your data. It lands on its own in a moment \u2014 no need to start over.',

    'powens.importing': 'Import in progress',
    'powens.importingDesc': 'Your bank is sending its data. This usually takes under a minute.',
    'powens.actionRequired': 'Action required',
    'powens.actionRequiredDesc': 'Your bank needs you to confirm the connection.',
    'powens.reconnect': 'Reconnect',

    'powens.noHistoryNote': 'Your connected banks only import transactions dated from',

    'transactions.pending': 'Pending',

    'powens.refreshBanks': 'Refresh banks',
    'powens.refreshStarted': 'Refresh started',
    'powens.refreshStartedDesc':
      'Your banks are being contacted. New operations appear on their own within a minute.',

    'bankSync.disable': 'Turn off bank sync',
    'bankSync.settingsTitle': 'Bank synchronisation',
    'bankSync.settingsDesc': '{count} accounts are updated by your bank on their own.',
    'bankSync.settingsDescOne': '{count} account is updated by your bank on its own.',
    'bankSync.title': 'Bank synchronisation is about to be turned off',
    'bankSync.desc':
      'Your accounts, your balances and all your transactions are kept. Only the automatic update from your bank stops.',
    'bankSync.keptAccounts': '{count} accounts switch to manual, with their name and their history',
    'bankSync.keptAccountsOne': '{count} account switches to manual, with its name and its history',
    'bankSync.keptTransactions': 'No transaction is deleted',
    'bankSync.keptBalance':
      'The last synced balance becomes the starting point you keep up yourself',
    'bankSync.keptReconnect': 'You can sync these accounts again later, with no duplicate',
    'bankSync.confirm': 'Switch my accounts to manual',
    'bankSync.cancel': 'Cancel',
    'bankSync.doneTitle': 'Your accounts are now manual',
    'bankSync.doneDesc':
      'Nothing was deleted. From now on, simply add your new transactions yourself to keep your balances up to date.',
    'bankSync.doneClose': 'Got it',
    'bankSync.failed': 'Could not turn bank sync off. Try again in a moment.',
    'accounts.synced': 'Synced',
    'accounts.syncedHint': 'Balance and transactions come from your bank, on their own.',
    'accounts.manualSource': 'Manual account',
    'accounts.manualSourceHint': 'You keep this account up to date yourself.',
    'accountLink.menu': 'Sync with my bank',
    'accountLink.introTitle': 'Sync "{name}" with your bank',
    'accountLink.introDesc':
      'You are about to connect the bank this account is held at, so it updates on its own.',
    'accountLink.introStep1': 'You sign in at your bank, through our licensed partner.',
    'accountLink.introStep2': 'You pick the bank account that is "{name}".',
    'accountLink.introStep3':
      'That account keeps its name, its history and its goals. No second account is created.',
    'accountLink.chooseBank': 'Choose my bank',
    'accountLink.otherBank': 'Another bank',
    'accountLink.cancel': 'Cancel',
    'accountLink.alreadyConnected': 'This bank account is already connected to clevia.',
    'accountLink.previousAccount': 'The account this one was synced with',
    'accountLink.blockedType': 'Not the same kind of account.',
    'accountLink.blockedCurrency': 'Held in another currency.',
    'accountLink.syncingDesc': 'Its accounts appear here on their own, usually within a minute.',
    'accountLink.noBankAccounts': 'No account came through',
    'accountLink.noBankAccountsDesc':
      'Your bank shared no account we can use. Check what you shared during the connection, or try another bank.',
    'accountLink.chooseTitle': 'Which bank account is it?',
    'accountLink.chooseDesc':
      'Here is what your bank just handed over. Pick the one that is "{name}".',
    'accountLink.syncing': 'Your bank is still sending its accounts\u2026',
    'accountLink.continue': 'Continue',
    'accountLink.back': 'Back',
    'accountLink.reviewTitle': 'Check before linking',
    'accountLink.balance': 'Balance',
    'accountLink.balanceHint': 'Your bank balance replaces the one entered by hand.',
    'accountLink.bankTransactions': '{count} bank transactions attached, from {date}',
    'accountLink.bankTransactionsOne': '{count} bank transaction attached, from {date}',
    'accountLink.merged': '{count} duplicates merged, keeping your category',
    'accountLink.mergedOne': '{count} duplicate merged, keeping your category',
    'accountLink.recurring': '{count} recurring transactions paused',
    'accountLink.recurringOne': '{count} recurring transaction paused',
    'accountLink.historyKept': 'Your history before {date} stays as it is',
    'accountLink.unmatchedTitle': '{count} entries not found at your bank',
    'accountLink.unmatchedTitleOne': '{count} entry not found at your bank',
    'accountLink.unmatchedDesc':
      'Entered by hand since {date}, they are kept. Check them: a typo in an amount would make a duplicate.',
    'accountLink.unmatchedDescOne':
      'Entered by hand since {date}, it is kept. Check it: a typo in an amount would make a duplicate.',
    'accountLink.confirm': 'Link account',
    'accountLink.successTitle': 'Account linked',
    'accountLink.successDesc': '"{name}" now updates from your bank.',
    'accountLink.finish': 'Finish linking',
    'accountLink.failed': 'Linking failed',
    'accountLink.error.link_account_not_found': 'This account no longer exists.',
    'accountLink.error.link_not_manual': 'This account is already linked to a bank.',
    'accountLink.error.link_not_aggregated': 'This bank account can no longer be chosen.',
    'accountLink.error.link_already_linked': 'This bank account is already connected to clevia.',
    'accountLink.error.link_type_mismatch':
      'An asset cannot be linked to a debt, or the other way round.',
    'accountLink.error.link_currency_mismatch': 'The two accounts are not in the same currency.',
    'accountLink.disconnect': 'Disconnect bank',
    'accountLink.disconnectTitle': 'Disconnect your bank?',
    'accountLink.disconnectLinkedDesc':
      '"{name}" becomes a manual account again. Its whole history is kept, but its balance will no longer update by itself.',
    'accountLink.disconnectDesc':
      '"{name}" and the transactions imported from your bank will be removed from Clevia.',
    'accountLink.disconnectConfirm': 'Disconnect',
    'accountLink.disconnected': 'Bank disconnected',
    'accountLink.disconnectFailed': 'Disconnection failed',

    // Common
    'common.currency': 'MAD',
  },
  fr: {
    // MVP Banner
    'mvpBanner.message':
      "clevia est un MVP en évolution — de nouvelles fonctionnalités sont ajoutées régulièrement. Merci de faire partie de l'aventure.",

    // Navigation
    'nav.login': 'Connexion',
    'nav.register': "S'inscrire",
    'nav.logout': 'Déconnexion',

    // Home Page
    'home.tagline': 'Votre argent, enfin plus simple',
    'home.hero.title1': "L'outil simple pour votre budget aujourd'hui,",
    'home.hero.title2': 'et votre vie demain',
    'home.hero.description':
      'Toutes les fonctionnalités essentielles pour gérer votre argent simplement, sans complexité inutile.',
    'home.cta.start': 'Commencer gratuitement',
    'home.cta.demo': 'Rencontrer les fondateurs',
    'home.trust.encrypted': 'Sans engagement',
    'home.trust.free': 'Mise en place en 2 minutes',
    'home.trust.rating': '5.0 sur 2000+ utilisateurs',
    'home.trust.eu': 'Données hébergées dans l’UE',
    'home.banks.eyebrow': 'Suivez les comptes des banques que vous utilisez déjà',
    'home.mock.tab.overview': 'Aperçu',
    'home.mock.tab.assets': 'Actifs',
    'home.mock.tab.budget': 'Budget',
    'home.mock.totalWealth': 'Patrimoine total',
    'home.mock.thisMonth': 'ce mois',
    'home.mock.monthlyBudget': 'Budget mensuel',
    'home.mock.asset.bank': 'Comptes bancaires',
    'home.mock.asset.savings': 'Livret',
    'home.mock.asset.crypto': 'Crypto',
    'home.mock.asset.stocks': 'Actions & PEA',
    'home.mock.asset.realEstate': 'Immobilier',
    'home.mock.budget.food': 'Alimentation',
    'home.mock.budget.transport': 'Transport',
    'home.mock.budget.shopping': 'Shopping',
    'home.mock.budget.leisure': 'Loisirs',
    'home.mock.notification.today': "Aujourd'hui",
    'home.mock.notification.goal': 'Vacances Maroc',
    'home.mock.notification.reached': 'atteint',
    'home.mock.caption':
      'Un aperçu du tableau de bord clevia. Données d’exemple, présentées à titre d’illustration.',
    'home.mock.overBudget': 'Dépassement de',

    'home.whatIs.title': "C'est quoi clevia ?",
    'home.whatIs.intro':
      'clevia est une application simple pour voir et comprendre votre argent, sans stress ni complication.',
    'home.whatIs.block1.title': 'Votre patrimoine, centralisé',
    'home.whatIs.block1.desc':
      'Vos comptes, vos économies, vos investissements et même vos objets de valeur apparaissent dans une seule vue claire. Vous voyez combien vous avez au total et comment votre argent évolue.',
    'home.whatIs.block2.title': 'Votre budget au quotidien',
    'home.whatIs.block2.desc':
      "Vous suivez vos revenus, vos dépenses et ce qu'il vous reste en temps réel. Vous savez exactement où va votre argent et vous pouvez ajuster simplement.",
    'home.story.1.b1': 'Tous vos comptes réunis dans une seule vue',
    'home.story.1.b2': 'Le total de votre patrimoine, toujours à jour',
    'home.story.1.b3': 'Crypto, actions et immobilier compris',
    'home.story.2.b1': 'Vos dépenses classées par catégorie',
    'home.story.2.b2': 'Une alerte claire dès qu’un budget est dépassé',
    'home.story.2.b3': 'Ce qu’il vous reste à dépenser, en temps réel',
    'home.story.3.b1': 'Un objectif par projet, à votre rythme',
    'home.story.3.b2': 'Une progression lisible d’un coup d’œil',
    'home.story.3.b3': 'Des versements que vous ajustez quand vous voulez',
    'home.whatIs.block4.title': 'Vos catégories, à votre façon',
    'home.whatIs.block4.desc':
      'Personne ne dépense comme vous. Créez, renommez et réorganisez vos catégories pour que votre budget parle votre langue.',
    'home.story.4.b1': 'Créez vos propres catégories en un clic',
    'home.story.4.b2': 'Renommez ou regroupez celles fournies par défaut',
    'home.story.4.b3': 'Un budget mensuel par catégorie, si vous le souhaitez',
    'home.story.4.visualLabel': 'Vos catégories',
    'home.story.4.custom': 'Famille au Maroc',
    'home.story.4.badge': 'Perso',
    'home.story.4.add': 'Ajouter une catégorie',

    'home.whyDifferent.title': 'Pourquoi clevia est différente ?',
    'home.whyDifferent.subtitle':
      'Créée par Mehdi & Marouane qui voulaient enfin une application financière simple et claire.',
    'home.whyDifferent.1.title': 'Fondée par deux personnes',
    'home.whyDifferent.1.desc':
      'Pas une grande entreprise. Accessible, humaine, proche de ses utilisateurs.',
    'home.whyDifferent.2.title': 'Indépendante',
    'home.whyDifferent.2.desc': "Bootstrappée. Pas d'investisseurs qui dictent les choix produit.",
    'home.whyDifferent.3.title': 'Simplicité avant tout',
    'home.whyDifferent.3.desc': 'Pas de jargon financier. Pas de fonctionnalités inutiles.',
    'home.whyDifferent.4.title': 'Construite avec les utilisateurs',
    'home.whyDifferent.4.desc': 'Les retours influencent directement les améliorations.',
    'home.whyDifferent.cta': 'Rencontrer les fondateurs',
    'home.whatIs.bank': 'Comptes bancaires',
    'home.whatIs.savings': "Comptes d'épargne",
    'home.whatIs.realEstate': 'Immobilier',
    'home.whatIs.crypto': 'Crypto',
    'home.whatIs.stocks': 'Actions & PEA',
    'home.whatIs.watches': 'Montres & Bijoux',
    'home.whatIs.metals': 'Métaux précieux',

    'home.assets.title': "Suivez chaque type d'actif",
    'home.assets.subtitle':
      'De votre compte bancaire à votre collection de montres — clevia centralise tout votre patrimoine.',
    'home.assets.bank': 'Comptes bancaires',
    'home.assets.crypto': 'Crypto',
    'home.assets.pea': 'Actions & PEA',
    'home.assets.realEstate': 'Immobilier',
    'home.assets.watches': 'Montres & Bijoux',
    'home.assets.metals': 'Métaux précieux',
    'home.stats.assetTypes': "Types d'actifs suivis",
    'home.stats.features': 'Fonctionnalités intégrées',
    'home.stats.freeForever': 'Gratuit pour toujours',
    'home.section.patrimoine': 'L’ESSENTIEL',
    'home.section.different': 'Unique',
    'home.section.features': 'Fonctionnalités',
    'home.section.guide': 'Guide',
    'home.section.faq': 'FAQ',
    'home.features.title': 'Fini les papiers et les fichiers Excel perdus',
    'home.features.subtitle':
      'clevia remplace les feuilles éparpillées et les tableaux compliqués par un espace simple et clair pour suivre votre argent. Tout est au même endroit, toujours à jour, sans stress et sans risque de tout perdre.',
    'home.feature.tracking.title': "Vue d'ensemble",
    'home.feature.tracking.desc':
      'Voyez tous vos actifs sur un seul tableau de bord. Soldes bancaires, prix crypto, valeurs actions, estimations immobilières - toujours à jour.',
    'home.feature.security.title': 'Sécurité bancaire',
    'home.feature.security.desc':
      "Vos données sont chiffrées de bout en bout avec l'infrastructure Supabase. Nous ne stockons jamais vos identifiants bancaires.",
    'home.feature.ai.title': 'Assistant IA',
    'home.feature.ai.desc':
      "Posez des questions sur vos finances en langage naturel. Obtenez des analyses, résumés et suggestions intelligentes propulsées par l'IA.",
    'home.feature.goals.title': "Objectifs d'épargne",
    'home.feature.goals.desc':
      "Fixez des objectifs pour vos vacances, fonds d'urgence ou prochain investissement. Suivez visuellement vos progrès et restez motivé.",
    'home.feature.multi.title': 'Multi-devises',
    'home.feature.multi.desc':
      "Suivez vos actifs en EUR, USD, MAD et CAD. clevia s'adapte à votre réalité financière où que vous soyez.",
    'home.feature.responsive.title': 'Utilisez partout',
    'home.feature.responsive.desc':
      'Fonctionne parfaitement sur desktop, tablette et mobile. Vos finances vous accompagnent, toujours accessibles.',
    'home.howItWorks.title': 'Prêt en quelques minutes',
    'home.howItWorks.subtitle':
      'Pas de configuration compliquée. Inscrivez-vous et commencez tout de suite.',
    'home.steps.1.title': 'Créez votre compte gratuitement',
    'home.steps.1.desc':
      "Inscrivez-vous avec votre email. Pas de carte bancaire. Pas d'engagement.",
    'home.steps.2.title': 'Ajoutez ce que vous possédez',
    'home.steps.2.desc': 'Vos comptes, vos économies, vos projets. Tout au même endroit.',
    'home.steps.3.title': 'Suivez simplement votre argent',
    'home.steps.3.desc':
      'Voyez combien vous avez, ce que vous dépensez et avancez vers vos objectifs.',
    'home.faq.title': 'Questions fréquentes',
    'home.faq.subtitle': 'Tout ce que vous devez savoir sur clevia',
    'home.faq.1.q': 'clevia est-il vraiment gratuit ?',
    'home.faq.1.a':
      'Oui, vous pouvez utiliser gratuitement les fonctionnalités essentielles de clevia. Et si vous souhaitez aller plus loin, une offre Premium vous donne accès à des fonctionnalités supplémentaires.',
    'home.faq.2.q': 'Dois-je connecter mon compte bancaire ?',
    'home.faq.2.a':
      'Non. clevia fonctionne avec la saisie manuelle, ce qui vous donne un contrôle total sur vos données. Vous ajoutez vos comptes et transactions vous-même. Pour la crypto et les actions, nous récupérons les prix du marché automatiquement.',
    'home.faq.3.q': 'Mes données sont-elles sécurisées ?',
    'home.faq.3.a':
      'Oui. Vos données sont protégées et hébergées au sein de l’Union européenne, comme indiqué dans nos mentions légales. Chaque utilisateur ne peut accéder qu’à ses propres données, et nous ne stockons jamais vos identifiants bancaires.',
    'home.faq.4.q': "Quels types d'actifs puis-je suivre ?",
    'home.faq.4.a':
      'Comptes bancaires, épargne, crypto (avec prix CoinGecko en direct), PEA/actions (CAC 40, ETFs avec données Yahoo Finance), immobilier, montres & bijoux, métaux précieux, et plus à venir.',
    'home.faq.5.q': 'Puis-je utiliser clevia en plusieurs langues ?',
    'home.faq.5.a':
      'Oui ! clevia est entièrement disponible en français et en anglais. Vous pouvez changer de langue à tout moment depuis les paramètres ou directement depuis la page d’accueil. Si vous souhaitez d’autres langues, contactez les fondateurs. Nous en ajouterons progressivement à mesure que clevia grandit.',
    'home.faq.6.q': 'Puis-je échanger avec les fondateurs de clevia ?',
    'home.faq.6.a':
      "Oui. Si vous avez une question, une suggestion ou simplement envie d'échanger, vous pouvez nous écrire à founders@cleviaapp.com. Nous lisons chaque message et nous aimons discuter avec les personnes qui utilisent clevia.",
    'home.cta.final.title': 'Votre nouvelle vie financière commence ici.',
    'home.cta.final.subtitle':
      "Gérez votre budget aujourd'hui. Construisez votre patrimoine demain. Gratuit, simple, sans engagement.",
    'home.cta.final.button': 'Créer mon compte gratuit',
    'home.cta.final.noCreditCard': '',
    'home.footer.rights': '© 2026 clevia. Tous droits réservés.',

    // Founders Page
    'founders.title': 'Nos Fondateurs',
    'founders.subtitle': 'Contenu à venir...',

    // Navigation Header (Landing)
    'header.features': 'Fonctionnalités',
    'header.resources': 'Ressources',
    'header.solutions': 'Solutions',
    'header.company': 'Qui sommes-nous',
    'header.pricing': 'Tarifs',

    // Fonctionnalités Menu
    'header.features.daily': 'Gestion quotidienne',
    'header.features.budget.title': 'Budget intelligent',
    'header.features.budget.desc': 'Suivez revenus, dépenses et solde restant en temps réel',
    'header.features.transactions.title': 'Transactions simplifiées',
    'header.features.transactions.desc': 'Ajoutez, filtrez et analysez vos opérations facilement',
    'header.features.rules.title': 'Règles automatiques',
    'header.features.rules.desc': 'Classement intelligent et automatisation',
    'header.features.calendar.title': 'Calendrier des récurrences',
    'header.features.calendar.desc': 'Visualisez abonnements et paiements futurs',
    'header.features.multiCurrency.title': 'Comptes multi-devises',
    'header.features.multiCurrency.desc': 'Gérez MAD, EUR, USD, CAD sans confusion',

    'header.features.vision': 'Vision globale',
    'header.features.wealth.title': 'Patrimoine total consolidé',
    'header.features.wealth.desc': 'Vue unifiée de tous vos comptes',
    'header.features.conversion.title': 'Conversion live multi-devises',
    'header.features.conversion.desc': 'Patrimoine recalculé automatiquement',
    'header.features.cashflow.title': 'Flux de trésorerie',
    'header.features.cashflow.desc': 'Revenus vs dépenses visuellement sur 6 mois',
    'header.features.topspending.title': 'Top dépenses & revenus',
    'header.features.topspending.desc': 'Identifiez vos postes clés instantanément',
    'header.features.analysis.title': 'Analyse mensuelle intelligente',
    'header.features.analysis.desc': 'Évolution € + % vs période précédente',

    'header.features.strategy': 'Objectifs & Stratégie',
    'header.features.goals.title': "Objectifs d'épargne intelligents",
    'header.features.goals.desc': "Suivi + prédiction d'atteinte",
    'header.features.allocation.title': 'Allocation virtuelle',
    'header.features.allocation.desc': 'Affectez votre argent sans le bloquer',
    'header.features.debts.title': 'Gestion des dettes',
    'header.features.debts.desc': 'Planifiez et optimisez vos remboursements',
    'header.features.method.title': 'Méthode 50/30/20',
    'header.features.method.desc': 'Structurez vos finances simplement',
    'header.features.ai.title': 'Assistant IA',
    'header.features.ai.desc': 'Insights automatiques basés sur vos données',

    'header.resources.learn': 'Apprendre',
    'header.resources.guide.title': 'Guide de démarrage',
    'header.resources.guide.desc': 'Démarrage rapide',
    'header.resources.method.title': 'Méthode 50/30/20',
    'header.resources.method.desc': 'Découvrez la méthode éprouvée',
    'header.resources.blog.title': 'Blog clevia',
    'header.resources.blog.desc': 'Conseils et éducation financière',

    // Blog Page
    'blog.empty': 'Aucun article disponible pour le moment.',
    'header.resources.support': 'Aide & Sécurité',
    'header.resources.help.title': "Centre d'aide",
    'header.resources.help.desc': 'FAQ et support',
    'help.title': 'Besoin d’aide avec clevia ?',
    'help.tutorial':
      'Un tutoriel de prise en main est disponible dès la création de votre compte pour vous guider dans les principales fonctionnalités de clevia.',
    'help.dashboard': 'Ce tutoriel reste accessible ensuite depuis votre Dashboard.',
    'help.contact':
      'Besoin d’aide supplémentaire ? Mehdi & Marouane restent disponibles directement par email.',
    'help.contactButton': 'Nous contacter',
    'header.resources.security.title': 'Sécurité & Confidentialité',
    'header.resources.security.desc': 'En savoir plus sur la protection des données',
    'header.resources.notifications.title': 'Notifications & Alertes',
    'header.resources.notifications.desc': 'Restez informé de vos finances',
    'header.resources.faq.title': 'FAQ',
    'header.resources.faq.desc': 'Questions fréquemment posées',
    'header.resources.contact.title': 'Contacter le support',
    'support.contactSupport': 'Contacter le support',
    'support.contactOrSuggest': 'Aide & Support',
    'support.suggestIdea': 'Proposer une idée',
    'feedback.title': 'Aide & Support',
    'feedback.description': 'Dis-nous ce dont tu as besoin et aide-nous à améliorer clevia.',
    'feedback.tabs.support': 'Support',
    'feedback.tabs.idea': 'Idée de fonctionnalité',
    'feedback.helper.support': 'Décris ton problème et nous te répondrons dès que possible.',
    'feedback.helper.idea': 'Partage une idée qui pourrait améliorer ton quotidien avec clevia.',
    'feedback.subject': 'Sujet',
    'feedback.subjectPlaceholder.support': 'ex. Problème avec un compte',
    'feedback.subjectPlaceholder.idea': 'ex. Ajouter une comparaison mensuelle',
    'feedback.message': 'Message',
    'feedback.messagePlaceholder.support': 'Décris ton problème en détail...',
    'feedback.messagePlaceholder.idea': 'Explique-nous en quoi cette fonctionnalité t’aiderait...',
    'feedback.addAttachment': 'Ajouter une pièce jointe',
    'feedback.removeAttachment': 'Supprimer la pièce jointe',
    'feedback.attachmentTooLarge': 'Le fichier est trop volumineux (5 Mo maximum).',
    'feedback.cancel': 'Annuler',
    'feedback.sending': 'Envoi...',
    'feedback.submit.support': 'Envoyer le message',
    'feedback.submit.idea': 'Envoyer l’idée',
    'feedback.successTitle': 'Merci pour ton message !',
    'feedback.successDescription': 'Ton retour a bien été envoyé à l’équipe clevia.',
    'feedback.close': 'Fermer',
    'header.resources.contact.desc': "Obtenez de l'aide de notre équipe",

    'header.solutions.particulars': 'Pour les particuliers',
    'header.solutions.students.title': 'Pour les étudiants',
    'header.solutions.students.desc': 'Gérez votre budget étudiant',
    'header.solutions.young.title': 'Jeunes actifs & Alternants',
    'header.solutions.young.desc': 'Commencez à construire votre richesse',
    'header.solutions.couples.title': 'Couples',
    'header.solutions.couples.desc': 'Gérez vos finances ensemble',
    'header.solutions.mre.title': "Résidents à l'étranger",
    'header.solutions.mre.desc': 'Centralisez vos finances entre deux pays',

    'header.solutions.professionals': 'Pour les professionnels',
    'header.solutions.freelancers.title': 'Indépendants',
    'header.solutions.freelancers.desc': 'Suivez votre revenu variable',
    'header.solutions.consultants.title': 'Consultants',
    'header.solutions.consultants.desc': 'Gérez vos clients et projets',
    'header.solutions.creators.title': 'Créateurs de contenu',
    'header.solutions.creators.desc': 'Monétisez votre contenu',
    'header.solutions.coaches.title': 'Coaches financiers',
    'header.solutions.coaches.desc': 'Aidez vos clients à croître',

    'header.company.transparency': 'Transparence',
    'header.company.founders.title': 'Fondateurs',
    'header.company.founders.desc': 'Mehdi & Marouane',
    'header.company.mission.title': 'Notre Mission',
    'header.company.mission.desc': 'Simplifier les finances pour tous',
    'header.company.vision.title': 'Notre Vision',
    'header.company.vision.desc': 'Démocratiser la gestion de patrimoine',
    'header.company.careers.title': 'Carrières',
    'header.company.careers.desc': 'Rejoignez notre équipe',
    'header.company.press.title': 'Partenariats & Presse',
    'header.company.press.desc': 'Médias et actualités',
    'header.company.blog.title': 'Blog',
    'header.company.blog.desc': 'Articles et histoires',
    'header.company.legal.title': 'Mentions légales',
    'header.company.legal.desc': "Conditions d'utilisation",
    'header.company.privacy.title': 'Politique de confidentialité',
    'header.company.privacy.desc': 'Protection de vos données',
    'header.company.contact.title': 'Nous contacter',
    'header.company.contact.desc': 'Prenez contact avec nous',

    // Auth Pages
    'auth.login.title': 'Connexion à votre compte',
    'auth.login.subtitle': 'Bienvenue ! Veuillez entrer vos identifiants',
    'auth.login.email': 'Email',
    'auth.login.password': 'Mot de passe',
    'auth.login.forgotPassword': 'Mot de passe oublié ?',
    'auth.login.rememberMe': 'Rester connecté pendant 30 jours',
    'auth.login.submit': 'Se connecter',
    'auth.login.loading': 'Connexion...',
    'auth.login.noAccount': 'Pas encore de compte ?',
    'auth.login.signup': "S'inscrire",
    'auth.login.security': '🔒 Connexion sécurisée',
    'auth.register.title': 'Créer un compte',
    'auth.register.subtitle': 'Commencez gratuitement en 2 minutes',
    'auth.register.name': 'Nom complet',
    'auth.register.email': 'Email',
    'auth.register.password': 'Mot de passe',
    'auth.register.confirmPassword': 'Confirmer le mot de passe',
    'auth.register.submit': 'Créer mon compte',
    'auth.register.loading': 'Création du compte...',
    'auth.register.hasAccount': 'Déjà un compte ?',
    'auth.register.login': 'Se connecter',
    'auth.register.benefit1': 'Suivi en temps réel de vos finances',
    'auth.register.benefit2': 'Dashboards et analyses BI',
    'auth.register.benefit3': 'Sécurité bancaire de niveau entreprise',
    'auth.register.benefit4': 'Gratuit pour toujours',
    'auth.register.hero.title': 'Prenez le contrôle de vos finances',
    'auth.register.hero.subtitle':
      'Rejoignez plus de 150 000 utilisateurs qui ont transformé leur vie financière',
    'auth.backHome': "Retour à l'accueil",

    // Dashboard
    'dashboard.welcome': 'Bon retour',
    'dashboard.customize': 'Personnaliser',
    'dashboard.greeting': 'Bonjour',
    'dashboard.subtitle': "Voici un aperçu de vos finances aujourd'hui",
    'dashboard.nav.dashboard': 'Dashboard',
    'dashboard.nav.transactions': 'Transactions',
    'dashboard.nav.budgets': 'Budgets',
    'dashboard.nav.categories': 'Catégories',
    'dashboard.nav.planning': 'Planification',
    'dashboard.nav.settings': 'Paramètres',
    'dashboard.nav.logout': 'Déconnexion',
    'sidebar.hideAmounts': 'Masquer les montants',
    'sidebar.showAmounts': 'Afficher les montants',
    'sidebar.collapse': 'Réduire la barre latérale',
    'sidebar.expand': 'Agrandir la barre latérale',
    'dashboard.stats.totalBudget': 'Budget Total',
    'dashboard.stats.expenses': 'Dépenses',
    'dashboard.stats.income': 'Revenus',
    'dashboard.stats.savings': 'Épargne',
    'dashboard.stats.thisMonth': 'Ce mois-ci',
    'dashboard.budget.title': 'Budget',
    'dashboard.budget.expenses': 'Dépenses',
    'dashboard.budget.income': 'Revenus',
    'dashboard.budget.fixed': 'Fixes',
    'dashboard.budget.flexible': 'Variables',
    'dashboard.budget.nonMonthly': 'Non-Mensuels',
    'dashboard.budget.spent': 'dépensé',
    'dashboard.budget.remaining': 'restant',
    'dashboard.netWorth.title': 'patrimoine net',
    'dashboard.netWorth.days7': '7 jours',
    'dashboard.netWorth.days30': '30 jours',
    'dashboard.netWorth.days90': '90 jours',
    'dashboard.netWorth.overPeriod': 'Sur les',
    'dashboard.spending.title': 'Dépenses',
    'dashboard.spending.other': 'Autres',
    'dashboard.spending.top5': 'Top 5 des dépenses',
    'dashboard.spending.thisMonth': 'ce mois-ci',
    'dashboard.spending.lastMonth': 'Mois dernier',
    'dashboard.goals.title': 'Objectifs',
    'dashboard.goals.subtitle': 'Vos 3 principales priorités',
    'dashboard.goals.empty': 'Aucun objectif défini',
    'dashboard.goals.add': 'Ajouter un objectif',
    'dashboard.transactions.title': 'Transactions',
    'dashboard.transactions.recent': 'Les plus récentes',
    'dashboard.transactions.all': 'Toutes les transactions',
    'dashboard.transactions.viewAll': 'Voir tout →',
    'dashboard.transactions.empty': 'Aucune transaction pour le moment',
    'dashboard.transactions.add': 'Ajouter une transaction',
    'dashboard.transactions.today': "Aujourd'hui",
    'dashboard.transactions.yesterday': 'Hier',
    'dashboard.recurring.title': 'Récurrentes',
    'dashboard.recurring.due': 'restantes dues',
    'dashboard.recurring.thisMonth': 'Ce mois-ci',
    'dashboard.recurring.empty': 'Aucune transaction à venir pour cette période',
    'dashboard.recurring.emptyDesc': 'Ajoutez des transactions récurrentes pour les voir ici',
    'dashboard.recurring.add': 'Ajouter récurrente',
    'dashboard.recurring.addButton': 'Ajouter',
    'dashboard.recurring.next7Days': 'Prochains 7 jours',
    'dashboard.recurring.later': 'Plus tard',
    'dashboard.recurring.total30Days': 'Total sur 30 jours',
    'dashboard.recurring.expenses': 'Dépenses:',
    'dashboard.recurring.income': 'Revenus:',
    'dashboard.recurring.viewCalendar': 'Voir le calendrier complet',
    'dashboard.recurring.today': "Aujourd'hui",
    'dashboard.recurring.tomorrow': 'Demain',

    // Recurring Modal
    'recurring.create': 'Nouvelle transaction récurrente',
    'recurring.edit': 'Modifier transaction récurrente',
    'recurring.expense': 'Dépense',
    'recurring.income': 'Revenu',
    'recurring.description': 'Description',
    'recurring.descriptionPlaceholder': 'Netflix, Loyer, Salaire...',
    'recurring.amount': 'Montant',
    'recurring.frequency': 'Fréquence',
    'recurring.frequency.daily': 'Quotidien',
    'recurring.frequency.weekly': 'Hebdo',
    'recurring.frequency.monthly': 'Mensuel',
    'recurring.frequency.yearly': 'Annuel',
    'recurring.startDate': 'Date de début',
    'recurring.endDate': 'Date de fin',
    'recurring.optional': 'optionnel',
    'recurring.category': 'Catégorie',
    'recurring.selectCategory': 'Sélectionner une catégorie',
    'recurring.account': 'Compte',
    'recurring.selectAccount': 'Sélectionner un compte',
    'recurring.cancel': 'Annuler',
    'recurring.save': 'Enregistrer',
    'recurring.saving': 'Enregistrement...',
    'recurring.delete': 'Supprimer',
    'recurring.deleteConfirm': 'Êtes-vous sûr de vouloir supprimer cette transaction récurrente ?',
    'recurring.pause': 'Mettre en pause',
    'recurring.resume': 'Reprendre',
    'recurring.nextOccurrence': 'Prochaine occurrence',

    'dashboard.accounts': 'comptes',
    'dashboard.noData': 'Aucune donnée disponible',
    'dashboard.noExpenses': 'Aucune dépense ce mois-ci',
    'dashboard.cashFlow.title': 'Flux de trésorerie',
    'dashboard.cashFlow.subtitle': 'Revenus vs dépenses sur les 6 derniers mois',
    'dashboard.quickActions.title': 'Actions rapides',
    'dashboard.quickActions.subtitle': 'Allez plus vite',
    'dashboard.quickActions.addTransaction': 'Ajouter Transaction',
    'dashboard.quickActions.viewAccounts': 'Voir Comptes',
    'dashboard.quickActions.viewGoals': 'Voir Objectifs',
    'dashboard.quickActions.setBudget': 'Définir Budget',
    'dashboard.quickActions.newTransaction': 'Nouvelle transaction',
    'dashboard.quickActions.createBudget': 'Créer un budget',
    'dashboard.quickActions.manageCategories': 'Gérer catégories',
    'dashboard.quickActions.viewAnalytics': 'Voir analytics',
    'dashboard.getStarted.title': 'Commencez maintenant',
    'dashboard.getStarted.step1': 'Compte créé avec succès',
    'dashboard.getStarted.step1Desc': 'Vous êtes prêt à démarrer',
    'dashboard.getStarted.step2': 'Créer votre premier budget',
    'dashboard.getStarted.step2Desc': 'Définissez vos objectifs financiers',
    'dashboard.getStarted.step3': 'Ajouter des transactions',
    'dashboard.getStarted.step3Desc': 'Suivez vos revenus et dépenses',
    'dashboard.getStarted.step4': 'Configurer les catégories',
    'dashboard.getStarted.step4Desc': 'Organisez vos dépenses',

    // Goals Page
    'goals.title': 'Objectifs',
    'goals.subtitle': 'Suivez vos objectifs financiers',
    'goals.addGoal': 'Ajouter un objectif',
    'goals.emptyTitle': 'Suivez les objectifs qui comptent pour vous',
    'goals.emptyDesc':
      "Utilisez des comptes liés pour suivre votre épargne, remboursement de dettes et objectifs d'investissement.",
    'goals.getStarted': 'Commencer',
    'goals.addNew': 'Ajouter un nouvel objectif',
    'goals.chooseType': "Choisir le type d'objectif",
    'goals.customizeGoal': 'Personnaliser votre objectif',
    'goals.name': "Nom de l'objectif",
    'goals.namePlaceholder': "Mon objectif d'épargne",
    'goals.targetAmount': 'Montant cible',
    'goals.targetDate': 'Date cible (optionnel)',
    'goals.linkAccount': 'Lier à un compte (optionnel)',
    'goals.noAccount': 'Aucun compte lié',
    'goals.untitled': 'Objectif sans titre',
    'goals.create': "Créer l'objectif",
    'goals.created': 'Objectif créé',
    'goals.createdDesc': 'Votre objectif a été créé avec succès',
    'goals.deleted': 'Objectif supprimé',
    'goals.deletedDesc': 'Votre objectif a été supprimé',
    'goals.archived': 'Objectif archivé',
    'goals.archivedDesc': 'Votre objectif a été archivé',
    'goals.archivedTitle': 'Objectifs archivés',
    'goals.unarchived': 'Objectif restauré',
    'goals.unarchivedDesc': 'Votre objectif a été restauré',
    'goals.unarchive': 'Restaurer',
    'goals.completed': 'Terminé',
    'goals.progress': 'Progression',
    'goals.remaining': 'Restant',
    'goals.archive': 'Archiver',
    'goals.delete': 'Supprimer',
    'goals.target': 'Cible',
    'goals.saved': 'Épargné',
    'goals.deadline': 'Échéance',
    'goals.noDeadline': "Pas d'échéance",
    'goals.addDeposit': 'Affecter',
    'goals.addWithdrawal': 'Désaffecter',
    'goals.depositAdded': 'Affectation enregistrée',
    'goals.depositAddedDesc': 'Votre affectation a été enregistrée',
    'goals.withdrawalAdded': 'Désaffectation enregistrée',
    'goals.withdrawalAddedDesc': 'Votre désaffectation a été enregistrée',
    'goals.amount': 'Montant',
    'goals.sourceAccount': 'Depuis le compte',
    'goals.destinationAccount': 'Depuis le compte',
    'goals.date': 'Date',
    'goals.noteOptional': 'Note (optionnel)',
    'goals.confirm': 'Confirmer',
    'goals.depositHistory': 'Historique',
    'goals.noDeposits': 'Aucune affectation',
    'goals.noDepositsDesc': 'Affectez des fonds pour commencer le suivi',
    'goals.predictionText': 'Au rythme actuel, vous atteindrez cet objectif vers {date}.',
    'goals.predictionInsufficient': 'Affectez plus de fonds pour voir une prédiction.',
    'goals.cumulativeProgress': 'Progression dans le temps',
    'goals.savingsGoals': "Objectifs d'épargne",
    'goals.debtPayment': 'Paiement de dettes',
    'goals.deleteConfirm':
      'Cela supprimera définitivement cet objectif et toutes ses affectations.',
    'goals.selectAccount': 'Sélectionner un compte',
    'dashboard.nav.goals': 'Objectifs',
    'dashboard.nav.calendar': 'Calendrier',
    'dashboard.nav.coach': 'Coach clevia',

    // Coach Page
    'coach.title': 'Coach clevia',
    'coach.subtitle': 'Votre guide financier IA personnel',
    'coach.comingSoon.title': 'Votre Coach IA Personnel',
    'coach.comingSoon.description':
      "Votre coach personnel IA arrive bientôt. Il t'aidera à prendre de meilleures décisions financières en se basant sur ton historique dans clevia.",
    'coach.disclaimer.title': 'Important :',
    'coach.disclaimer.description':
      'Coach clevia fournit des conseils généraux, pas des conseils financiers. Consultez toujours un conseiller financier qualifié pour les décisions importantes.',
    'coach.features.analysis': 'Analyse des dépenses',
    'coach.features.analysisDesc':
      "Comprenez vos habitudes de dépenses et trouvez des opportunités d'économies.",
    'coach.features.insights': 'Insights Personnalisés',
    'coach.features.insightsDesc':
      'Recevez des recommandations adaptées basées sur vos données financières.',
    'coach.features.decisions': 'Meilleures Décisions',
    'coach.features.decisionsDesc':
      "Prenez des décisions financières plus intelligentes avec les conseils alimentés par l'IA.",

    // Calendar Page
    'calendar.title': 'Calendrier des abonnements',
    'calendar.subtitle': 'Visualisez et g\u00e9rez vos transactions r\u00e9currentes',
    'calendar.viewCalendar': 'Calendrier',
    'calendar.viewList': 'Liste',
    'calendar.add': 'Ajouter',
    'calendar.income': 'Revenus',
    'calendar.expenses': 'D\u00e9penses',
    'calendar.recurring': 'R\u00e9currents',
    'calendar.net': 'Net',
    'calendar.fixedExpenses': 'Charges fixes',
    'calendar.recurringIncome': 'Revenus r\u00e9currents',
    'calendar.forecastBalance': 'Solde pr\u00e9visionnel',
    'calendar.next7Days': '7 prochains jours',
    'calendar.upcomingDue': '\u00c9ch\u00e9ances \u00e0 venir',
    'calendar.manageRecurrences': 'G\u00e9rer les r\u00e9currences',
    'calendar.manage.description': 'Description',
    'calendar.manage.amount': 'Montant',
    'calendar.manage.frequency': 'Fr\u00e9quence',
    'calendar.manage.recurrenceDate': 'Date de r\u00e9currence',
    'calendar.manage.endDate': 'Fin',
    'calendar.manage.category': 'Cat\u00e9gorie',
    'calendar.manage.account': 'Compte',
    'calendar.manage.status': 'Statut',
    'calendar.manage.actions': 'Actions',
    'calendar.manage.active': 'Actif',
    'calendar.manage.inactive': 'Inactif',
    'calendar.manage.noEnd': '\u2014',
    'calendar.manage.noRecurrences': 'Aucune r\u00e9currence',
    'calendar.manage.daily': 'Quotidien',
    'calendar.manage.weekly': 'Hebdomadaire',
    'calendar.manage.monthly': 'Mensuel',
    'calendar.manage.yearly': 'Annuel',
    'calendar.modify.title': 'Comment appliquer cette modification ?',
    'calendar.modify.includeCurrent': 'Modifier aussi le mois en cours',
    'calendar.modify.includeCurrentDesc':
      'La modification s\u2019applique imm\u00e9diatement\nL\u2019occurrence du mois actuel est mise \u00e0 jour\nToutes les occurrences futures utilisent le nouveau montant',
    'calendar.modify.fromNext': 'Appliquer \u00e0 partir du prochain cycle',
    'calendar.modify.fromNextDesc':
      'Le mois en cours reste inchang\u00e9\nLa modification commence au prochain pr\u00e9l\u00e8vement',
    'calendar.modify.apply': 'Appliquer',
    'calendar.modify.cancel': 'Annuler',
    'calendar.today': "Aujourd'hui",
    'calendar.activeSubscriptions': 'abonnements actifs',
    'calendar.empty': 'Aucun paiement r\u00e9current ce mois',
    'calendar.addFirst': 'Ajoutez votre premier abonnement',
    'calendar.nothingOnDay': 'Aucun paiement ce jour',
    'calendar.incomeLabel': 'Revenu',
    'calendar.expenseLabel': 'D\u00e9pense',
    'calendar.mon': 'Lun',
    'calendar.tue': 'Mar',
    'calendar.wed': 'Mer',
    'calendar.thu': 'Jeu',
    'calendar.fri': 'Ven',
    'calendar.sat': 'Sam',
    'calendar.sun': 'Dim',

    // Budgets
    'budgets.title': 'Budgets par catégorie',
    'budgets.subtitle': 'Définissez des limites de dépenses pour chaque catégorie',
    'budgets.addNew': 'Ajouter un budget',
    'budgets.empty': 'Aucun budget',
    'budgets.emptyDesc': 'Créez des budgets pour suivre vos dépenses par catégorie',
    'budgets.addFirst': 'Ajouter votre premier budget',
    'budgets.spent': 'Dépensé',
    'budgets.limit': 'Limite',
    'budgets.remaining': 'restant',
    'budgets.status.exceeded': 'Dépassé',
    'budgets.status.nearLimit': 'Proche limite',
    'budgets.status.healthy': 'Sain',
    'budgets.period.weekly': 'Hebdomadaire',
    'budgets.period.monthly': 'Mensuel',
    'budgets.period.yearly': 'Annuel',
    'budgets.modal.edit': 'Modifier le budget',
    'budgets.modal.create': 'Créer un budget',
    'budgets.modal.category': 'Catégorie',
    'budgets.modal.selectCategory': 'Sélectionner une catégorie',
    'budgets.modal.amount': 'Montant du budget',
    'budgets.modal.period': 'Période',
    'budgets.delete.confirm': 'Êtes-vous sûr de vouloir supprimer ce budget ?',
    'budgets.stats.totalBudget': 'Budget total',
    'budgets.stats.totalSpent': 'Total dépensé',
    'budgets.stats.remaining': 'Restant',
    'budgets.stats.usage': 'Utilisation',
    'budgets.healthyBudgets': 'sains',
    'budgets.nearLimitBudgets': 'proche limite',
    'budgets.exceededBudgets': 'dépassés',

    'common.cancel': 'Annuler',
    'common.loading': 'Chargement...',
    'common.save': 'Enregistrer',
    'common.saving': 'Enregistrement...',
    'common.error': 'Erreur',
    'common.create': 'Créer',
    'common.edit': 'Modifier',
    'common.delete': 'Supprimer',
    'common.retry': 'Réessayer',

    // Categories
    'categories.income': 'Revenus',
    'categories.expenses': 'Dépenses',
    'categories.infoBanner':
      "Les modifications apportées à vos groupes et catégories ici seront appliquées dans toute l'application clevia. Personnalisez la structure de vos catégories selon vos besoins.",
    'categories.createGroup': 'Créer un groupe',
    'categories.editGroup': 'Modifier le groupe',
    'categories.deleteGroup': 'Supprimer le groupe',
    'categories.createGroupDesc': 'Créez un nouveau groupe pour organiser vos catégories.',
    'categories.editGroupDesc': 'Modifiez le nom du groupe.',
    'categories.groupName': 'Nom du groupe',
    'categories.groupNamePlaceholder': 'ex: Logement, Transport...',
    'categories.groupCreated': 'Groupe créé',
    'categories.groupCreatedDesc': 'Votre groupe a été créé avec succès.',
    'categories.groupUpdated': 'Groupe modifié',
    'categories.groupUpdatedDesc': 'Votre groupe a été modifié avec succès.',
    'categories.groupDeleted': 'Groupe supprimé',
    'categories.groupDeletedDesc': 'Votre groupe a été supprimé avec succès.',
    'categories.groupError': "Échec de l'enregistrement du groupe. Veuillez réessayer.",
    'categories.groupDeleteError': 'Échec de la suppression du groupe. Veuillez réessayer.',
    'categories.deleteGroupConfirm': 'Supprimer le groupe ?',
    'categories.deleteGroupWarning':
      'Êtes-vous sûr de vouloir supprimer "{name}" ? Les catégories de ce groupe deviendront non groupées.',
    'categories.noGroups':
      'Aucun groupe pour le moment. Créez-en un pour organiser vos catégories.',
    'categories.createCategory': 'Créer une catégorie',
    'categories.editCategory': 'Modifier la catégorie',
    'categories.createCategoryDesc': 'Créez une nouvelle catégorie pour suivre vos transactions.',
    'categories.editCategoryDesc': 'Modifiez les détails de la catégorie.',
    'categories.categoryName': 'Nom de la catégorie',
    'categories.categoryNamePlaceholder': 'ex: Courses, Essence...',
    'categories.icon': 'Icône',
    'categories.chooseEmoji': 'Choisir un emoji...',
    'categories.color': 'Couleur',
    'categories.categoryCreated': 'Catégorie créée',
    'categories.categoryCreatedDesc': 'Votre catégorie a été créée avec succès.',
    'categories.categoryUpdated': 'Catégorie modifiée',
    'categories.categoryUpdatedDesc': 'Votre catégorie a été modifiée avec succès.',
    'categories.categoryDeleted': 'Catégorie supprimée',
    'categories.categoryDeletedDesc': 'Votre catégorie a été supprimée avec succès.',
    'categories.categoryError': "Échec de l'enregistrement de la catégorie. Veuillez réessayer.",
    'categories.categoryDeleteError':
      'Échec de la suppression de la catégorie. Veuillez réessayer.',
    'categories.deleteCategoryConfirm': 'Supprimer la catégorie ?',
    'categories.deleteCategoryWarning':
      'Êtes-vous sûr de vouloir supprimer "{name}" ? Les transactions utilisant cette catégorie n\'auront plus de catégorie assignée.',
    'categories.noCategories': 'Aucune catégorie dans ce groupe pour le moment.',
    'categories.createFirstGroup': 'Créer votre premier groupe',
    'categories.edit': 'Modifier',
    'categories.delete': 'Supprimer',
    'categories.dragHint': 'Glissez-déposez les catégories pour les réorganiser dans un groupe.',
    'categories.reorderError': 'Échec de la réorganisation des catégories. Veuillez réessayer.',
    'categories.resetOrder': "Réinitialiser l'ordre",
    'categories.resetOrderConfirm': "Réinitialiser l'ordre des catégories ?",
    'categories.resetOrderWarning':
      'Cela réorganisera toutes les catégories par ordre alphabétique dans chaque groupe. Votre ordre personnalisé sera perdu.',
    'categories.orderReset': 'Ordre réinitialisé',
    'categories.orderResetDesc': 'Les catégories ont été réorganisées par ordre alphabétique.',
    'categories.resetError': "Échec de la réinitialisation de l'ordre. Veuillez réessayer.",
    'categories.hide': 'Masquer',
    'categories.show': 'Afficher',
    'categories.hideGroup': 'Masquer le groupe',
    'categories.showGroup': 'Afficher le groupe',
    'categories.active': 'actives',
    'categories.duplicateError': 'Une catégorie avec ce nom existe déjà dans ce groupe.',
    'categories.duplicateGroupError': 'Un groupe avec ce nom existe déjà.',
    'categories.categoryHidden': 'Catégorie masquée',
    'categories.categoryHiddenDesc':
      "Cette catégorie n'apparaîtra pas dans les listes de sélection.",
    'categories.categoryShown': 'Catégorie visible',
    'categories.categoryShownDesc':
      'Cette catégorie apparaîtra maintenant dans les listes de sélection.',
    'categories.groupHidden': 'Groupe masqué',
    'categories.groupHiddenDesc': "Ce groupe n'apparaîtra pas dans les listes de sélection.",
    'categories.groupShown': 'Groupe visible',
    'categories.groupShownDesc': 'Ce groupe apparaîtra maintenant dans les listes de sélection.',
    'categories.toggleHiddenError': 'Échec de la mise à jour de la visibilité. Veuillez réessayer.',
    'categories.loadError': 'Échec du chargement des catégories',
    'categories.emptyTitle': 'Aucune catégorie',
    'categories.emptyDesc':
      'Commencez par configurer vos catégories par défaut pour organiser vos transactions.',
    'categories.setupDefaults': 'Configurer les catégories par défaut',
    'categories.validation.nameRequired': 'Le nom est requis.',
    'categories.validation.nameTooShort': 'Le nom doit contenir au moins 2 caractères.',
    'categories.validation.nameTooLong': 'Le nom doit contenir moins de 50 caractères.',

    // Settings
    'settings.title': 'Paramètres',
    'settings.subtitle': 'Personnalisez votre expérience clevia',
    'settings.backToDashboard': 'Retour au dashboard',
    'settings.tab.profile': 'Profil',
    'settings.tab.categories': 'Catégories',
    'settings.tab.notifications': 'Notifications',
    'settings.tab.security': 'Sécurité',
    'settings.tab.appearance': 'Apparence',
    'settings.tab.billing': 'Facturation',
    'settings.profile.photo': 'Photo de profil',
    'settings.profile.upload': 'Télécharger une photo',
    'settings.profile.delete': 'Supprimer',
    'settings.profile.photoDesc': 'JPG, PNG ou GIF. Max 2MB.',
    'settings.profile.invalidFileType': 'Type de fichier invalide',
    'settings.profile.invalidFileTypeDesc': 'Veuillez télécharger une image JPG, PNG ou GIF.',
    'settings.profile.fileTooLarge': 'Fichier trop volumineux',
    'settings.profile.fileTooLargeDesc': 'Veuillez télécharger une image de moins de 2MB.',
    'settings.profile.photoUploaded': 'Photo téléchargée',
    'settings.profile.photoUploadedDesc': 'Votre photo de profil a été mise à jour.',
    'settings.profile.uploadError': 'Échec du téléchargement',
    'settings.profile.uploadErrorDesc':
      'Impossible de télécharger votre photo. Veuillez réessayer.',
    'settings.profile.photoDeleted': 'Photo supprimée',
    'settings.profile.photoDeletedDesc': 'Votre photo de profil a été supprimée.',
    'settings.profile.deleteError': 'Échec de la suppression',
    'settings.profile.deleteErrorDesc': 'Impossible de supprimer votre photo. Veuillez réessayer.',
    'settings.profile.personalInfo': 'Informations personnelles',
    'settings.profile.fullName': 'Nom complet',
    'settings.profile.email': 'Email',
    'settings.profile.phone': 'Téléphone',
    'settings.profile.phonePlaceholder': '+212 6XX XXX XXX',
    'settings.profile.address': 'Adresse',
    'settings.profile.addressPlaceholder': 'Casablanca, Maroc',
    'settings.profile.save': 'Enregistrer les modifications',
    'settings.profile.saved': 'Profil mis à jour',
    'settings.profile.savedDesc': 'Votre profil a été enregistré avec succès',
    'settings.profile.error': 'Échec de la mise à jour',
    'settings.profile.errorDesc': 'Impossible de mettre à jour votre profil. Veuillez réessayer.',
    'settings.notifications.title': 'Préférences de notification',
    'settings.notifications.email': 'Notifications par email',
    'settings.notifications.emailDesc': 'Recevez des mises à jour par email',
    'settings.notifications.push': 'Notifications push',
    'settings.notifications.pushDesc': 'Recevez des notifications sur vos appareils',
    'settings.notifications.transactions': 'Alertes de transactions',
    'settings.notifications.transactionsDesc': 'Soyez notifié de chaque transaction',
    'settings.notifications.budgets': 'Alertes de budget',
    'settings.notifications.budgetsDesc': 'Recevez des alertes quand vous dépassez votre budget',
    'settings.notifications.weekly': 'Rapport hebdomadaire',
    'settings.notifications.weeklyDesc': 'Résumé hebdomadaire de vos finances',
    'settings.notifications.saved': 'Préférences enregistrées',
    'settings.notifications.savedDesc': 'Vos préférences de notification ont été mises à jour.',
    'settings.notifications.error': "Échec de l'enregistrement",
    'settings.notifications.errorDesc':
      "Impossible d'enregistrer vos préférences. Veuillez réessayer.",
    'settings.security.changePassword': 'Changer le mot de passe',
    'settings.security.currentPassword': 'Mot de passe actuel',
    'settings.security.newPassword': 'Nouveau mot de passe',
    'settings.security.confirmPassword': 'Confirmer le mot de passe',
    'settings.security.updatePassword': 'Mettre à jour le mot de passe',
    'settings.security.twoFactor': 'Authentification à deux facteurs',
    'settings.security.twoFactorDesc':
      'Ajoutez une couche de sécurité supplémentaire à votre compte',
    'settings.security.enable2FA': 'Activer la 2FA',
    'settings.security.manage2FA': 'Gérer la 2FA',
    'settings.security.2faActive': 'Active',
    'settings.2fa.title': 'Authentification à deux facteurs',
    'settings.2fa.subtitle': 'Sécurisez votre compte',
    'settings.2fa.manageDesc': 'Gérez vos paramètres 2FA',
    'settings.2fa.howItWorks': 'Comment ça marche',
    'settings.2fa.howItWorksDesc':
      "Utilisez une application d'authentification comme Google Authenticator ou Authy pour générer des codes de vérification lors de votre connexion.",
    'settings.2fa.step1': "Téléchargez une application d'authentification",
    'settings.2fa.step2': "Scannez le QR code avec l'application",
    'settings.2fa.step3': 'Entrez le code de vérification',
    'settings.2fa.startSetup': 'Commencer la configuration',
    'settings.2fa.scanQR': "Scannez ce QR code avec votre application d'authentification",
    'settings.2fa.manualEntry': 'Impossible de scanner ? Entrez ce code manuellement :',
    'settings.2fa.continue': 'Continuer',
    'settings.2fa.enterCode': 'Entrez le code de vérification',
    'settings.2fa.enterCodeDesc':
      "Entrez le code à 6 chiffres de votre application d'authentification",
    'settings.2fa.codeLength': 'Veuillez entrer un code à 6 chiffres',
    'settings.2fa.invalidCode': 'Code de vérification invalide. Veuillez réessayer.',
    'settings.2fa.back': 'Retour',
    'settings.2fa.verify': 'Vérifier',
    'settings.2fa.successTitle': '2FA Activée !',
    'settings.2fa.successDesc':
      "Votre compte est maintenant protégé par l'authentification à deux facteurs.",
    'settings.2fa.enabled': '2FA Activée',
    'settings.2fa.enabledDesc':
      "L'authentification à deux facteurs a été activée pour votre compte.",
    'settings.2fa.disabled': '2FA Désactivée',
    'settings.2fa.disabledDesc': "L'authentification à deux facteurs a été désactivée.",
    'settings.2fa.activeTitle': 'La 2FA est Active',
    'settings.2fa.activeDesc': "Votre compte est protégé par l'authentification à deux facteurs.",
    'settings.2fa.addedOn': 'Ajouté le',
    'settings.2fa.remove': 'Supprimer',
    'settings.2fa.close': 'Fermer',
    'settings.2fa.error': 'Erreur',
    'settings.2fa.enrollError': 'Échec du démarrage de la configuration 2FA. Veuillez réessayer.',
    'settings.2fa.disableError': 'Échec de la désactivation 2FA. Veuillez réessayer.',
    'settings.2fa.verifyTitle': 'Authentification à deux facteurs requise',
    'settings.2fa.verifyDesc': "Entrez le code de votre application d'authentification",
    'settings.security.activeSessions': 'Sessions actives',
    'settings.security.currentSession': 'Actuel',
    'settings.security.activeNow': 'Actif maintenant',
    'settings.security.onDevice': 'sur',
    'settings.security.revoke': 'Révoquer',
    'settings.security.signOutOthers': 'Déconnecter les autres',
    'settings.security.sessionRevoked': 'Session révoquée',
    'settings.security.sessionRevokedDesc': 'La session a été révoquée avec succès.',
    'settings.security.otherSessionsRevoked': 'Autres sessions révoquées',
    'settings.security.otherSessionsRevokedDesc':
      'Toutes les autres sessions ont été déconnectées.',
    'settings.security.allFieldsRequired': 'Tous les champs sont requis',
    'settings.security.passwordMinLength': 'Le mot de passe doit contenir au moins 8 caractères',
    'settings.security.passwordsNoMatch': 'Les mots de passe ne correspondent pas',
    'settings.security.currentPasswordWrong': 'Le mot de passe actuel est incorrect',
    'settings.security.passwordUpdated': 'Mot de passe mis à jour',
    'settings.security.passwordUpdatedDesc': 'Votre mot de passe a été mis à jour avec succès.',
    'settings.security.passwordUpdateError':
      'Échec de la mise à jour du mot de passe. Veuillez réessayer.',
    'settings.appearance.theme': 'Thème',
    'settings.appearance.darkMode': 'Mode sombre',
    'settings.appearance.darkModeDesc': 'Parfait pour la nuit',
    'settings.appearance.lightMode': 'Mode clair',
    'settings.appearance.lightModeDesc': 'Idéal pour le jour',
    'settings.appearance.language': 'Langue',
    'settings.appearance.languageDesc': 'Sélectionnez votre langue préférée',
    'settings.appearance.currency': 'Devise',
    'settings.appearance.currencyDesc':
      'Choisissez votre devise préférée pour afficher les montants',
    'settings.appearance.currencyExample': 'Exemple',
    'settings.billing.currentPlan': 'Plan Gratuit',
    'settings.billing.planDesc': 'Profitez de toutes les fonctionnalités gratuitement',
    'settings.billing.perMonth': '/ mois',
    'settings.billing.upgradePremium': 'Passer au Premium',
    'settings.billing.features': 'Fonctionnalités incluses',
    'settings.billing.feature1': 'Budgets illimités',
    'settings.billing.feature2': 'Transactions illimitées',
    'settings.billing.feature3': 'Catégories personnalisées',
    'settings.billing.feature4': 'Analyses et graphiques',
    'settings.billing.feature5': 'Export de données',
    'settings.billing.feature6': 'Support prioritaire',
    'settings.billing.exportData': 'Exporter vos données',
    'settings.billing.exportDesc':
      'Téléchargez une copie de toutes vos données en format CSV ou JSON',
    'settings.billing.exportCSV': 'Export CSV',
    'settings.billing.exportJSON': 'Export JSON',
    'settings.tab.account': 'Compte',
    'settings.account.statusTitle': 'Statut du compte',
    'settings.account.statusActiveDesc':
      'Votre compte est actif et toutes les fonctionnalités sont disponibles.',
    'settings.account.statusPausedDesc':
      'Votre compte est en pause. Vos données sont conservées mais vous ne pouvez pas utiliser les fonctionnalités.',
    'settings.account.active': 'Actif',
    'settings.account.paused': 'Compte mis en pause',
    'settings.account.resumed': 'Compte réactivé',
    'settings.account.pausedDesc':
      'Votre compte a été mis en pause. Vous pouvez le réactiver à tout moment.',
    'settings.account.resumedDesc': 'Votre compte est de nouveau actif.',
    'settings.account.pauseBtn': 'Mettre en pause mon compte',
    'settings.account.resumeBtn': 'Réactiver mon compte',
    'settings.account.dataRetention': 'Conservation des données',
    'settings.account.dataFinancial': 'Données financières',
    'settings.account.dataFinancialValue': 'Conservées tant que le compte est actif',
    'settings.account.dataConnection': 'Données de connexion',
    'settings.account.dataConnectionValue': 'Conservées 12 mois à des fins de sécurité',
    'settings.account.dataCookies': 'Cookies',
    'settings.account.dataCookiesValue': 'Durée maximale de 13 mois (CNIL)',
    'settings.account.dataAfterDelete': 'Après suppression',
    'settings.account.dataAfterDeleteValue':
      'Données conservées 30 jours puis supprimées définitivement',
    'settings.account.dangerZone': 'Zone de danger',
    'settings.account.deleteWarning':
      'Une fois votre compte supprimé, il y a un délai de grâce de 30 jours pendant lequel vous pouvez nous contacter pour annuler la suppression.',
    'settings.account.deleteInfo1': 'Vos données seront conservées 30 jours après la demande',
    'settings.account.deleteInfo2':
      'Après 30 jours, toutes les données seront définitivement supprimées',
    'settings.account.deleteInfo3': 'Cette action est irréversible passé le délai de grâce',
    'settings.account.deleteBtn': 'Supprimer mon compte',
    'settings.account.deleteConfirmLabel':
      'Tapez SUPPRIMER pour confirmer la suppression de votre compte :',
    'settings.account.confirmDelete': 'Supprimer définitivement',
    'settings.account.cancel': 'Annuler',
    'settings.account.deleteRequested': 'Suppression demandée',
    'settings.account.deleteRequestedDesc':
      'Votre compte sera supprimé dans 30 jours. Contactez-nous pour annuler.',
    'settings.account.error': 'Erreur',
    'settings.account.errorDesc': 'Une erreur est survenue. Veuillez réessayer.',

    // Transactions Page
    'transactions.title': 'Transactions',
    'transactions.subtitle': 'Suivez tous vos revenus et dépenses',
    'transactions.addNew': 'Ajouter transaction',
    'transactions.import': 'Importer',
    'transactions.export': 'Exporter',
    'transactions.search': 'Rechercher transactions...',
    'transactions.filter.all': 'Tout',
    'transactions.filter.income': 'Revenus',
    'transactions.filter.expense': 'Dépenses',
    'transactions.stats.income': 'Total Revenus',
    'transactions.stats.expense': 'Total Dépenses',
    'transactions.stats.balance': 'Solde',
    'transactions.empty': 'Aucune transaction trouvée',
    'transactions.emptyDesc': 'Commencez par ajouter votre première transaction',
    'transactions.today': "Aujourd'hui",
    'transactions.yesterday': 'Hier',
    'transactions.type.income': 'Revenu',
    'transactions.type.expense': 'Dépense',
    'transactions.delete.confirm': 'Êtes-vous sûr de vouloir supprimer cette transaction ?',
    'transactions.delete.success': 'Transaction supprimée avec succès',
    'transactions.create.success': 'Transaction créée avec succès',
    'transactions.update.success': 'Transaction mise à jour avec succès',

    // Transaction Modal
    'transactionModal.create': 'Nouvelle Transaction',
    'transactionModal.edit': 'Modifier Transaction',
    'transactionModal.amount': 'Montant',
    'transactionModal.description': 'Description',
    'transactionModal.descriptionPlaceholder': 'Entrez une description...',
    'transactionModal.noDescription': 'Sans description',
    'transactionModal.date': 'Date',
    'transactionModal.type': 'Type',
    'transactionModal.category': 'Catégorie',
    'transactionModal.categoryPlaceholder': 'Sélectionner catégorie...',
    'transactionModal.submit': 'Enregistrer',
    'transactionModal.cancel': 'Annuler',
    'transactionModal.creating': 'Création...',
    'transactionModal.updating': 'Mise à jour...',

    // Categories
    'categories.salary': 'Salaire',
    'categories.freelance': 'Freelance',
    'categories.investment': 'Investissement',
    'categories.food': 'Alimentation',
    'categories.transport': 'Transport',
    'categories.housing': 'Logement',
    'categories.entertainment': 'Divertissement',
    'categories.health': 'Santé',
    'categories.shopping': 'Shopping',
    'categories.other': 'Autre',

    // Onboarding
    'onboarding.step': 'Étape',
    'onboarding.of': 'sur',
    'onboarding.next': 'Suivant',
    'onboarding.previous': 'Précédent',
    'onboarding.skip': 'Passer cette étape',
    'onboarding.finish': 'Créer mon compte',
    'onboarding.hasAccount': 'Tu as déjà un compte ?',
    'onboarding.login': 'Se connecter',

    'onboarding.identity.title': 'Pour commencer, quel est ton prénom ?',
    'onboarding.identity.subtitle': 'Quelques infos pour que clevia te ressemble vraiment',
    'onboarding.identity.firstName': 'Prénom',
    'onboarding.identity.firstNamePlaceholder': 'Kamil',
    'onboarding.age.label': 'Âge',
    'onboarding.age.placeholder': '25',
    'onboarding.dateOfBirth.label': 'Date de naissance',
    'onboarding.gender.label': 'Sexe',

    'onboarding.country.title': 'Où tu vis en ce moment ?',
    'onboarding.country.subtitle': 'On ajuste la monnaie et les infos à ton lieu de vie',
    'onboarding.country.search': 'Rechercher un pays',
    'onboarding.country.other': 'Autre pays',
    'onboarding.country.loading': 'Chargement des pays...',
    'onboarding.country.noResults': 'Aucun pays trouvé',
    'onboarding.country.error': 'Impossible de charger la liste des pays. Réessaie.',

    'onboarding.lifeSituation.title': 'Ta situation de vie',
    'onboarding.lifeSituation.subtitle':
      'Choisis le profil qui décrit le mieux ta situation du moment',

    'onboarding.management.title': 'Tu gères ton argent',
    'onboarding.management.subtitle': 'Juste pour toi, pour deux, ou pour toute la maison ?',

    'onboarding.challenges.title': 'Pourquoi tu viens sur clevia ?',
    'onboarding.challenges.subtitle':
      "Dis-nous ce qui est le plus compliqué pour toi avec l'argent",

    'onboarding.expectations.title': "Ce que clevia peut t'apporter",
    'onboarding.expectations.subtitle': 'Dis-nous ce que tu attends de nous',

    'onboarding.discovery.title': 'Tu nous as trouvés comment ?',
    'onboarding.discovery.subtitle': 'Réseaux, amis, Google… on est curieux de savoir',

    'onboarding.referral.title': 'As-tu un code de parrainage clevia ?',
    'onboarding.referral.subtitle': 'Tu peux le saisir maintenant, ou continuer sans rien ajouter',
    'onboarding.referral.label': 'Code de parrainage (optionnel)',
    'onboarding.referral.placeholder': 'Entre ton code',
    'onboarding.referral.hint':
      "Si tu parraines 5 personnes, tu gagnes 1 mois gratuit sur l'offre payante (plus tard).",

    'onboarding.account.title': 'Créer mon compte',
    'onboarding.account.subtitle': 'Dernière étape avant de commencer',
    'onboarding.account.email': 'Ton email',
    'onboarding.account.emailPlaceholder': 'nom@exemple.com',
    'onboarding.account.password': 'Mot de passe',
    'onboarding.account.passwordPlaceholder': 'Minimum 8 caractères (a-z, A-Z, 0-9)',
    'onboarding.account.terms': "En t'inscrivant, tu acceptes les",
    'onboarding.account.termsLink': 'Conditions de service',
    'onboarding.account.and': 'et la',
    'onboarding.account.privacyLink': 'Politique de confidentialité',
    'onboarding.account.ofclevia': 'de clevia',

    'onboarding.welcome.title': 'Bienvenue sur clevia !',
    'onboarding.welcome.message': 'Ton compte a été créé avec succès',

    // Guide de prise en main
    'gettingStarted.label': 'Découvrir clevia',
    'gettingStarted.start': "C'est parti",
    'gettingStarted.next': 'Suivant',
    'gettingStarted.previous': 'Précédent',
    'gettingStarted.finish': 'Terminer',
    'gettingStarted.final.cta': 'Commencer avec clevia',
    'gettingStarted.finalStep': '7 / 7',
    'gettingStarted.slide1.title': 'Bienvenue sur clevia 👋',
    'gettingStarted.slide1.description':
      "clevia t'aide à comprendre ton argent simplement : ce que tu possèdes, ce qui entre, ce qui sort et les projets que tu veux réaliser.",
    'gettingStarted.slide1.detail':
      'En quelques étapes, on te montre simplement ce qu’il faut connaître pour commencer.',
    'gettingStarted.slide2.title': '1. Commence par tes comptes',
    'gettingStarted.slide2.description':
      'Ajoute les endroits où tu gardes ton argent : compte courant, épargne, cash et autres éléments de ton patrimoine.',
    'gettingStarted.slide2.cardTitle': 'Boursorama',
    'gettingStarted.slide2.cardType': 'Compte courant',
    'gettingStarted.slide2.balanceLabel': 'Solde actuel',
    'gettingStarted.slide2.amount': '2 450 €',
    'gettingStarted.slide2.cardNote': 'Ce montant devient ton point de départ dans clevia.',
    'gettingStarted.slide2.cardHelp':
      'Lorsque tu ajoutes un compte, indique simplement le montant que tu as actuellement dessus. Ensuite, commence à ajouter tes nouvelles transactions à partir de maintenant. Pas besoin de reconstruire tout ton historique.',
    'gettingStarted.slide3.title': '2. Fais vivre tes comptes',
    'gettingStarted.slide3.description':
      'À partir de maintenant, ajoute simplement les mouvements qui se produisent sur tes comptes.',
    'gettingStarted.slide3.expenseTitle': 'Dépense',
    'gettingStarted.slide3.expenseText':
      "De l'argent sort de ton compte. Exemples : restaurant, courses, loyer.",
    'gettingStarted.slide3.incomeTitle': 'Revenu',
    'gettingStarted.slide3.incomeText':
      "De l'argent entre sur ton compte. Exemples : salaire, remboursement, revenu freelance.",
    'gettingStarted.slide3.transferTitle': 'Transfert',
    'gettingStarted.slide3.transferText':
      'Tu déplaces ton propre argent d’un compte vers un autre. Exemple : compte courant → épargne.',
    'gettingStarted.slide3.note': "Un transfert n'est ni une dépense ni un revenu.",
    'gettingStarted.slide4.title': '3. Donne un cadre à ton mois',
    'gettingStarted.slide4.description':
      'Les budgets t’aident à savoir combien tu veux consacrer à chaque catégorie et combien il te reste au fil du mois.',
    'gettingStarted.slide4.exampleTitle': 'Restaurants',
    'gettingStarted.slide4.exampleText': '120 € utilisés sur 200 €',
    'gettingStarted.slide4.note':
      'Pas besoin de tout paramétrer dès le début. Commence simplement par les catégories qui comptent le plus pour toi.',
    'gettingStarted.slide5.title': '4. Anticipe ce qui revient',
    'gettingStarted.slide5.description':
      'Le Calendrier te permet de visualiser les revenus et dépenses qui reviennent régulièrement.',
    'gettingStarted.slide5.netflix': 'Netflix',
    'gettingStarted.slide5.rent': 'Loyer',
    'gettingStarted.slide5.gym': 'Salle de sport',
    'gettingStarted.slide5.salary': 'Salaire',
    'gettingStarted.slide5.insurance': 'Assurance',
    'gettingStarted.slide5.cardTitle': 'Tout se gère depuis “Gérer les récurrences”',
    'gettingStarted.slide5.cardText':
      'Tu peux ajouter, modifier, suspendre ou supprimer une récurrence. Ajoute une fois tes abonnements et tes charges régulières, clevia les organise ensuite dans ton calendrier.',
    'gettingStarted.slide6.title': '5. Donne un but à ton argent',
    'gettingStarted.slide6.description':
      'Fixe des objectifs qui donnent une direction à ton argent et suis ta progression au fil du temps.',
    'gettingStarted.slide6.savingsTitle': 'Objectif d’épargne',
    'gettingStarted.slide6.savingsText': 'Mettre progressivement de l’argent de côté.',
    'gettingStarted.slide6.savingsExamples': 'Voyage · Voiture · Apport · Épargne de sécurité',
    'gettingStarted.slide6.debtTitle': 'Paiement de dette',
    'gettingStarted.slide6.debtText': 'Suivre progressivement ce qu’il te reste à rembourser.',
    'gettingStarted.slide6.debtExamples': 'Prêt personnel · Dette familiale · Crédit',
    'gettingStarted.slide6.note':
      'Tu vois simplement d’où tu pars, où tu veux arriver et ta progression.',
    'gettingStarted.slide7.title': '6. Fais clevia à ton image',
    'gettingStarted.slide7.description':
      'Les catégories utilisées dans tes transactions sont entièrement personnalisables.',
    'gettingStarted.slide7.path': 'Paramètres → Paramétrage financier → Catégories',
    'gettingStarted.slide7.detail':
      'clevia te propose une base pour commencer, mais c’est toi qui décides comment organiser ton argent.',
    'gettingStarted.slide7.create': 'Créer tes propres catégories',
    'gettingStarted.slide7.edit': 'Modifier leur nom ou leur icône',
    'gettingStarted.slide7.organize': 'Les organiser',
    'gettingStarted.slide7.hide': 'Masquer celles dont tu n’as pas besoin',
    'gettingStarted.final.title': 'Et voilà, tu es prêt 🎉',
    'gettingStarted.final.description':
      'C’est tout ce qu’il faut pour commencer. Ajoute tes comptes, note simplement ce qui entre et ce qui sort, fixe quelques budgets et avance progressivement vers tes objectifs.',
    'gettingStarted.final.detail':
      'Pas besoin d’être parfait dès le premier jour. Commence simplement, clevia évoluera avec toi. On te souhaite une vie pleine de projets, de progrès et de belles réussites.',
    'gettingStarted.final.signature': 'Cofondateurs de clevia',
    'gettingStarted.final.names': 'Mehdi & Marouane',

    // Forgot Password
    'forgotPassword.title': 'Mot de passe oublié',
    'forgotPassword.subtitle': 'Entrez votre email pour recevoir un lien de réinitialisation',
    'forgotPassword.email': 'Adresse email',
    'forgotPassword.emailPlaceholder': 'nom@exemple.com',
    'forgotPassword.submit': 'Envoyer le lien de réinitialisation',
    'forgotPassword.loading': 'Envoi en cours...',
    'forgotPassword.backToLogin': 'Retour à la connexion',
    'forgotPassword.success.title': 'Email envoyé !',
    'forgotPassword.success.message': 'Nous avons envoyé un email à',
    'forgotPassword.success.instruction':
      "Cliquez sur le lien dans l'email pour réinitialiser votre mot de passe.",
    'forgotPassword.help': 'Vous avez retrouvé votre mot de passe ?',
    'forgotPassword.login': 'Se connecter',
    'forgotPassword.toast.success': 'Email envoyé',
    'forgotPassword.toast.successDesc':
      'Vérifiez votre boîte mail pour réinitialiser votre mot de passe',
    'forgotPassword.toast.error': 'Erreur',
    'forgotPassword.toast.errorDesc': 'Une erreur est survenue',

    // Reset Password
    'resetPassword.title': 'Nouveau mot de passe',
    'resetPassword.subtitle': 'Choisissez un nouveau mot de passe sécurisé',
    'resetPassword.newPassword': 'Nouveau mot de passe',
    'resetPassword.confirmPassword': 'Confirmer le mot de passe',
    'resetPassword.submit': 'Réinitialiser le mot de passe',
    'resetPassword.loading': 'Mise à jour...',
    'resetPassword.success.title': 'Mot de passe mis à jour !',
    'resetPassword.success.message': 'Votre mot de passe a été réinitialisé avec succès.',
    'resetPassword.success.redirect': 'Redirection vers la page de connexion...',
    'resetPassword.error.invalidLink': 'Lien invalide ou expiré',
    'resetPassword.error.requestNew': 'Veuillez demander un nouveau lien de réinitialisation',
    'resetPassword.verifying': 'Vérification du lien...',
    'resetPassword.toast.success': 'Mot de passe mis à jour',
    'resetPassword.toast.successDesc': 'Votre mot de passe a été réinitialisé avec succès',
    'resetPassword.validation.passwordMin': 'Le mot de passe doit contenir au moins 6 caractères',
    'resetPassword.validation.passwordMatch': 'Les mots de passe ne correspondent pas',

    // Accounts
    'accounts.title': 'Comptes',
    'accounts.subtitle': 'Gérez tous vos actifs et passifs',
    'accounts.addAccount': 'Ajouter un compte',
    'accounts.netWorth': 'PATRIMOINE NET',
    'accounts.monthChange': 'évolution sur 1 mois',
    'accounts.performance': 'Performance du patrimoine',
    'accounts.vsPreviousPeriod': 'vs période précédente',
    'accounts.period.1m': '1 mois',
    'accounts.period.3m': '3 mois',
    'accounts.period.6m': '6 mois',
    'accounts.period.1y': '1 an',
    'accounts.period.all': 'Tout',
    'accounts.summary': 'Résumé',
    'accounts.summary.totals': 'Totaux',
    'accounts.summary.percent': 'Pourcentage',
    'accounts.summary.assets': 'Actifs',
    'accounts.summary.liabilities': 'Passifs',
    'accounts.summary.downloadExcel': 'Télécharger Excel',
    'accounts.empty': 'Aucun compte pour le moment',
    'accounts.emptyDesc': 'Ajoutez votre premier compte pour commencer à suivre votre patrimoine',
    'accounts.noAccount': 'Aucun compte',
    'accounts.justNow': "À l'instant",
    'accounts.hidden': 'compte masqué',
    'accounts.hidden_plural': 'comptes masqués',
    'accounts.lastUpdated': 'Dernière mise à jour',
    'accounts.edit': 'Modifier',
    'accounts.delete': 'Supprimer',
    'accounts.deleteConfirm': 'Êtes-vous sûr de vouloir supprimer ce compte ?',
    'accounts.hide': 'Masquer',
    'accounts.show': 'Afficher',
    'accounts.updateBalance': 'Mettre à jour le solde',
    'accounts.modal.add': 'Ajouter un compte',
    'accounts.modal.addManual': 'Ajouter un compte manuel',
    'accounts.modal.edit': 'Modifier le compte',
    'accounts.modal.name': 'Nom',
    'accounts.modal.namePlaceholder': 'Mon compte épargne',
    'accounts.modal.type': 'Type',
    'accounts.modal.subtype': 'Catégorie',
    'accounts.modal.balance': 'Solde',
    'accounts.modal.balancePlaceholder': '0.00',
    'accounts.modal.institution': 'Institution (optionnel)',
    'accounts.modal.institutionPlaceholder': 'Nom de la banque',
    'accounts.modal.save': 'Enregistrer',
    'accounts.modal.cancel': 'Annuler',
    'accounts.modal.saving': 'Enregistrement...',

    // Add Bank Account
    'addBank.title': 'Ajouter un compte bancaire',
    'addBank.subtitle': 'Liez vos comptes bancaires pour suivre vos finances en un seul endroit.',
    'addBank.openBanking': 'Open Banking',
    'addBank.openBankingDesc':
      "Connectez-vous automatiquement via l'API sécurisée de votre banque.",
    'addBank.comingSoon': 'Bientôt disponible',
    'addBank.manualAdd': 'Ajout manuel',
    'addBank.manualAddDesc':
      'Sélectionnez votre banque et entrez les détails du compte manuellement.',
    'addBank.selectBank': 'Sélectionnez votre banque',
    'addBank.selectBankDesc': 'Choisissez parmi notre liste de banques supportées.',
    'addBank.searchPlaceholder': 'Rechercher une banque...',
    'addBank.yourCountry': 'Votre pays',
    'addBank.noResults': 'Aucune banque trouvée. Essayez une autre recherche.',
    'addBank.accountType': 'Type de compte',
    'addBank.accountDetails': 'Détails du compte',
    'addBank.addAccount': 'Ajouter ce compte',
    'addBank.editAccount': 'Modifier le compte',
    'addBank.saveChanges': 'Enregistrer les modifications',
    'addBank.categoryTitle': 'Ajouter un compte',
    'addBank.categorySubtitle': 'Quel type de compte souhaitez-vous ajouter ?',
    'addBank.cat.bank_accounts': 'Comptes bancaires & livrets',
    'addBank.cat.cash': 'Cash',
    'addBank.cat.real_estate': 'Immobilier',
    'addBank.cat.other_assets': 'Autres actifs',
    'addBank.cat.watches_jewelry': 'Montres & Bijoux',
    'addBank.cat.precious_metals': 'Métaux précieux',
    'addBank.cat.crypto': 'Crypto',
    'addBank.cat.pea': 'PEA',
    'addBank.cat.life_insurance': 'Assurance Vie',
    'addBank.cat.stocks_funds': 'Actions & Fonds',
    'addBank.catDesc.bank_accounts': 'Comptes courants, épargne, dépôts à terme',
    'addBank.catDesc.cash': 'Suivez votre argent liquide',
    'addBank.catDesc.real_estate': 'Propriétés et investissements immobiliers',
    'addBank.catDesc.other_assets': 'Véhicules, collections, autres objets de valeur',
    'addBank.catDesc.watches_jewelry': 'Montres de luxe et bijoux',
    'addBank.catDesc.precious_metals': 'Or, argent et autres métaux',
    'addBank.catDesc.crypto': 'Bitcoin, Ethereum et autres cryptomonnaies',
    'addBank.catDesc.pea': "Plan d'Épargne en Actions",
    'addBank.catDesc.life_insurance': "Contrats d'assurance vie",
    'addBank.catDesc.stocks_funds': "Actions individuelles et fonds d'investissement",
    'addBank.bankType.checking': 'Compte courant',
    'addBank.bankType.savings': "Compte d'épargne",
    'addBank.bankType.credit_card': 'Carte de crédit',
    'addBank.bankType.joint_account': 'Compte joint',
    'addBank.bankType.money_market': 'Money market',
    'addBank.interestRate': "Taux d'intérêt annuel",
    'addBank.interestRateHint': 'Optionnel — utile pour suivre la croissance de votre épargne',
    'addBank.apr': 'Taux annuel effectif global (TAEG)',
    'addBank.aprHint': "Optionnel — le taux d'intérêt annuel de votre carte de crédit",
    'addBank.creditLimit': 'Plafond de crédit',

    'addCash.title': 'Ajouter du cash',
    'addCash.subtitle': 'Déclarez vos liquidités pour les suivre dans votre patrimoine.',
    'addCash.name': 'Nom du cash',
    'addCash.namePlaceholder': 'ex. Portefeuille, Coffre-fort, Cash maison...',
    'addCash.nameHint': 'Exemples : Cash portefeuille, Coffre-fort, Cash maison, Cash voyage',
    'addCash.amount': 'Montant actuel (approx.)',
    'addCash.amountHint': 'Une estimation suffit, tu pourras ajuster plus tard.',
    'addCash.currencyHint': 'Selon tes paramètres de devise',
    'addCash.addCash': 'Ajouter ce cash',

    // Immobilier
    'addRealEstate.title': 'Ajouter un bien immobilier',
    'addRealEstate.subtitle': 'Suivez votre immobilier dans votre patrimoine.',
    'addRealEstate.defaultName': 'Mon bien',
    'addRealEstate.optional': '(optionnel)',
    'addRealEstate.next': 'Suivant',
    'addRealEstate.addProperty': 'Ajouter ce bien',
    'addRealEstate.estimatedValue': 'Valeur estimée',
    'addRealEstate.tab.description': 'Description',
    'addRealEstate.tab.characteristics': 'Caractéristiques',
    'addRealEstate.tab.ownership': 'Détention',
    'addRealEstate.name': 'Nom du bien',
    'addRealEstate.namePlaceholder': 'ex. Mon appartement, Maison de campagne...',
    'addRealEstate.description': 'Description',
    'addRealEstate.descriptionPlaceholder': 'Ajoutez une courte description...',
    'addRealEstate.propertyType': 'Type de bien',
    'addRealEstate.category': 'Catégorie',
    'addRealEstate.city': 'Ville',
    'addRealEstate.cityPlaceholder': 'ex. Paris',
    'addRealEstate.country': 'Pays',
    'addRealEstate.countryPlaceholder': 'ex. France',
    'addRealEstate.type.apartment': 'Appartement',
    'addRealEstate.type.house': 'Maison',
    'addRealEstate.type.building': 'Immeuble',
    'addRealEstate.type.parking': 'Parking',
    'addRealEstate.type.land': 'Terrain',
    'addRealEstate.type.commercial': 'Local commercial',
    'addRealEstate.type.other': 'Autre',
    'addRealEstate.cat.primary_residence': 'Résidence principale',
    'addRealEstate.cat.secondary_residence': 'Résidence secondaire',
    'addRealEstate.cat.rental': 'Bien locatif',
    'addRealEstate.cat.other': 'Autre',
    'addRealEstate.purchasePrice': "Prix d'achat (hors frais)",
    'addRealEstate.surface': 'Surface',
    'addRealEstate.landSurface': 'Surface du terrain',
    'addRealEstate.constructionYear': 'Année de construction',
    'addRealEstate.dpe': 'DPE',
    'addRealEstate.agencyFees': "Frais d'agence",
    'addRealEstate.notaryFees': 'Frais de notaire',
    'addRealEstate.renovationFees': 'Frais de travaux',
    'addRealEstate.furnishingFees': "Frais d'ameublement",
    'addRealEstate.purchaseDate': "Date d'achat",
    'addRealEstate.ownershipPercent': 'Part de détention',
    'addRealEstate.ownershipHint':
      'Pourcentage du bien que vous détenez (100% si seul propriétaire).',

    // Autres actifs
    'addOtherAsset.title': 'Ajouter un actif',
    'addOtherAsset.subtitle': 'Suivez vos actifs alternatifs et investissements divers',
    'addOtherAsset.tabInfo': 'Informations',
    'addOtherAsset.tabOwnership': 'Détention',
    'addOtherAsset.name': 'Nom',
    'addOtherAsset.namePlaceholder': 'ex. Rolex Submariner, Collection de vin...',
    'addOtherAsset.category': 'Catégorie',
    'addOtherAsset.quantity': 'Quantité',
    'addOtherAsset.purchaseUnitPrice': "Prix d'achat unitaire",
    'addOtherAsset.currentUnitPrice': 'Prix unitaire actuel',
    'addOtherAsset.currentPricePlaceholder': "Laisser vide pour utiliser le prix d'achat",
    'addOtherAsset.ownershipPercent': 'Part de détention',
    'addOtherAsset.estimatedValue': 'Valeur totale estimée',
    'addOtherAsset.estimatedHint': 'Qté × Prix actuel × % détention',
    'addOtherAsset.addAsset': 'Ajouter cet actif',
    'addOtherAsset.categories.other': 'Autre',
    'addOtherAsset.categories.jewelry': 'Bijoux',
    'addOtherAsset.categories.pokemon_cards': 'Cartes Pokémon',
    'addOtherAsset.categories.real_estate_crowdfunding': 'Crowdfunding immobilier',
    'addOtherAsset.categories.private_debt': 'Dette privée',
    'addOtherAsset.categories.fcpi': 'FCPI',
    'addOtherAsset.categories.g3f': 'G3F',
    'addOtherAsset.categories.forestry_investment': "Groupement forestier d'investissement",
    'addOtherAsset.categories.hedge_fund': 'Hedge fund',
    'addOtherAsset.categories.watch': 'Montre',
    'addOtherAsset.categories.sneakers': 'Sneakers',
    'addOtherAsset.categories.art': "Œuvres d'art",
    'addOtherAsset.categories.precious_stones': 'Pierres précieuses',
    'addOtherAsset.categories.p2p_lending': 'Prêts entre particuliers',
    'addOtherAsset.categories.private_equity': 'Private equity',
    'addOtherAsset.categories.land': 'Terrain',
    'addOtherAsset.categories.wine': 'Vin',
    'addOtherAsset.categories.car': 'Voiture',
    'addOtherAsset.categories.farm': 'Ferme',
    'addOtherAsset.categories.agriculture': 'Exploitation agricole',
    'addOtherAsset.categories.livestock': 'Bétail',
    'addOtherAsset.categories.taxi_license': 'Licence de taxi',

    // Montres & Bijoux
    'addWatchJewelry.title': 'Ajouter une montre ou un bijou',
    'addWatchJewelry.subtitle': 'Suivez vos montres de luxe et bijoux',
    'addWatchJewelry.tabInfo': 'Informations',
    'addWatchJewelry.tabOwnership': 'Détention',
    'addWatchJewelry.typeWatch': 'Montre',
    'addWatchJewelry.typeJewelry': 'Bijou',
    'addWatchJewelry.model': 'Modèle',
    'addWatchJewelry.modelPlaceholder': 'Rolex Submariner Date',
    'addWatchJewelry.name': 'Nom',
    'addWatchJewelry.namePlaceholder': 'ex. Bracelet en or, Bague diamant...',
    'addWatchJewelry.purchasePrice': "Prix d'achat",
    'addWatchJewelry.seller': 'Vendeur',
    'addWatchJewelry.sellerPlaceholder': 'Concessionnaire original ou reprise',
    'addWatchJewelry.condition': 'État',
    'addWatchJewelry.conditionOptional': 'Optionnel',
    'addWatchJewelry.condition.never_worn': 'Jamais porté(e)',
    'addWatchJewelry.condition.worn': 'Déjà porté(e)',
    'addWatchJewelry.originalBox': "Boîte d'origine",
    'addWatchJewelry.papers': 'Papiers',
    'addWatchJewelry.ownershipPercent': 'Part de détention',
    'addWatchJewelry.estimatedValue': 'Valeur estimée',
    'addWatchJewelry.addItem': 'Ajouter cet article',

    'accounts.subtype.watch': 'Montre',
    'accounts.subtype.jewelry': 'Bijou',
    'accountDetails.watchJewelry.details': "Détails de l'article",
    'accountDetails.watchJewelry.condition': 'État',
    'accountDetails.watchJewelry.seller': 'Vendeur',
    'accountDetails.watchJewelry.originalBox': "Boîte d'origine",
    'accountDetails.watchJewelry.papers': 'Papiers',
    'accountDetails.watchJewelry.yes': 'Oui',
    'accountDetails.watchJewelry.no': 'Non',

    // Métaux précieux
    'addPreciousMetal.title': 'Métaux précieux',
    'addPreciousMetal.subtitle': 'Ajoutez vos métaux précieux',
    'addPreciousMetal.selectTitle': 'Ajouter mes métaux précieux',
    'addPreciousMetal.selectSubtitle':
      'Sélectionnez parmi les métaux populaires ou ajoutez un personnalisé',
    'addPreciousMetal.searchPlaceholder': 'Chercher métaux précieux...',
    'addPreciousMetal.popular': 'Les plus populaires',
    'addPreciousMetal.results': 'Résultats',
    'addPreciousMetal.noResults':
      'Aucun métal trouvé. Essayez une autre recherche ou ajoutez un personnalisé.',
    'addPreciousMetal.addCustom': 'Ajouter un métal personnalisé',
    'addPreciousMetal.tabInfo': 'Informations',
    'addPreciousMetal.tabOwnership': 'Détention',
    'addPreciousMetal.name': 'Nom',
    'addPreciousMetal.namePlaceholder': 'ex. Lingotin 1 Once Or',
    'addPreciousMetal.quantity': 'Quantité',
    'addPreciousMetal.purchaseUnitPrice': "Prix d'achat unitaire",
    'addPreciousMetal.totalValue': 'Valeur totale',
    'addPreciousMetal.ownershipPercent': 'Part de détention',
    'addPreciousMetal.estimatedValue': 'Valeur estimée',
    'addPreciousMetal.estimatedHint': 'Basé sur quantité × prix × détention',
    'addPreciousMetal.addMetal': 'Ajouter ce métal',
    'accounts.subtype.precious_metal': 'Métal précieux',
    'accountDetails.preciousMetal.details': 'Détails du métal',

    // Crypto
    'addCrypto.title': 'Cryptomonnaie',
    'addCrypto.subtitle': 'Ajoutez vos cryptomonnaies',
    'addCrypto.selectTitle': 'Ajouter ma crypto',
    'addCrypto.selectSubtitle': 'Sélectionnez parmi les cryptos populaires ou recherchez',
    'addCrypto.searchPlaceholder': 'Chercher une cryptomonnaie...',
    'addCrypto.popular': 'Les plus populaires',
    'addCrypto.results': 'Résultats',
    'addCrypto.noResults':
      'Aucune crypto trouvée. Essayez une autre recherche ou ajoutez une personnalisée.',
    'addCrypto.addCustom': 'Ajouter une crypto personnalisée',
    'addCrypto.name': 'Nom',
    'addCrypto.namePlaceholder': 'ex. Bitcoin',
    'addCrypto.symbol': 'Symbole',
    'addCrypto.quantity': 'Quantité',
    'addCrypto.purchasePrice': "Prix d'achat unitaire",
    'addCrypto.livePrice': 'Prix en direct',
    'addCrypto.totalPurchase': "Coût total d'achat",
    'addCrypto.currentValue': 'Valeur actuelle',
    'addCrypto.pnl': 'Plus / Moins-value',
    'addCrypto.addCrypto': 'Ajouter cette crypto',
    'accounts.subtype.crypto': 'Crypto',
    'accounts.group.crypto': 'Cryptomonnaies',
    'accountDetails.crypto.details': 'Détails du portefeuille',
    'accountDetails.crypto.livePrice': 'Prix en direct',
    'accountDetails.crypto.change24h': 'Variation 24h',
    'accountDetails.crypto.pnl': 'Plus / Moins-value',
    'accountDetails.crypto.marketCap': 'Capitalisation',
    'accountDetails.crypto.priceChart': 'Graphique du prix',
    'accountDetails.crypto.totalInvested': 'Total investi',
    'accountDetails.crypto.noChartData': 'Aucune donnée de graphique disponible',

    // PEA (Plan d'Épargne en Actions)
    'addPea.title': 'PEA',
    'addPea.subtitle': 'Ajouter une action ou un ETF à votre PEA',
    'addPea.selectTitle': 'Sélectionner une action',
    'addPea.selectSubtitle': 'Choisissez parmi les actions et ETF éligibles au PEA',
    'addPea.searchPlaceholder': 'Rechercher des actions, ETF...',
    'addPea.popular': 'Actions populaires',
    'addPea.results': 'Résultats',
    'addPea.noResults': 'Aucune action trouvée',
    'addPea.addCustom': 'Ajouter une action personnalisée',
    'addPea.name': "Nom de l'action",
    'addPea.namePlaceholder': 'ex. TotalEnergies',
    'addPea.quantity': 'Quantité',
    'addPea.purchasePrice': "Prix d'achat unitaire",
    'addPea.totalValue': 'Valeur totale',
    'addPea.addStock': 'Ajouter cette action',
    'addPea.symbol': 'Symbole',
    'addPea.stockType': 'Type',
    'accounts.subtype.pea_stock': 'PEA',
    'accounts.group.pea': 'PEA',
    'accountDetails.pea.details': 'Détails du portefeuille',
    'accountDetails.pea.livePrice': 'Prix en direct',
    'accountDetails.pea.pnl': 'Plus / Moins-value',
    'accountDetails.pea.currentValue': 'Valeur actuelle',
    'accountDetails.pea.priceChart': 'Graphique du prix',
    'accountDetails.pea.totalInvested': 'Total investi',
    'accountDetails.pea.noChartData': 'Aucune donnée de graphique disponible',

    'accounts.type.asset': 'Actif',
    'accounts.type.liability': 'Passif',
    'accounts.subtype.checking': 'Compte courant',
    'accounts.subtype.savings': 'Épargne',
    'accounts.subtype.cash': 'Espèces',
    'accounts.subtype.investment': 'Investissements',
    'accounts.subtype.real_estate': 'Immobilier',
    'accounts.subtype.vehicle': 'Véhicules',
    'accounts.subtype.other_asset': 'Autres actifs',
    'accounts.subtype.credit_card': 'Carte de crédit',
    'accounts.subtype.mortgage': 'Hypothèque',
    'accounts.subtype.loan': 'Prêts',
    'accounts.subtype.other_liability': 'Autres passifs',
    'accounts.subtype.joint_account': 'Compte joint',
    'accounts.subtype.money_market': 'Money market',
    'accounts.group.bankAccounts': 'Comptes bancaires',
    'accounts.group.livrets': 'Livrets',
    'accounts.group.cash': 'Espèces',
    'accounts.group.investments': 'Investissements',
    'accounts.group.realEstate': 'Immobilier',
    'accounts.group.vehicles': 'Véhicules',
    'accounts.group.otherAssets': 'Autres actifs',
    'accounts.group.watchesJewelry': 'Montres & Bijoux',
    'accounts.group.preciousMetals': 'Métaux précieux',
    'accounts.group.creditCards': 'Cartes de crédit',
    'accounts.group.mortgages': 'Hypothèques',
    'accounts.group.loans': 'Prêts',
    'accounts.group.otherLiabilities': 'Autres passifs',
    'dashboard.nav.accounts': 'Comptes',

    // Import
    'accounts.import': 'Importer',
    'accounts.import.title': 'Importer des comptes',
    'accounts.import.subtitle': 'Téléversez un fichier CSV ou Excel pour importer vos comptes',
    'accounts.import.upload': 'Téléverser un fichier',
    'accounts.import.uploadDesc': 'Glissez-déposez un fichier ici, ou cliquez pour parcourir',
    'accounts.import.supported': 'Supporte CSV, XLS, XLSX',
    'accounts.import.maxSize': 'Max 5 Mo',
    'accounts.import.mapColumns': 'Associer les colonnes',
    'accounts.import.mapColumnsDesc': 'Associez les colonnes de votre fichier aux champs de compte',
    'accounts.import.preview': 'Aperçu',
    'accounts.import.previewDesc': "Vérifiez vos données avant l'importation",
    'accounts.import.importing': 'Importation...',
    'accounts.import.complete': 'Importation terminée',
    'accounts.import.success': '{count} comptes importés avec succès',
    'accounts.import.errors': '{count} erreurs rencontrées',
    'accounts.import.field.name': 'Nom du compte',
    'accounts.import.field.type': 'Type (actif/passif)',
    'accounts.import.field.subtype': 'Catégorie',
    'accounts.import.field.balance': 'Solde',
    'accounts.import.field.institution': 'Institution',
    'accounts.import.field.skip': '-- Ignorer --',
    'accounts.import.rows': '{count} lignes détectées',
    'accounts.import.valid': '{count} valides',
    'accounts.import.invalid': '{count} invalides',
    'accounts.import.startImport': 'Importer {count} comptes',
    'accounts.import.back': 'Retour',
    'accounts.import.next': 'Suivant',
    'accounts.import.close': 'Fermer',
    'accounts.import.done': 'Terminé',
    'accounts.import.tryAgain': 'Importer plus',
    'accounts.import.fileError': 'Impossible de lire le fichier. Veuillez vérifier le format.',
    'accounts.import.noData': 'Aucune donnée trouvée dans le fichier',
    'accounts.import.nameRequired': 'Le nom est requis',
    'accounts.import.downloadTemplate': 'Télécharger le modèle',

    // Account Details
    'accountDetails.backToAccounts': 'Retour aux comptes',
    'accountDetails.realEstate.details': 'D\u00e9tails du bien',
    'accountDetails.realEstate.fees': "Frais d'acquisition",
    'accountDetails.otherAsset.details': "Détails de l'actif",
    'accountDetails.cash.currentAmount': 'Montant actuel',
    'accountDetails.cash.updateAmount': 'Mettre \u00e0 jour le montant',
    'accountDetails.cash.tipTitle': 'Suivi manuel',
    'accountDetails.cash.tipDesc':
      'Mettez \u00e0 jour ce montant quand vos esp\u00e8ces changent. Il sera inclus dans le calcul de votre patrimoine.',
    'accountDetails.notFound': 'Compte non trouvé',
    'accountDetails.balanceHistory': 'Historique du solde',
    'accountDetails.transactions': 'Transactions',
    'accountDetails.noTransactions': 'Aucune transaction',
    'accountDetails.noTransactionsDesc': 'Ajoutez votre première transaction pour ce compte',
    'accountDetails.stats.income': 'Revenus',
    'accountDetails.stats.expense': 'Dépenses',
    'accountDetails.stats.transfersIn': 'Virements entrants',
    'accountDetails.stats.transfersOut': 'Virements sortants',
    'accountDetails.stats.allTime': 'Depuis toujours',

    // RIB Document
    'accountDetails.rib.title': 'Coordonnées bancaires (RIB)',
    'accountDetails.rib.upload': 'Importer le RIB',
    'accountDetails.rib.replace': 'Remplacer',
    'accountDetails.rib.download': 'Télécharger',
    'accountDetails.rib.view': 'Voir',
    'accountDetails.rib.delete': 'Supprimer',
    'accountDetails.rib.noFile': 'Aucun RIB importé',
    'accountDetails.rib.noFileDesc': "Importez votre relevé d'identité bancaire (PDF, max 5 Mo)",
    'accountDetails.rib.uploaded': 'RIB importé',
    'accountDetails.rib.uploadedDesc': 'Votre RIB a été enregistré',
    'accountDetails.rib.deleted': 'RIB supprimé',
    'accountDetails.rib.deletedDesc': 'Votre RIB a été supprimé',
    'accountDetails.rib.invalidType': 'Type de fichier invalide',
    'accountDetails.rib.invalidTypeDesc': 'Veuillez importer un fichier PDF',
    'accountDetails.rib.fileTooLarge': 'Fichier trop volumineux',
    'accountDetails.rib.fileTooLargeDesc': 'La taille maximale est de 5 Mo',
    'accountDetails.rib.uploadError': "Échec de l'import",
    'accountDetails.rib.uploadErrorDesc':
      "Impossible d'importer votre document. Veuillez réessayer.",
    'accountDetails.rib.deleteConfirm': 'Êtes-vous sûr de vouloir supprimer ce RIB ?',
    'accountDetails.rib.fileName': 'Document RIB',

    // Goal Allocations
    'accountDetails.goals.title': 'Objectifs liés à ce compte',
    'accountDetails.goals.realBalance': 'Solde réel',
    'accountDetails.goals.allocated': 'Alloué aux objectifs',
    'accountDetails.goals.available': 'Disponible',
    'accountDetails.goals.explanation':
      'Votre solde réel reste inchangé. Une partie est simplement affectée à vos objectifs.',
    'accountDetails.goals.allocatedFrom': 'affectés depuis ce compte',
    'accountDetails.goals.noGoals': 'Aucun objectif lié à ce compte pour le moment.',

    // Transfer
    'transactions.transfer': 'Virement',
    'transactions.filter.transfer': 'Virement',
    'transactions.filter.allAccounts': 'Tous les comptes',
    'transactions.filter.allCategories': 'Toutes les catégories',
    'transactions.filter.nCategories': '{n} catégories',
    'transactions.filter.from': 'Du',
    'transactions.filter.to': 'Au',
    'transactions.filter.clearDates': 'Effacer les dates',
    'transactions.customizeCategories': 'Personnaliser les catégories',
    'transactions.stats.transfers': 'Virements',
    'accounts.transfer': 'Virement',
    'accounts.transferFrom': 'Virer depuis ce compte',
    'dashboard.quickActions.transfer': 'Virement rapide',
    'dashboard.filter.thisMonth': 'Ce mois',
    'dashboard.filter.lastMonth': 'Mois dernier',
    'dashboard.filter.last3Months': '3 derniers mois',
    'dashboard.filter.thisYear': 'Cette année',
    'dashboard.filter.allAccounts': 'Tous les comptes',
    'dashboard.filter.all': 'Tout',
    'dashboard.filter.income': 'Revenus',
    'dashboard.filter.expense': 'Dépenses',
    'dashboard.filter.transfer': 'Transferts',
    'dashboard.goals.progress': 'épargné',
    'dashboard.goals.remaining': 'restant',
    'dashboard.goals.daysLeft': 'jours restants',
    // New dashboard translation keys
    'dashboard.accounts.empty': 'Aucun compte',
    'dashboard.accounts.add': 'Ajouter un compte',
    'dashboard.distribution.title': 'Répartition du patrimoine',
    'dashboard.distribution.noAssets': 'Aucun actif à afficher',
    'dashboard.budget.monthlyTitle': 'Budget du mois',
    'dashboard.budget.exceeded': 'Dépassé',
    'dashboard.budget.ofIncome': 'des revenus',
    'dashboard.budget.availableBalance': 'Solde disponible',
    'dashboard.budget.expensesOverIncome': 'Dépenses > Revenus',
    'dashboard.cashFlow.avgIncome': 'Moyenne revenus',
    'dashboard.cashFlow.avgExpenses': 'Moyenne dépenses',
    'dashboard.cashFlow.avgBalance': 'Solde moyen',
    'dashboard.cashFlow.balance': 'Solde',
    'dashboard.topCategories.topIncome': 'Top 3 Revenus',
    'dashboard.topCategories.noIncome': 'Aucun revenu',
    'dashboard.topCategories.total': 'Total',
    'dashboard.upcomingBills.title': 'Factures à venir',
    'dashboard.upcomingBills.add': 'Ajouter',
    'dashboard.upcomingBills.totalNext30Days': 'Total sur 30 jours',
    'dashboard.upcomingBills.next7Days': 'Prochains 7 jours',
    'dashboard.upcomingBills.later': 'Plus tard',
    'dashboard.upcomingBills.viewCalendar': 'Voir le calendrier complet',
    'dashboard.upcomingBills.today': "Aujourd'hui",
    'dashboard.upcomingBills.tomorrow': 'Demain',
    'dashboard.goals.viewAll': 'Voir tous les objectifs',
    'dashboard.goals.deadlinePassed': 'Échéance dépassée',
    'dashboard.transactions.viewAllBtn': 'Voir toutes les transactions',
    'dashboard.distribution.others': 'autres',
    'dashboard.period.7days': '7 jours',
    'dashboard.period.30days': '30 jours',
    'dashboard.period.90days': '90 jours',
    'dashboard.period.overLast': 'Sur les',

    // Transaction Modal (account selection)
    'transactionModal.account': 'Compte',
    'transactionModal.fromAccount': 'Depuis',
    'transactionModal.toAccount': 'Vers',
    'transactionModal.selectAccount': 'Sélectionner un compte',
    'transactionModal.transferSummary': 'Résumé du virement',
    'transactionModal.insufficientBalance': 'Solde insuffisant',
    'transactionModal.selectDifferentAccounts': 'Sélectionnez des comptes différents',
    'transactionModal.noAccounts': 'Aucun compte',
    'transactionModal.noAccountsDesc': "Ajoutez d'abord un compte",

    // Transfer Modal
    'transfer.title': 'Virement rapide',
    'transfer.amount': 'Montant',
    'transfer.from': 'De',
    'transfer.to': 'Vers',
    'transfer.swap': 'Inverser',
    'transfer.quickAmounts': 'Montants rapides',
    'transfer.transferAll': 'Tout transférer',
    'transfer.description': 'Description',
    'transfer.descriptionPlaceholder': 'Note de virement (optionnel)',
    'transfer.summary': 'Résumé du virement',
    'transfer.fromAccount': 'De',
    'transfer.toAccount': 'Vers',
    'transfer.newBalance': 'Nouveau solde',
    'transfer.submit': 'Transférer',
    'transfer.submitting': 'Transfert en cours...',
    'transfer.success': 'Virement effectué',
    'transfer.error': 'Échec du virement',
    'transfer.insufficientFunds': 'Fonds insuffisants',
    'transfer.sameAccount': 'Impossible de transférer vers le même compte',
    'transfer.selectAccounts': 'Sélectionnez les deux comptes',
    'transfer.selectBothAccounts': 'Veuillez sélectionner les deux comptes',
    'transfer.sameAccountError': 'Impossible de transférer vers le même compte',
    'transfer.insufficientBalance': 'Solde insuffisant',
    'transfer.defaultDescription': 'Virement',
    'transfer.selectAccount': 'Sélectionner un compte',
    'transfer.available': 'Disponible',
    'transfer.all': 'Tout transférer',
    'common.optional': 'optionnel',
    'common.comingSoon': 'Bientôt dispo',

    // Transaction Modal additional
    'transactionModal.selectDestination': 'Veuillez sélectionner un compte de destination',
    'transactionModal.sameAccountError': 'Impossible de transférer entre le même compte',
    'transactionModal.transferDescription': 'Virement',
    'transactions.type.transfer': 'Virement',
    'transactionModal.selectAccountPlaceholder': 'Sélectionner un compte...',
    'transactionModal.availableBalance': 'Disponible',
    'transactionModal.selectDestinationPlaceholder': 'Sélectionner destination...',
    'transactionModal.newBalance': 'Nouveau solde',
    'transactionModal.transferDescriptionPlaceholder': 'Note de virement...',
    'transactionModal.update': 'Mettre à jour',
    'transactions.noDescription': 'Sans description',

    // AI Assistant
    'ai.title': 'Assistant IA',
    'ai.subtitle': "Posez-moi n'importe quelle question sur vos finances",
    'ai.welcome.title': 'Comment puis-je vous aider ?',
    'ai.welcome.description':
      'Posez-moi des questions sur vos dépenses, votre épargne, ou obtenez des conseils financiers personnalisés.',
    'ai.input.placeholder': 'Poser une question...',
    'ai.disclaimer': "L'IA peut faire des erreurs. Vérifiez les informations importantes.",
    'ai.prompts.spending': 'Analyser mes dépenses',
    'ai.prompts.savings': 'Comment économiser plus ?',
    'ai.prompts.subscriptions': 'Revoir mes abonnements',
    'ai.prompts.advice': 'Conseils financiers',
    'ai.prompts.spending_analysis.full': 'Peux-tu analyser mes habitudes de dépenses ce mois-ci ?',
    'ai.prompts.savings_tips.full':
      "Comment puis-je économiser plus d'argent selon mes transactions ?",
    'ai.prompts.subscriptions_review.full': 'Peux-tu revoir mes abonnements récurrents ?',
    'ai.prompts.financial_advice.full':
      'Quels conseils financiers me donnerais-tu selon mes données ?',
    'ai.placeholder.spending':
      "D'après vos transactions, je vois que vos principales catégories de dépenses ce mois sont... (Intégration IA à venir)",
    'ai.placeholder.savings':
      "En analysant vos habitudes financières, voici quelques moyens d'économiser... (Intégration IA à venir)",
    'ai.placeholder.budget':
      "Pour vous aider à créer un budget, j'analyserais vos revenus et dépenses... (Intégration IA à venir)",
    'ai.placeholder.subscriptions':
      'Je vais analyser vos transactions récurrentes pour identifier vos abonnements... (Intégration IA à venir)',
    'ai.placeholder.default':
      'Je suis votre assistant finances personnel. Je peux vous aider à analyser vos dépenses, suggérer des économies, suivre vos objectifs, et plus encore. (Intégration IA complète à venir)',
    'ai.error.generic': "Désolé, une erreur s'est produite. Veuillez réessayer.",
    'ai.error.notConfigured': "L'assistant IA n'est pas configuré. Veuillez ajouter votre clé API.",

    // Footer
    'footer.tagline':
      "L'application simple pour gérer ton budget aujourd'hui, et qui évolue demain, avec de nouveaux modules, pour centraliser toute ta vie",
    'footer.features.title': 'Fonctionnalités',
    'footer.features.budget': 'Gestion budgétaire',
    'footer.features.tracking': 'Suivi des transactions',
    'footer.features.wealth': 'Suivi du patrimoine',
    'footer.features.goals': 'Objectifs et plans',
    'footer.resources.title': 'Ressources',
    'footer.resources.guide': 'Débuter',
    'footer.resources.faq': 'FAQ',
    'footer.resources.blog': 'Blog',
    'footer.resources.help': "Centre d'aide",
    'footer.solutions.title': 'Solutions',
    'footer.solutions.personal': 'Usage personnel',
    'footer.solutions.professionals': 'Pour professionnels',
    'footer.solutions.families': 'Pour familles',
    'footer.company.title': 'Entreprise',
    'footer.company.about': 'À propos',
    'footer.company.careers': 'Carrières',
    'footer.company.press': 'Partenariats & Presse',
    'footer.company.partnerships': 'Partenariats',
    'footer.legal.title': 'Mentions légales',
    'footer.legal.terms': "Conditions d'utilisation",
    'footer.legal.privacy': 'Politique de confidentialité',
    'footer.legal.cookies': 'Cookies',
    'footer.legal.legal': 'Mentions légales',
    'footer.copyright': '© 2026 clevia. Tous droits réservés.',
    'press.title': 'Partenariats & Presse',
    'footer.terms': "Conditions d'utilisation",
    'footer.privacy': 'Politique de confidentialité',
    'footer.cookies': 'Cookies',
    'footer.legal': 'Mentions légales',

    // Page Tarifs
    'nav.pricing': 'Tarifs',
    'pricing.hero.title': 'Tarification simple et transparente',
    'pricing.hero.subtitle': 'Choisissez le plan qui vous convient le mieux',
    'pricing.free.name': 'Gratuit',
    'pricing.free.description': 'Parfait pour commencer votre parcours financier',
    'pricing.premium.name': 'Premium',
    'pricing.premium.description': 'Libérez tout votre potentiel financier',
    'pricing.mostPopular': 'Le plus populaire',
    'pricing.features.accounts': 'Gestion des comptes',
    'pricing.features.transactions': 'Suivi des transactions',
    'pricing.features.budgets': 'Budgets avancés',
    'pricing.features.multiCurrency': 'Multi-devise',
    'pricing.features.reports': 'Rapports avancés',
    'pricing.features.aiChat': 'Assistant IA',
    'pricing.features.goals': 'Objectifs financiers',
    'pricing.features.recurring': 'Transactions récurrentes',
    'pricing.highlights.fast': 'Rapide et fiable',
    'pricing.highlights.fastDesc': 'Synchronisation instantanée de vos données financières',
    'pricing.highlights.secure': 'Sécurisé',
    'pricing.highlights.secureDesc': 'Vos données sont cryptées et protégées',
    'pricing.highlights.analytics': 'Analyses approfondies',
    'pricing.highlights.analyticsDesc': 'Comprenez vos habitudes de dépenses',
    'pricing.highlights.ai': "Alimenté par l'IA",
    'pricing.highlights.aiDesc': "Conseils personnalisés basés sur l'IA",
    'pricing.whyChoose': 'Pourquoi choisir clevia ?',
    'pricing.whyChooseDesc': 'Nous offrons les meilleurs outils pour votre gestion financière',
    'pricing.faq': 'Questions fréquemment posées',
    'pricing.faqQ1': 'Puis-je changer de plan plus tard ?',
    'pricing.faqA1': 'Oui, vous pouvez passer à un niveau supérieur ou inférieur à tout moment.',
    'pricing.faqQ2': "Y a-t-il une période d'essai gratuite ?",
    'pricing.faqA2':
      'Oui, le plan gratuit offre un accès à toutes les fonctionnalités de base sans limite de temps.',
    'pricing.faqQ3': 'Comment est assurée ma sécurité ?',
    'pricing.faqA3':
      'Nous utilisons le chiffrement de bout en bout et les normes de sécurité les plus élevées du secteur.',
    'pricing.ctaTitle': 'Prêt à reprendre le contrôle ?',
    'pricing.ctaDesc': "Commencez gratuitement aujourd'hui, aucune carte bancaire requise.",
    'pricing.learnMore': 'En savoir plus',
    'nav.dashboard': 'Tableau de bord',
    'nav.upgrade': 'Passer à Premium',

    // Powens (agr\u00e9gation bancaire)
    'powens.connectBank': 'Connecter ma banque automatiquement',
    'powens.connectBankDesc': 'Connectez votre compte bancaire directement, sans saisie manuelle.',
    'powens.connecting': 'Redirection vers votre banque\u2026',
    'powens.syncing': 'Connexion et préparation de votre compte\u2026',
    'powens.syncingHint':
      'Cela peut prendre jusqu\u2019\u00e0 une minute lors d\u2019une premi\u00e8re connexion.',
    'powens.successTitle': 'Banque connect\u00e9e',
    'powens.accountReady': 'compte prêt',
    'powens.errorTitle': '\u00c9chec de la connexion',
    'powens.scaRequired':
      'Votre banque demande une authentification suppl\u00e9mentaire. Relancez la connexion.',
    'powens.cancelled': 'Connexion annul\u00e9e.',
    'powens.retry': 'R\u00e9essayer',
    'powens.backToAccounts': 'Retour \u00e0 mes comptes',

    'powens.pendingTitle': 'Ta banque r\u00e9pond encore',
    'powens.pendingDesc':
      'Powens r\u00e9cup\u00e8re encore tes donn\u00e9es. Elles arriveront toutes seules dans un instant \u2014 inutile de recommencer.',

    'powens.importing': 'Import en cours',
    'powens.importingDesc':
      'Ta banque transmet ses donn\u00e9es. Cela prend g\u00e9n\u00e9ralement moins d\u2019une minute.',
    'powens.actionRequired': 'Action requise',
    'powens.actionRequiredDesc': 'Ta banque attend que tu confirmes la connexion.',
    'powens.reconnect': 'Reconnecter',

    'powens.noHistoryNote':
      'Tes banques connect\u00e9es n\u2019importent que les transactions \u00e0 partir du',

    'transactions.pending': 'En attente',

    'powens.refreshBanks': 'Actualiser les banques',
    'powens.refreshStarted': 'Actualisation lanc\u00e9e',
    'powens.refreshStartedDesc':
      'Tes banques sont interrog\u00e9es. Les nouvelles op\u00e9rations appara\u00eetront seules d\u2019ici une minute.',

    'bankSync.disable': 'D\u00e9sactiver la synchronisation',
    'bankSync.settingsTitle': 'Synchronisation bancaire',
    'bankSync.settingsDesc': '{count} comptes sont mis \u00e0 jour tout seuls par ta banque.',
    'bankSync.settingsDescOne': '{count} compte est mis \u00e0 jour tout seul par ta banque.',
    'bankSync.title': 'La synchronisation bancaire va \u00eatre d\u00e9sactiv\u00e9e',
    'bankSync.desc':
      'Tes comptes, tes soldes et toutes tes transactions sont conserv\u00e9s. Seule la mise \u00e0 jour automatique depuis ta banque s\u2019arr\u00eate.',
    'bankSync.keptAccounts':
      '{count} comptes passent en mode manuel, avec leur nom et leur historique',
    'bankSync.keptAccountsOne':
      '{count} compte passe en mode manuel, avec son nom et son historique',
    'bankSync.keptTransactions': 'Aucune transaction n\u2019est supprim\u00e9e',
    'bankSync.keptBalance':
      'Le dernier solde synchronis\u00e9 devient le point de d\u00e9part que tu tiens toi-m\u00eame',
    'bankSync.keptReconnect': 'Tu pourras resynchroniser ces comptes plus tard, sans doublon',
    'bankSync.confirm': 'Passer mes comptes en mode manuel',
    'bankSync.cancel': 'Annuler',
    'bankSync.doneTitle': 'Tes comptes sont maintenant en mode manuel',
    'bankSync.doneDesc':
      'Rien n\u2019a \u00e9t\u00e9 supprim\u00e9. \u00c0 partir de maintenant, ajoute simplement tes nouvelles transactions toi-m\u00eame pour garder tes soldes \u00e0 jour.',
    'bankSync.doneClose': 'Compris',
    'bankSync.failed': 'La d\u00e9sactivation a \u00e9chou\u00e9. R\u00e9essaie dans un instant.',
    'accounts.synced': 'Synchronis\u00e9',
    'accounts.syncedHint': 'Le solde et les op\u00e9rations viennent de ta banque, tout seuls.',
    'accounts.manualSource': 'Compte manuel',
    'accounts.manualSourceHint': 'C\u2019est toi qui tiens ce compte \u00e0 jour.',
    'accountLink.menu': 'Synchroniser avec ma banque',
    'accountLink.introTitle': 'Synchroniser \u00ab\u00a0{name}\u00a0\u00bb avec ta banque',
    'accountLink.introDesc':
      'Tu vas connecter la banque o\u00f9 ce compte est ouvert, pour qu\u2019il se mette \u00e0 jour tout seul.',
    'accountLink.introStep1':
      'Tu t\u2019identifies chez ta banque, via notre partenaire agr\u00e9\u00e9.',
    'accountLink.introStep2':
      'Tu choisis le compte bancaire qui correspond \u00e0 \u00ab\u00a0{name}\u00a0\u00bb.',
    'accountLink.introStep3':
      'Ce compte garde son nom, son historique et ses objectifs. Aucun second compte n\u2019est cr\u00e9\u00e9.',
    'accountLink.chooseBank': 'Choisir ma banque',
    'accountLink.otherBank': 'Une autre banque',
    'accountLink.cancel': 'Annuler',
    'accountLink.alreadyConnected':
      'Ce compte bancaire est d\u00e9j\u00e0 connect\u00e9 \u00e0 clevia.',
    'accountLink.previousAccount': 'Le compte avec lequel il \u00e9tait synchronis\u00e9',
    'accountLink.blockedType': 'Ce n\u2019est pas le m\u00eame type de compte.',
    'accountLink.blockedCurrency': 'Compte tenu dans une autre devise.',
    'accountLink.syncingDesc':
      'Ses comptes appara\u00eetront ici tout seuls, en g\u00e9n\u00e9ral en moins d\u2019une minute.',
    'accountLink.noBankAccounts': 'Aucun compte re\u00e7u',
    'accountLink.noBankAccountsDesc':
      'Ta banque n\u2019a partag\u00e9 aucun compte exploitable. V\u00e9rifie ce que tu as partag\u00e9 pendant la connexion, ou essaie une autre banque.',
    'accountLink.chooseTitle': 'Quel compte bancaire est-ce\u00a0?',
    'accountLink.chooseDesc':
      'Voici les comptes que ta banque vient de transmettre. Choisis celui qui correspond \u00e0 \u00ab\u00a0{name}\u00a0\u00bb.',
    'accountLink.syncing': 'Ta banque envoie encore ses comptes\u2026',
    'accountLink.continue': 'Continuer',
    'accountLink.back': 'Retour',
    'accountLink.reviewTitle': 'V\u00e9rifie avant de relier',
    'accountLink.balance': 'Solde',
    'accountLink.balanceHint': 'Le solde de ta banque remplace celui saisi \u00e0 la main.',
    'accountLink.bankTransactions':
      '{count} op\u00e9rations bancaires rattach\u00e9es, depuis le {date}',
    'accountLink.bankTransactionsOne':
      '{count} op\u00e9ration bancaire rattach\u00e9e, depuis le {date}',
    'accountLink.merged': '{count} doublons fusionn\u00e9s, ta cat\u00e9gorie est conserv\u00e9e',
    'accountLink.mergedOne': '{count} doublon fusionn\u00e9, ta cat\u00e9gorie est conserv\u00e9e',
    'accountLink.recurring': '{count} r\u00e9currences mises en pause',
    'accountLink.recurringOne': '{count} r\u00e9currence mise en pause',
    'accountLink.historyKept': 'Ton historique avant le {date} reste tel quel',
    'accountLink.unmatchedTitle': '{count} op\u00e9rations introuvables \u00e0 la banque',
    'accountLink.unmatchedTitleOne': '{count} op\u00e9ration introuvable \u00e0 la banque',
    'accountLink.unmatchedDesc':
      'Saisies \u00e0 la main depuis le {date}, elles sont conserv\u00e9es. V\u00e9rifie-les\u00a0: une faute de montant ferait un doublon.',
    'accountLink.unmatchedDescOne':
      'Saisie \u00e0 la main depuis le {date}, elle est conserv\u00e9e. V\u00e9rifie-la\u00a0: une faute de montant ferait un doublon.',
    'accountLink.confirm': 'Relier le compte',
    'accountLink.successTitle': 'Compte reli\u00e9',
    'accountLink.successDesc':
      '\u00ab\u00a0{name}\u00a0\u00bb se met d\u00e9sormais \u00e0 jour depuis ta banque.',
    'accountLink.finish': 'Terminer la liaison',
    'accountLink.failed': 'La liaison a \u00e9chou\u00e9',
    'accountLink.error.link_account_not_found': 'Ce compte n\u2019existe plus.',
    'accountLink.error.link_not_manual':
      'Ce compte est d\u00e9j\u00e0 reli\u00e9 \u00e0 une banque.',
    'accountLink.error.link_not_aggregated': 'Ce compte bancaire ne peut plus \u00eatre choisi.',
    'accountLink.error.link_already_linked':
      'Ce compte bancaire est d\u00e9j\u00e0 connect\u00e9 \u00e0 clevia.',
    'accountLink.error.link_type_mismatch':
      'Un compte d\u2019actif ne peut pas \u00eatre reli\u00e9 \u00e0 une dette, et inversement.',
    'accountLink.error.link_currency_mismatch':
      'Les deux comptes ne sont pas dans la m\u00eame devise.',
    'accountLink.disconnect': 'D\u00e9connecter la banque',
    'accountLink.disconnectTitle': 'D\u00e9connecter ta banque\u00a0?',
    'accountLink.disconnectLinkedDesc':
      '\u00ab\u00a0{name}\u00a0\u00bb redevient un compte manuel. Tout son historique est conserv\u00e9, mais son solde ne se mettra plus \u00e0 jour tout seul.',
    'accountLink.disconnectDesc':
      '\u00ab\u00a0{name}\u00a0\u00bb et les op\u00e9rations import\u00e9es de ta banque seront supprim\u00e9s de Clevia.',
    'accountLink.disconnectConfirm': 'D\u00e9connecter',
    'accountLink.disconnected': 'Banque d\u00e9connect\u00e9e',
    'accountLink.disconnectFailed': 'La d\u00e9connexion a \u00e9chou\u00e9',

    // Common
    'common.currency': 'MAD',
  },
};

export type Language = 'en' | 'fr';
export type TranslationKey = keyof typeof translations.en;
